/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme', [
        'toastr',
        'BlurAdmin.theme.components'
    ]);

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('plainText', plainText);

    function plainText() {
        "ngInject";
        return function (text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('profilePicture', profilePicture);

    function profilePicture(layoutPaths) {
        "ngInject";
        return function (input, ext) {
            ext = ext || 'png';
            return layoutPaths.images.profile + input + '.' + ext;
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('kameleonImg', kameleonImg);

    function kameleonImg(layoutPaths) {
        "ngInject";
        return function (input) {
            return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('appImage', appImage);

    function appImage(layoutPaths) {
        "ngInject";
        return function (input) {
            return layoutPaths.images.root + input;
        };
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('widgets', widgets);

    function widgets() {
        "ngInject";
        return {
            restrict: 'EA',
            scope: {
                ngModel: '='
            },
            templateUrl: 'app/theme/components/widgets/widgets.html',
            replace: true
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('pageTop', pageTop);

    function pageTop() {
        "ngInject";
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controller: function ($scope, $uibModal) {
                $scope.openModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/commons/partials/profile.modal.html',
                        controller: function ($rootScope, $scope, $uibModalInstance, $http) {
                            $scope.user = $rootScope.user;

                            $scope.close = function () {
                                $uibModalInstance.dismiss();
                            };

                            $scope.save = function (user) {
                                $http.put('api/profile', user).then(function () {
                                    $uibModalInstance.close();
                                });
                            };
                        }
                    });
                };
            },

        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('contentTop', contentTop);

    function contentTop($location, $state) {
        "ngInject";
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/contentTop/contentTop.html',
            link: function ($scope) {
                $scope.$watch(function () {
                    $scope.activePageTitle = $state.current.title;
                });
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('backTop', backTop);

    function backTop() {
        "ngInject";
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/backTop/backTop.html',
            controller: function () {
                $('#backTop').backTop({
                    'position': 200,
                    'speed': 100
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('baWizardStep', baWizardStep);

    function baWizardStep() {
        "ngInject";
        return {
            restrict: 'E',
            transclude: true,
            require: '^baWizard',
            scope: {
                form: '='
            },
            templateUrl: 'app/theme/components/baWizard/baWizardStep.html',
            link: function ($scope, $element, $attrs, wizard) {
                $scope.selected = true;

                var tab = {
                    title: $attrs.title,
                    select: select,
                    submit: submit,
                    isComplete: isComplete,
                    isAvailiable: isAvailiable,
                    prevTab: undefined,
                    setPrev: setPrev
                };

                wizard.addTab(tab);

                function select(isSelected) {
                    if (isSelected) {
                        $scope.selected = true;
                    } else {
                        $scope.selected = false;
                    }
                }

                function submit() {
                    $scope.form && $scope.form.$setSubmitted(true);
                }

                function isComplete() {
                    return $scope.form ? $scope.form.$valid : true;
                }

                function isAvailiable() {
                    return tab.prevTab ? tab.prevTab.isComplete() : true;
                }

                function setPrev(pTab) {
                    tab.prevTab = pTab;
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('baWizardCtrl', baWizardCtrl);

    function baWizardCtrl($scope) {
        "ngInject";
        var vm = this;
        vm.tabs = [];

        vm.tabNum = 0;
        vm.progress = 0;

        vm.addTab = function (tab) {
            tab.setPrev(vm.tabs[vm.tabs.length - 1]);
            vm.tabs.push(tab);
            vm.selectTab(0);
        };

        $scope.$watch(angular.bind(vm, function () {
            return vm.tabNum;
        }), calcProgress);

        vm.selectTab = function (tabNum) {
            vm.tabs[vm.tabNum].submit();
            if (vm.tabs[tabNum].isAvailiable()) {
                vm.tabNum = tabNum;
                vm.tabs.forEach(function (t, tIndex) {
                    tIndex == vm.tabNum ? t.select(true) : t.select(false);
                });
            }
        };

        vm.isFirstTab = function () {
            return vm.tabNum == 0;
        };

        vm.isLastTab = function () {
            return vm.tabNum == vm.tabs.length - 1;
        };

        vm.nextTab = function () {
            vm.selectTab(vm.tabNum + 1)
        };

        vm.previousTab = function () {
            vm.selectTab(vm.tabNum - 1)
        };

        function calcProgress() {
            vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
        }
    }
})();


(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('baWizard', baWizard);

    function baWizard() {
        "ngInject";
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: 'app/theme/components/baWizard/baWizard.html',
            controllerAs: '$baWizardController',
            controller: 'baWizardCtrl'
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('baSidebarToggleMenu', baSidebarToggleMenu)
        .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
        .directive('baSidebarTogglingItem', baSidebarTogglingItem)
        .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
        .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
        .directive('baUiSrefToggler', baUiSrefToggler);

    function baSidebarToggleMenu(baSidebarService) {
        "ngInject";
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('click', function ($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    scope.$apply(function () {
                        baSidebarService.toggleMenuCollapsed();
                    });
                });
            }
        };
    }

    function baSidebarCollapseMenu(baSidebarService) {
        "ngInject";
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('click', function ($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    if (!baSidebarService.isMenuCollapsed()) {
                        scope.$apply(function () {
                            baSidebarService.setMenuCollapsed(true);
                        });
                    }
                });
            }
        };
    }

    function baSidebarTogglingItem() {
        "ngInject";
        return {
            restrict: 'A',
            controller: 'BaSidebarTogglingItemCtrl'
        };
    }

    function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
        "ngInject";
        var vm = this;
        var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
        if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
            vm.$$expandSubmenu = function () {
                console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu')
            };
            vm.$$collapseSubmenu = function () {
                console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu')
            };

            var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

            vm.$expand = function () {
                vm.$$expandSubmenu();
                $element.addClass('ba-sidebar-item-expanded');
            };

            vm.$collapse = function () {
                vm.$$collapseSubmenu();
                $element.removeClass('ba-sidebar-item-expanded');
            };

            vm.$toggle = function () {
                $element.hasClass('ba-sidebar-item-expanded') ?
                    vm.$collapse() :
                    vm.$expand();
            };

            if (_isState($state.current)) {
                $element.addClass('ba-sidebar-item-expanded');
            }

            $scope.$on('$stateChangeStart', function (event, toState) {
                if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
                    vm.$collapse();
                    $element.removeClass('ba-sidebar-item-expanded');
                }
            });

            $scope.$on('$stateChangeSuccess', function (event, toState) {
                if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
                    vm.$expand();
                    $element.addClass('ba-sidebar-item-expanded');
                }
            });
        }

        function _isState(state) {
            return state && subItemsStateRefs.some(function (subItemState) {
                    return state.name.indexOf(subItemState) == 0;
                });
        }
    }

    function baUiSrefTogglingSubmenu($state) {
        "ngInject";
        return {
            restrict: 'A',
            require: '^baSidebarTogglingItem',
            link: function (scope, el, attrs, baSidebarTogglingItem) {
                baSidebarTogglingItem.$$expandSubmenu = function () {
                    el.slideDown();
                };
                baSidebarTogglingItem.$$collapseSubmenu = function () {
                    el.slideUp();
                };
            }
        };
    }

    function baUiSrefToggler(baSidebarService) {
        "ngInject";
        return {
            restrict: 'A',
            require: '^baSidebarTogglingItem',
            link: function (scope, el, attrs, baSidebarTogglingItem) {
                el.on('click', function () {
                    if (baSidebarService.isMenuCollapsed()) {
                        // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
                        // This should not affect mobiles, because on mobiles sidebar should be hidden at all
                        scope.$apply(function () {
                            baSidebarService.setMenuCollapsed(false);
                        });
                        baSidebarTogglingItem.$expand();
                    } else {
                        baSidebarTogglingItem.$toggle();
                    }
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    function baSidebarServiceProvider() {
        "ngInject";
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        this.$get = function ($state, layoutSizes) {
            "ngInject";
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function (item) {
                        return item.level == 0;
                    });

                    menuItems.forEach(function (item) {
                        var children = states.filter(function (child) {
                            return child.level == 1 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function (s) {
                            return s.sidebarMeta;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('baSidebar', baSidebar);

    function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
        "ngInject";
        var jqWindow = $(window);
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
            controller: 'BaSidebarCtrl',
            link: function (scope, el) {

                scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
                jqWindow.on('click', _onWindowClick);
                jqWindow.on('resize', _onWindowResize);

                scope.$on('$destroy', function () {
                    jqWindow.off('click', _onWindowClick);
                    jqWindow.off('resize', _onWindowResize);
                });

                function _onWindowClick($evt) {
                    if (!baUtil.isDescendant(el[0], $evt.target) && !$evt.originalEvent.$sidebarEventProcessed && !baSidebarService.isMenuCollapsed() &&
                        baSidebarService.canSidebarBeHidden()) {
                        $evt.originalEvent.$sidebarEventProcessed = true;
                        $timeout(function () {
                            baSidebarService.setMenuCollapsed(true);
                        }, 10);
                    }
                }

                // watch window resize to change menu collapsed state if needed
                function _onWindowResize() {
                    var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
                    var newMenuHeight = _calculateMenuHeight();
                    if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
                        scope.$apply(function () {
                            scope.menuHeight = newMenuHeight;
                            baSidebarService.setMenuCollapsed(newMenuCollapsed)
                        });
                    }
                }

                function _calculateMenuHeight() {
                    return el[0].childNodes[0].clientHeight - 84;
                }
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    function BaSidebarCtrl($scope, baSidebarService, $cookies) {
        "ngInject";

        $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
        var user = $cookies.getObject('user');

        $scope.hoverItem = function ($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function () {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });

        $scope.authorizedModules = function (module) {
            return user[module.name];
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
    'use strict';

    /**
     * Represents current element as panel, adding all necessary classes.
     */
    angular.module('BlurAdmin.theme')
        .directive('baPanelSelf', baPanelSelf);

    function baPanelSelf(baPanel) {
        "ngInject";
        return angular.extend({}, baPanel, {
            link: function (scope, el, attrs) {
                el.addClass('panel panel-white');
                if (attrs.baPanelClass) {
                    el.addClass(attrs.baPanelClass);
                }
            }
        });
    }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('baPanelBlurHelper', baPanelBlurHelper);

    function baPanelBlurHelper($q) {
        "ngInject";
        var res = $q.defer();
        var computedStyle = getComputedStyle(document.body, ':before');
        var image = new Image();
        image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
        image.onerror = function () {
            res.reject();
        };
        image.onload = function () {
            res.resolve();
        };

        this.bodyBgLoad = function () {
            return res.promise;
        };

        this.getBodyBgImageSizes = function () {
            var elemW = document.documentElement.clientWidth;
            var elemH = document.documentElement.clientHeight;
            if (elemW <= 640) return;
            var imgRatio = (image.height / image.width);       // original img ratio
            var containerRatio = (elemH / elemW);     // container ratio

            var finalHeight, finalWidth;
            if (containerRatio > imgRatio) {
                finalHeight = elemH;
                finalWidth = (elemH / imgRatio);
            } else {
                finalWidth = elemW;
                finalHeight = (elemW * imgRatio);
            }
            return {
                width: finalWidth,
                height: finalHeight,
                positionX: (elemW - finalWidth) / 2,
                positionY: (elemH - finalHeight) / 2
            };
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('baPanelBlur', baPanelBlur);

    function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
        "ngInject";
        var bodyBgSize;

        baPanelBlurHelper.bodyBgLoad().then(function () {
            bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
        });

        $window.addEventListener('resize', function () {
            bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
        });

        return {
            restrict: 'A',
            link: function ($scope, elem) {
                if (!$rootScope.$isMobile) {
                    baPanelBlurHelper.bodyBgLoad().then(function () {
                        setTimeout(recalculatePanelStyle);
                    });
                    $window.addEventListener('resize', recalculatePanelStyle);

                    $scope.$on('$destroy', function () {
                        $window.removeEventListener('resize', recalculatePanelStyle);
                    });
                }

                function recalculatePanelStyle() {
                    if (!bodyBgSize) {
                        return;
                    }
                    elem.css({
                        backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
                        backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
                    });
                }

            }
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baPanel', baPanel);

    function baPanel() {
        "ngInject";
        /** Base baPanel directive */
        return {
            restrict: 'A',
            transclude: true,
            template: function (elem, attrs) {
                var res = '<div class="panel-body" ng-transclude></div>';
                if (attrs.baPanelTitle) {
                    var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
                    res = titleTpl + res; // title should be before
                }

                return res;
            }
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
    'use strict';

    /**
     * Includes basic panel layout inside of current element.
     */
    angular.module('BlurAdmin.theme')
        .directive('baPanel', baPanel);

    function baPanel(baPanel, baConfig) {
        "ngInject";
        return angular.extend({}, baPanel, {
            template: function (el, attrs) {
                var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
                res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
                res += baPanel.template(el, attrs);
                res += '</div>';
                return res;
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.stats.landings', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('stats.landings', {
                url: '/landings',
                templateUrl: 'app/pages/stats/landings/landings.html',
                title: 'Start & Landningar',
                sidebarMeta: {
                    order: 20
                },
                controller: 'LandingsCtrl',
                resolve: {
                    data: ['Landings',
                        function (Landings) {
                            return Landings.query({year: (new Date()).getFullYear()});
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.stats.landings')
    .factory('Landings', ['$resource', function ($resource) {
        return $resource('api/stats/landings/:year', {year: '@year'}, {
                query: {
                    method: 'GET',
                    isArray: false
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.stats.landings')
    .controller('LandingsCtrl',
        ['$scope', '$uibModal', '$location', '$timeout', 'data', 'Landings',
            function ($scope, $uibModal, $location, $timeout, data, Landings) {
                $scope.data = data;
                $scope.year = {year: (new Date()).getFullYear()};

                $scope.activeTab = {
                    act: 0
                };

                $scope.months = [
                    'Januari',
                    'Februari',
                    'Mars',
                    'April',
                    'Maj',
                    'Juni',
                    'Juli',
                    'Augusti',
                    'September',
                    'Oktober',
                    'November',
                    'December'
                ];

                $scope.getLandings = function (year) {
                    var act = $scope.activeTab.act;
                    $scope.data = Landings.query(year);
                    $scope.data.$promise.then(function(){
                        $timeout(function(){
                            $scope.activeTab.act = act;
                        })
                    });
                };

                $scope.calculateTotal = function (data) {
                    var sum = 0;
                    for (var i = 1; i <= 12; i++){
                        sum += data[i].takeoff_day;
                        sum += data[i].takeoff_evening;
                        sum += data[i].takeoff_night;
                        sum += data[i].landing_day;
                        sum += data[i].landing_evening;
                        sum += data[i].landing_night;
                        sum += data[i].tgl_day*2;
                        sum += data[i].tgl_evening*2;
                        sum += data[i].tgl_night*2;
                    }

                    return sum;
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.stats.flighthours', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('stats.flighthours', {
                url: '/flighthours',
                templateUrl: 'app/pages/stats/flighthours/flighthours.html',
                title: 'Flygtimmar',
                sidebarMeta: {
                    order: 30
                },
                controller: 'FlightHoursCtrl',
                resolve: {
                    data: ['FlightHours',
                        function (FlightHours) {
                            return FlightHours.query({year: (new Date()).getFullYear()}).$promise;
                        }]
                }
            });
    }
})();

angular.module('BlurAdmin.pages.stats.flighthours')
    .factory('FlightHours', ['$resource', function ($resource) {
        return $resource('api/stats/flightHours/:year', {year: '@year'}, {
                query: {
                    method: 'GET',
                    isArray: false
                }
            }
        );
    }
    ]);

angular.module('BlurAdmin.pages.stats.flighthours')
    .controller('FlightHoursCtrl',
        ['$scope', 'data', 'FlightHours',
            function ($scope, data, FlightHours) {
                $scope.categories = data.categories;
                $scope.data = data.data;
                $scope.year = {year: (new Date()).getFullYear()};

                $scope.getFlightHours = function (year) {
                    FlightHours.query(year).$promise.then(function (result) {
                        $scope.categories = result.categories;
                        $scope.data = result.data;
                    });
                };

                $scope.calculateRowTotal = function (row, field) {
                    var sum = 0;
                    angular.forEach(row, function (value) {
                        sum += value[field] || 0;
                    });
                    return sum;
                };

                $scope.calculateColumnTotal = function (category, field) {
                    var sum = 0;
                    angular.forEach($scope.data, function (row) {
                        sum += (row[category] && row[category][field]) || 0;
                    });
                    return sum;
                };

                $scope.calculateGrandTotal = function (field) {
                    var sum = 0;
                    angular.forEach($scope.data, function (row) {
                        angular.forEach(row, function (value) {
                            sum += value[field] || 0;
                        });
                    });
                    return sum;
                };
            }]);

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.stats.flightcodestats', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('stats.flightcodestats', {
                url: '/flightcodestats',
                templateUrl: 'app/pages/stats/flightcodestats/flightcodestats.html',
                title: 'Flygstatistik',
                sidebarMeta: {
                    order: 10
                },
                controller: 'FlightCodeStatsCtrl'
            });
    }
})();

angular.module('BlurAdmin.pages.stats.flightcodestats')
    .factory('FlightCodeStats', ['$resource', function ($resource) {
        return $resource('api/stats/flightCodeStats/:year', {year: '@year'}, {
                query: {
                    method: 'GET',
                    isArray: false
                }
            }
        );
    }
    ]);

angular.module('BlurAdmin.pages.stats.flightcodestats')
    .controller('FlightCodeStatsCtrl',
        ['$scope', '$http', '$timeout',
            function ($scope, $http, $timeout) {
                var months = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];

                $scope.year = {year: (new Date()).getFullYear()};
                $scope.months = months;
                $scope.data = null;

                function loadData(year) {
                    $scope.data = null;
                    $http.get('api/stats/flightCodeStats/' + year, {params: {_t: Date.now()}}).then(function (response) {
                        var result = response.data;
                        var hidden = ['TJ'];
                        result.rows = result.rows.filter(function (r) { return hidden.indexOf(r.kod) === -1; });
                        result.pieFlygkod = result.pieFlygkod.filter(function (p) { return hidden.indexOf(p.name) === -1; });
                        var visibleIdx = result.barChart.categories.reduce(function (acc, k, i) {
                            if (hidden.indexOf(k) === -1) { acc.push(i); }
                            return acc;
                        }, []);
                        result.barChart.categories = visibleIdx.map(function (i) { return result.barChart.categories[i]; });
                        result.barChart.actual     = visibleIdx.map(function (i) { return result.barChart.actual[i]; });
                        result.barChart.budget     = visibleIdx.map(function (i) { return result.barChart.budget[i]; });
                        result.barChart.prevYear   = visibleIdx.map(function (i) { return result.barChart.prevYear[i]; });
                        $scope.data = result;
                        $scope.pieFlygkodConfig = buildPieConfig('Fördelning per flygkod', result.pieFlygkod);
                        $scope.pieAircraftConfig = buildPieConfig('Fördelning per flygplan', result.pieAircraft);
                        $scope.barChartConfig = buildBarConfig(result);
                        $scope.lineChartConfig = buildLineConfig(result);

                        // Highcharts' SVGs have no viewBox, so CSS can't rescale them for
                        // print (Chrome lays out the print page at the physical paper
                        // width, in a pass scripts can't react to, which otherwise just
                        // clips the on-screen-sized SVG instead of scaling it). Stamping a
                        // viewBox once here makes the print CSS rule in common.scss able to
                        // scale each chart to fit, since viewBox scaling happens as part of
                        // rendering rather than requiring script execution during print.
                        $timeout(function () {
                            forEachChart(stampViewBox);
                        });
                    });
                }

                function forEachChart(fn) {
                    [$scope.lineChartConfig, $scope.barChartConfig, $scope.pieFlygkodConfig, $scope.pieAircraftConfig].forEach(function (cfg) {
                        var chart = cfg && cfg.getHighcharts && cfg.getHighcharts();
                        if (chart) { fn(chart); }
                    });
                }

                function stampViewBox(chart) {
                    var svg = chart.container && chart.container.getElementsByTagName('svg')[0];
                    if (svg) {
                        svg.setAttribute('viewBox', '0 0 ' + chart.chartWidth + ' ' + chart.chartHeight);
                        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
                    }
                }

                $scope.getStats = function (year) {
                    loadData(year.year);
                };

                $scope.print = function () {
                    window.print();
                };

                // Fixed chart height (applies on screen too): the print layout scales
                // each chart's width down to fit its column via the viewBox above, and
                // relies on this height being set explicitly up front rather than
                // auto-detected, since resizing a live chart specifically for print
                // turned out to be unreliable (Highcharts/highcharts-ng aren't built
                // for reconfiguring an existing chart right before printing).
                var CHART_HEIGHT = 525;

                loadData($scope.year.year);

                function buildPieConfig(title, pieData) {
                    return {
                        options: {
                            chart: {
                                type: 'pie',
                                height: CHART_HEIGHT
                            },
                            tooltip: {
                                pointFormat: '<b>{point.y:.1f} h</b> ({point.percentage:.1f}%)'
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: true,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: true,
                                        format: '{point.name}: {point.percentage:.0f}%'
                                    }
                                }
                            }
                        },
                        series: [{
                            name: 'Timmar',
                            data: pieData || []
                        }],
                        title: {
                            text: title
                        }
                    };
                }

                function buildBarConfig(result) {
                    return {
                        options: {
                            chart: {
                                type: 'column',
                                height: CHART_HEIGHT
                            },
                            tooltip: {
                                shared: true,
                                valueSuffix: ' h'
                            },
                            plotOptions: {
                                column: {
                                    grouping: true
                                }
                            }
                        },
                        series: [
                            {name: 'Utfall', data: result.barChart.actual},
                            {name: 'Budget', data: result.barChart.budget},
                            {name: '' + result.prevYear, data: result.barChart.prevYear}
                        ],
                        xAxis: {
                            categories: result.barChart.categories
                        },
                        yAxis: {
                            title: {text: 'Timmar'}
                        },
                        title: {
                            text: 'Utfall vs Budget vs ' + result.prevYear
                        }
                    };
                }

                function buildLineConfig(result) {
                    // Trim actual data to only months with data
                    var actualData = [];
                    for (var i = 0; i <= result.lastMonthWithData; i++) {
                        actualData.push(result.lineChart.actual[i]);
                    }

                    return {
                        options: {
                            chart: {
                                type: 'line',
                                height: CHART_HEIGHT
                            },
                            tooltip: {
                                shared: true,
                                valueSuffix: ' h'
                            }
                        },
                        series: [
                            {name: 'Utfall', data: actualData, color: '#ff0000'},
                            {name: 'Budget', data: result.lineChart.budget, color: '#0070c0', dashStyle: 'Dash'},
                            {name: 'Ack. ' + result.prevYear, data: result.lineChart.prevYear, color: '#70ad47', dashStyle: 'Dot'}
                        ],
                        xAxis: {
                            categories: months
                        },
                        yAxis: {
                            title: {text: 'Timmar'}
                        },
                        title: {
                            text: 'Total ackumulerad flygtid ' + $scope.year.year
                        }
                    };
                }
            }]);

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.salaries.tariffs', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('salaries.tariffs', {
                url: '/tariffs',
                templateUrl: 'app/pages/salaries/tariffs/tariffs.html',
                title: 'Lönearter',
                sidebarMeta: {
                    order: 20,
                },
                controller: 'TariffsCtrl',
                resolve: {
                    tariffs: function (Tariffs) {
                        return Tariffs.query();
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.salaries.tariffs')
    .factory('Tariffs', ['$resource', function ($resource) {
        return $resource('api/salaries/tariffs/:id', {id: '@id'}, {
            query: {
                params: {
                    withTrashed: true
                },
                isArray: true
            },
            update: {
                method: 'PUT'
            },
            restore: {
                method: 'PUT',
                url: 'api/salaries/tariffs/:id/restore'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.salaries.tariffs')
    .controller('TariffsCtrl',
        function ($scope, $uibModal, tariffs, Tariffs) {
            $scope.tariffs = tariffs;
            $scope.filter = {showDel: false};

            $scope.openModal = function (tariff) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/pages/salaries/tariffs/tariff.modal.html',
                    controller: 'TariffModalCtrl',
                    resolve: {
                        tariff: function () {
                            if (tariff === undefined) {
                                return {};
                            }
                            return angular.copy(tariff);
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.tariffs = Tariffs.query();
                });

            };

            $scope.openInfoModal = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/salaries/tariffs/info.modal.html'
                });
            };

            $scope.delete = function (tariff) {
                tariff.$delete().then(function () {
                    $scope.tariffs = Tariffs.query();
                });
            };

            $scope.restore = function (tariff) {
                tariff.$restore().then(function () {
                    $scope.tariffs = Tariffs.query();
                });
            };
        }).controller('TariffModalCtrl',
    function ($scope, $uibModalInstance, tariff, Tariffs) {
        $scope.isNew = tariff.id === undefined;
        $scope.tariff = tariff;

        $scope.types = [
            {
                id : 0,
                name : "kr/h"
            },
            {
                id : 1,
                name : "kr/st"
            }
        ];

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.save = function (tariff) {
            if (tariff.id === undefined) {
                Tariffs.save(tariff, function () {
                    $uibModalInstance.close();
                });
            } else {
                tariff.$update().then(function () {
                    $uibModalInstance.close();
                });
            }
        };

    });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.salaries.instructors', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('salaries.instructors', {
                url: '/instructors',
                templateUrl: 'app/pages/salaries/instructors/instructors.html',
                title: 'Instruktörer',
                sidebarMeta: {
                    order: 20,
                },
                controller: 'InstructorsCtrl',
                resolve: {
                    instructors: ['Instructors',
                        function (Instructors) {
                            return Instructors.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.salaries.instructors')
    .factory('Instructors', ['$resource', function ($resource) {
        return $resource('api/salaries/instructors/:id', {id: '@id'}, {
            query: {
                params: {
                    withTrashed: true
                },
                isArray: true,
                transformResponse: function (data) {
                    var instructors = angular.fromJson(data);
                    instructors.forEach(function (instructor) {
                        instructor.born = new Date(instructor.born);
                    });

                    return instructors;
                }
            },
            update: {
                method: 'PUT'
            },
            restore: {
                method: 'PUT',
                url: 'api/salaries/instructors/:id/restore'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.salaries.instructors')
    .controller('InstructorsCtrl',
        function ($scope, $uibModal, instructors, Instructors) {
            $scope.instructors = instructors;
            $scope.filter = {showDel: false};

            $scope.openModal = function (instructor) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/pages/salaries/instructors/instructor.modal.html',
                    controller: 'InstructorModalCtrl',
                    resolve: {
                        instructor: function () {
                            if (instructor === undefined) {
                                return {};
                            }
                            return angular.copy(instructor);
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.instructors = Instructors.query();
                });

            };

            $scope.delete = function (instructor) {
                instructor.$delete().then(function () {
                    $scope.instructors = Instructors.query();
                });
            };

            $scope.restore = function (instructor) {
                instructor.$restore().then(function () {
                    $scope.instructors = Instructors.query();
                });
            };

            $scope.showDel = function (instructor) {
                if ($scope.filter.showDeleted) return true;
                return instructor.deleted_at === null;
            };

        }).controller('InstructorModalCtrl',
    function ($scope, $uibModalInstance, instructor, Instructors) {
        $scope.isNew = instructor.id === undefined;
        $scope.instructor = instructor;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.save = function (instructor) {
            if (instructor.id === undefined) {
                Instructors.save(instructor, function () {
                    $uibModalInstance.close();
                });
            } else {
                instructor.$update().then(function () {
                    $uibModalInstance.close();
                });
            }
        };

    });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.salaries.flightTypes', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('salaries.flightTypes', {
                url: '/flightTypes',
                templateUrl: 'app/pages/salaries/flightTypes/flightTypes.html',
                title: 'Typer av flygningar',
                sidebarMeta: {
                    order: 10,
                },
                controller: 'FlightTypesCtrl',
                resolve: {
                    flightTypes: function (FlightTypes) {
                        return FlightTypes.query();
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.salaries.flightTypes')
    .factory('FlightTypes', ['$resource', function ($resource) {
        return $resource('api/salaries/flightTypes/:id', {id: '@id'}, {
            query: {
                isArray: true
            },
            update: {
                method: 'PUT'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.salaries.flightTypes')
    .controller('FlightTypesCtrl',
        function ($scope, $uibModal, flightTypes, FlightTypes) {
            $scope.flightTypes = flightTypes;

            $scope.openModal = function (type) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/pages/salaries/flightTypes/flightType.modal.html',
                    controller: 'FlightTypeModalCtrl',
                    resolve: {
                        type: function () {
                            if (type === undefined) {
                                return {};
                            }
                            return angular.copy(type);
                        },
                        tariffs: function (Tariffs) {
                            return Tariffs.query();
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.flightTypes = FlightTypes.query();
                });

            };

            $scope.delete = function (type) {
                type.$delete().then(function () {
                    $scope.flightTypes = FlightTypes.query();
                });
            };

        }).controller('FlightTypeModalCtrl',
    function ($scope, $uibModalInstance, type, FlightTypes, tariffs) {
        $scope.isNew = type.id === undefined;
        $scope.type = type;
        $scope.tariffs = tariffs;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.save = function (type) {
            if (type.id === undefined) {
                FlightTypes.save(type, function () {
                    $uibModalInstance.close();
                });
            } else {
                type.$update().then(function () {
                    $uibModalInstance.close();
                });
            }
        };

    });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.salaries.breakdown', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('salaries.breakdown', {
                url: '/breakdown',
                templateUrl: 'app/pages/salaries/breakdown/breakdown.html',
                title: 'Löneunderlag',
                sidebarMeta: {
                    order: 30,
                },
                controller: 'BreakdownCtrl',
                resolve: {
                    breakdown: function ($http) {
                        var d = new Date();
                        d.setMonth(d.getMonth() - 1);
                        return $http.get('api/salaries/breakdown?month=' + d.toISOString());
                    }
                }
            });
    }
})
();
angular.module('BlurAdmin.pages.salaries.breakdown')
    .controller('BreakdownCtrl',
        function ($scope, breakdown, $http, toastr, $filter) {
            $scope.breakdown = breakdown.data;
            var d = new Date();
            d.setMonth(d.getMonth() - 1);
            $scope.month = d;
            $scope.activeInstructor = 'Sammanställning';
            
            $scope.setActive = function(active){
                $scope.activeInstructor = active;
            };

            $scope.getSalaries = function(month){
                $http.get('api/salaries/breakdown?month=' + month.toISOString()).then(function(response){
                    $scope.breakdown = response.data;
                }, function(){});
            };

            $scope.sendMails = function(month){
                $http.post('api/salaries/sendMails', {month: month.toISOString()}).then(function(){
                    toastr.success('Löneunderlag skickade utan problem.');
                }, function(){});
            };
            
            $scope.getTariff = function(sends_invoices, has_retired, tariff){
                return sends_invoices ? tariff.tariff : has_retired ? tariff.tariff_invoice : tariff.tariff_invoice_retired;
            };

            $scope.getTotals = function(tariffs) {
                var hours = 0;
                var noSingle = 0;

                tariffs.forEach(function(tariff) {
                    if (tariff.is_single) {
                        noSingle += tariff.number;
                    } else {
                        hours += tariff.number;
                    }
                });

                return $filter('number')(hours, 1) + ' h / ' + noSingle + ' st';
            };

            $scope.getExtraTariffAPrice = function(flight) {
                  if (flight.extraTariff === undefined) {
                      return '-';
                  } else {
                      return $filter('number')(flight.extraTariff.tariff, 2) + ' kr/st';
                  }
            };

            $scope.objToArray = function(object){
                var array = [];
                for (var key in object) {
                    // skip loop if the property is from prototype
                    if (!object.hasOwnProperty(key)) continue;

                    array.push(object[key]);
                }
                return array;
            }
            
        }
    );
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.saab.invoice', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('saab.invoice', {
                url: '/invoice',
                title: 'Fakturering',
                templateUrl: 'app/pages/saab/invoice/invoice.html',
                sidebarMeta: {
                    icon: 'fa fa-usd',
                    order: 10,
                },
                controller: 'InvoiceCtrl',
                resolve: {
                    dates: function () {
                        var date = new Date();
                        date.setHours(12);
                        date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                        var d2 = new Date(date);
                        d2.setDate(1);
                        return {
                            'startDate': d2,
                            'endDate': date
                        };
                    }
                }
            });
    }

})();

angular.module('BlurAdmin.pages.saab.invoice')
    .factory('Invoice', ['$resource', function ($resource) {
            return $resource('api/saab/invoice', null, {
                query: {
                    method: 'GET',
                    isArray: false
                }
            });
        }]
    );
angular.module('BlurAdmin.pages.saab.invoice')
    .controller('InvoiceCtrl',
        ['$scope', '$filter', 'dates', 'Invoice',
            function ($scope, $filter, dates, Invoice) {
                Invoice.query(dates, function (data) {
                    $scope.flights = data.rows;
                    $scope.balances = data.balances;
                });
                $scope.dates = dates;
                $scope.orders = {};

                $scope.getInvoice = function (dates) {
                    Invoice.query(dates, function (response) {
                        $scope.flights = response.rows;
                        $scope.balances = response.balances;
                    });
                };

                $scope.addToOrder = function (flight) {
                    flight.in_order = true;
                    $scope.balances[flight.pilot_nr] -= flight.amount;
                };

                $scope.removeFromOrder = function (flight) {
                    flight.in_order = false;
                    $scope.balances[flight.pilot_nr] += flight.amount;
                };

                $scope.filterFlights = function (flights, to_order) {
                    return $filter('filter')(flights, {in_order: to_order});
                };

                $scope.groupInvoice = function (flights) {
                    return $filter('groupBy')(flights, 'name');
                };
            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.saab.accounts', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('saab.accounts', {
                url: '/accounts',
                templateUrl: 'app/pages/saab/accounts/accounts.html',
                title: 'Konton',
                sidebarMeta: {
                    order: 20,
                },
                controller: 'AccountsCtrl',
                resolve: {
                    accounts: ['Accounts', function (Accounts) {
                        return Accounts.query();
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.saab.accounts')
    .factory('Accounts', ['$resource', function ($resource) {
        return $resource('api/saab/accounts/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            },
            keyed: {
                method: 'GET',
                url: 'api/saab/accounts/keyed'
            }
        });
    }]);
angular.module('BlurAdmin.pages.saab.accounts')
    .controller('AccountsCtrl',
        ['$scope', '$uibModal', 'accounts', 'Accounts',
            function ($scope, $uibModal, accounts, Accounts) {
                $scope.accounts = accounts;

                $scope.openModal = function (account) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/saab/accounts/account.modal.html',
                        controller: 'AccountModalCtrl',
                        resolve: {
                            account: function () {
                                if (account === undefined) {
                                    return {};
                                }
                                return angular.copy(account);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.accounts = Accounts.query();
                    });

                };

                $scope.delete = function (account) {
                    account.$delete().then(function () {
                        $scope.accounts = Accounts.query();
                    });
                };

                $scope.showPayments = function (payments) {
                    var modal = $uibModal.open({
                        templateUrl: 'app/pages/saab/accounts/payments.modal.html',
                        controller: 'AccountPaymentsModalCtrl',
                        resolve: {
                            payments: function () {
                                return payments;
                            }
                        }
                    });

                    modal.result.then(function(){
                        $scope.accounts = Accounts.query();
                    });
                };

            }])
    .controller('AccountModalCtrl',
        ['$scope', '$uibModalInstance', 'account', 'Accounts',
            function ($scope, $uibModalInstance, account, Accounts) {
                $scope.isNew = account.id === undefined;
                $scope.account = account;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (account) {
                    if (account.id === undefined) {
                        Accounts.save(account, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        account.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }])
    .controller('AccountPaymentsModalCtrl',
        ['$scope', '$uibModalInstance', 'payments', '$http', function ($scope, $uibModalInstance, payments, $http) {
            $scope.payments = payments;

            $scope.delete = function(payment){
                $http.delete('api/saab/payments/' + payment.id).then(function(){
                    $uibModalInstance.close();
                });
            };

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };
        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.kiosk.purchases', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('kiosk.purchases', {
                url: '/purchases',
                templateUrl: 'app/pages/kiosk/purchases/purchases.html',
                title: 'Köp',
                sidebarMeta: {
                    order: 20
                },
                controller: 'PurchasesCtrl',
                resolve: {
                    purchases: ['Purchases', '$filter',
                        function (Purchases, $filter) {
                            var date = new Date();
                            return Purchases.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var d = new Date();
                        d.setDate(1);
                        return {
                            'startDate': d,
                            'endDate': new Date()
                        };
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.kiosk.purchases')
    .factory('Purchases', ['$resource', function ($resource) {
        return $resource('api/kiosk/records/:id', {id: '@id'});
    }
    ]);
angular.module('BlurAdmin.pages.kiosk.purchases')
    .controller('PurchasesCtrl',
        ['$scope', '$uibModal', '$location', 'purchases', 'dates', 'Purchases',
            function ($scope, $uibModal, $location, purchases, dates, Purchases) {
                $scope.purchases = purchases;
                $scope.dates = dates;

                $scope.getKiosklist = function (dates) {
                    $scope.purchases = Purchases.query(dates);
                };

                $scope.delete = function (purchase) {
                    purchase.$delete().then(function () {
                        $scope.purchases = Purchases.query(dates);
                    });
                };

                $scope.showDetails = function (purchase) {
                    $uibModal.open({
                        templateUrl: 'app/pages/kiosk/purchases/purchase.modal.html',
                        controller: 'PurchaseModalCtrl',
                        resolve: {
                            purchase: function () {
                                return purchase;
                            }
                        }
                    });
                };

                $scope.openInfoModal = function(purchases){
                    $uibModal.open({
                        templateUrl: 'app/pages/kiosk/purchases/info.modal.html',
                        resolve: {
                            purchases: function(){
                                return purchases;
                            }
                        }
                    });
                };

                $scope.openHelpModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/kiosk/purchases/info.modal.html'
                    })
                };

            }]).controller('PurchaseModalCtrl',
    ['$scope', '$uibModalInstance', 'purchase',
        function ($scope, $uibModalInstance, purchase) {
            $scope.purchase = purchase;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };
        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.kiosk.products', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('kiosk.products', {
                url: '/products',
                templateUrl: 'app/pages/kiosk/products/products.html',
                title: 'Produkter',
                sidebarMeta: {
                    order: 10,
                },
                controller: 'ProductsCtrl',
                resolve: {
                    products: ['Products', function (Products) {
                        return Products.query();
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.kiosk.products')
    .factory('Products', ['$resource', function ($resource) {
        return $resource('api/kiosk/products/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.kiosk.products')
    .controller('ProductsCtrl',
        ['$scope', '$uibModal', 'products', 'Products',
            function ($scope, $uibModal, products, Products) {
                $scope.products = products;

                $scope.openModal = function (product) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/kiosk/products/product.modal.html',
                        controller: 'ProductModalCtrl',
                        resolve: {
                            product: function () {
                                if (product === undefined) {
                                    return {
                                        name: '',
                                        price: '',
                                        stock: ''
                                    };
                                }
                                return angular.copy(product);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.products = Products.query();
                    });

                };

                $scope.delete = function (product) {
                    product.$delete().then(function () {
                        $scope.products = Products.query();
                    });
                };

            }])
    .controller('ProductModalCtrl',
        ['$scope', '$uibModalInstance', 'product', 'Products',
            function ($scope, $uibModalInstance, product, Products) {
                $scope.isNew = product.id === undefined;
                $scope.product = product;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (product) {
                    if (product.id === undefined) {
                        Products.save(product, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        product.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.jour.workgroups', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('jour.workgroups', {
                url: '/workgroups',
                templateUrl: 'app/pages/jour/workgroups/workgroups.html',
                title: 'Arbetsgrupper',
                sidebarMeta: {
                    order: 20,
                },
                controller: 'WorkGroupsCtrl',
                resolve: {
                    workGroups: function (WorkGroups) {
                        return WorkGroups.query({year: (new Date()).getFullYear()});
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.jour.workgroups')
    .factory('WorkGroups', ['$resource', function ($resource) {
        return $resource('api/jour/workgroups/:id', {id: '@id'}, {
            query: {
                isArray: true
            },
            update: {
                method: 'PUT'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.jour.workgroups')
    .controller('WorkGroupsCtrl',
        function ($scope, $http, $uibModal, workGroups, WorkGroups) {
            $scope.workGroups = workGroups;
            $scope.year = {year: (new Date()).getFullYear()};

            $scope.getGroups = function(year){
                $scope.workGroups = WorkGroups.query(year);
            };

            $scope.transferFromPrev = function(year){
                $http.post('api/jour/workgroups/transferFromPreviousYear', year).then(function(){
                    $scope.workGroups = WorkGroups.query(year);
                });
            };

            $scope.openModal = function (group) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/pages/jour/workgroups/workgroup.modal.html',
                    controller: 'WorkGroupModalCtrl',
                    resolve: {
                        workGroup: function () {
                            if (group === undefined) {
                                return {
                                    year: $scope.year.year
                                };
                            }
                            return angular.copy(group);
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.workGroups = WorkGroups.query($scope.year);
                });

            };

            $scope.delete = function (group) {
                group.$delete().then(function () {
                    $scope.workGroups = WorkGroups.query($scope.year);
                });
            };

        }).controller('WorkGroupModalCtrl',
    function ($scope, $uibModalInstance, workGroup, WorkGroups) {
        $scope.isNew = workGroup.id === undefined;
        $scope.group = workGroup;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.save = function (group) {
            if (group.id === undefined) {
                WorkGroups.save(group, function () {
                    $uibModalInstance.close();
                });
            } else {
                group.$update().then(function () {
                    $uibModalInstance.close();
                });
            }
        };

    });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.jour.signs', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('jour.signs', {
                url: '/signs',
                templateUrl: 'app/pages/jour/signs/signs.html',
                title: 'Signeringar',
                sidebarMeta: {
                    order: 10,
                },
                controller: 'SignsCtrl',
                resolve: {
                    signs: ['Signs', '$filter',
                        function (Signs, $filter) {
                            var date = new Date();
                            return Signs.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setDate(1);
                        return {
                            'startDate': date,
                            'endDate': new Date()
                        };
                    }
                }
            });
    }
})();

angular.module('BlurAdmin.pages.jour.signs')
    .factory('Signs', ['$resource', function ($resource) {
        return $resource('api/jour/signs/:id', {id: '@id'}, {
            query: {
                method: 'GET',
                isArray: true,
                transformResponse: function (response) {
                    var data = angular.fromJson(response);
                    data.forEach(function (sign) {
                        sign.date = new Date(sign.date);
                    });
                    return data;
                }
            },
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.jour.signs')
    .controller('SignsCtrl',
        ['$scope', '$uibModal', 'dates', 'Signs', 'signs',
            function ($scope, $uibModal, dates, Signs, signs) {
                $scope.dates = dates;
                $scope.signs = signs;

                $scope.getSigns = function (dates) {
                    $scope.signs = Signs.query(dates);
                };

                $scope.delete = function (sign) {
                    sign.$delete().then(function () {
                        $scope.signs = Signs.query(dates);
                    });
                };

                $scope.openModal = function (sign) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/jour/signs/sign.modal.html',
                        controller: 'SignModalCtrl',
                        resolve: {
                            sign: function () {
                                if (sign === undefined) {
                                    return {
                                        date: new Date()
                                    };
                                }
                                return angular.copy(sign);
                            },
                            isNew: function () {
                                return sign === undefined;
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.signs = Signs.query(dates);
                    });

                };
            }]).controller('SignModalCtrl',
    ['$scope', '$uibModalInstance', 'sign', 'isNew', 'Signs',
        function ($scope, $uibModalInstance, sign, isNew, Signs) {
            $scope.isNew = isNew;
            $scope.sign = sign;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (sign) {
                if (sign.id === undefined) {
                    Signs.save(sign, function () {
                        $uibModalInstance.close();
                    });
                } else {
                    sign.$update().then(function () {
                        $uibModalInstance.close();
                    });
                }
            };

        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.jour.overview', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('jour.overview', {
                url: '/overview',
                templateUrl: 'app/pages/jour/overview/overview.html',
                title: 'Översikt',
                sidebarMeta: {
                    order: 30,
                },
                controller: 'OverviewCtrl',
                resolve: {
                    data: ['Overview',
                        function (Overview) {
                            return Overview.query({year: (new Date()).getFullYear()});
                        }],
                    workGroups: ['WorkGroups', function(WorkGroups){
                        return WorkGroups.query({year: (new Date()).getFullYear()});
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.jour.overview')
    .factory('Overview', ['$resource', function ($resource) {

        return $resource('api/jour/overview/:id', {id: '@id'}, {
            query: {
                isArray: false
            },
            update: {
                method: 'PUT'
            },
            lockPeriod: {
                method: 'PUT'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.jour.overview')
    .controller('OverviewCtrl',
        ['$scope', '$http', '$uibModal', '$timeout', 'toastr', 'data', 'workGroups', 'Overview', 'WorkGroups',
            function ($scope, $http, $uibModal, $timeout, toastr, data, workGroups, Overview, WorkGroups) {
                $scope.data = data;
                $scope.workGroups = workGroups;
                $scope.year = {year: (new Date()).getFullYear()};

                $scope.activeTab = {
                    act: 0
                };

                $scope.getOverview = function (year) {
                    var act = $scope.activeTab.act;
                    $scope.data = Overview.query(year);
                    $scope.data.$promise.then(function () {
                        $timeout(function () {
                            $scope.activeTab.act = act;
                        })
                    });
                    $scope.workGroups = WorkGroups.query(year);
                };

                $scope.delete = function (member) {
                    $http.delete('api/jour/members/' + member.id).then(function (r) {
                        $scope.getOverview($scope.year);
                    });
                };

                $scope.sync = function (year) {
                    $http.post('api/jour/members/sync/' + year.year, {}).then(
                        function (response) {
                            toastr.success('Synkronisering lyckad \n\n Raderade: ' + response.data.removed + '\n Tillagda: ' + response.data.added);

                            $scope.getOverview(year);
                        }
                    )
                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/jour/overview/info.modal.html'
                    })
                };

                $scope.transferJourFromPrev = function (year) {
                    $http.put('api/jour/members/transferJourFromPreviousYear', year).then(function () {
                        $scope.getOverview(year);
                    });
                };

                $scope.assignToNewGroup = function (member, group) {
                    $http.put('api/jour/members/' + member.id + '/assign', {group_id: group.id}).then(function (response) {
                        $scope.getOverview($scope.year);
                    });
                };

                $scope.sendInformation = function (year) {
                    $http.post('api/jour/members/sendInformationEmails/' + year.year, {}).then(function (r) {
                        toastr.success('Email skickade utan problem');
                    });
                };

                $scope.openModal = function (member) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/jour/overview/member.modal.html',
                        controller: 'MemberModalCtrl',
                        resolve: {
                            member: function () {
                                return angular.copy(member);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.getOverview($scope.year);
                    });

                };
            }]).controller('MemberModalCtrl',
    ['$scope', '$http', '$uibModalInstance', 'member',
        function ($scope, $http, $uibModalInstance, member) {
            $scope.member = member;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (member) {
                $http.put('api/jour/members/' + member.id, {
                    comment: member.comment,
                    email: member.email
                }).then(function (response) {
                    $uibModalInstance.close();
                }, function (resp) {
                    $uibModalInstance.close();
                })
            };

        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.jour.check', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('jour.check', {
                url: '/check',
                templateUrl: 'app/pages/jour/check/check.html',
                title: 'Avstämning',
                sidebarMeta: {
                    order: 40,
                },
                controller: 'CheckCtrl',
                resolve: {
                    data: ['Check',
                        function (Check) {
                            return Check.query({year: (new Date()).getFullYear() - 1});
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.jour.check')
    .factory('Check', ['$resource', function ($resource) {

        return $resource('api/jour/check/:id', {id: '@id'}, {
            query: {
                isArray: false
            },
            update: {
                method: 'PUT'
            },
            lockPeriod: {
                method: 'PUT'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.jour.check')
    .controller('CheckCtrl',
        ['$scope', '$http', 'toastr', 'data', 'Check',
            function ($scope, $http, toastr, data, Check) {
                $scope.data = data;
                $scope.year = {year: (new Date()).getFullYear() - 1};


                $scope.getCheck = function (year) {
                    $scope.data = Check.query(year);
                };

                $scope.sendDebitInfo = function (year) {
                    $http.post('api/jour/check/sendEmails', year).then(function (r) {
                        toastr.success('Email skickade utan problem');
                    });
                };
            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.taxreturn', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.taxreturn', {
                url: '/taxreturn',
                templateUrl: 'app/pages/fuel/taxreturn/taxreturn.html',
                title: 'Bränsleskatt',
                sidebarMeta: {
                    order: 100,
                },
                controller: 'TaxreturnCtrl',
                resolve: {
                    data: ['Taxreturn', function (Taxreturn) {
                        return Taxreturn.query({year: (new Date()).getFullYear()});
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.taxreturn')
    .factory('Taxreturn', ['$resource', function ($resource) {
        return $resource('api/fuel/taxreturn/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                },
            }
        );
    }
]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.checks', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.checks', {
                url: '/checks',
                templateUrl: 'app/pages/fuel/checks/checks.html',
                title: 'Avstämning',
                sidebarMeta: {
                    order: 50,
                },
                controller: 'ChecksCtrl',
                resolve: {
                    keys: ['Keys', function (Keys) {
                        var d = new Date();
                        d.setMonth(d.getMonth() - 1);
                        return Keys.monthlyCheck({
                            month: d
                        });
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.checks')
    .controller('TaxreturnCtrl',
        function ($scope, $http, data, Taxreturn, toastr, $uibModal) {
            $scope.data = data;
            $scope.year = {year: (new Date()).getFullYear()};

            $scope.months = [
                'Januari',
                'Februari',
                'Mars',
                'April',
                'Maj',
                'Juni',
                'Juli',
                'Augusti',
                'September',
                'Oktober',
                'November',
                'December'
            ];

            $scope.showTax = function (year) {
                $scope.data = Taxreturn.query(year);
            }

            $scope.getQuarterLitres = function (quarter, fuel_type, data) {
                return data.slice(quarter, quarter+3).reduce((part, curr) => part + curr.litres[fuel_type], 0);
            }

            $scope.getQuarterAmount = function (quarter, data) {
                return data.slice(quarter, quarter+3)
                    .reduce((part, curr) => {
                        return part + curr.litres[0]*curr.tax[0] + curr.litres[1]*curr.tax[1];
                    }, 0);
            }

            $scope.sendMail = function () {
                $http.post(`api/fuel/taxreturn/sendEmails?year=${$scope.year.year}`).then(function () {
                    toastr.success('Rapport mailad');
                });
            };

            $scope.openInfoModal = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/fuel/checks/info.modal.html'
                })
            };

        });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.stats', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.stats', {
                url: '/stats',
                templateUrl: 'app/pages/fuel/stats/stats.html',
                title: 'Statistik',
                sidebarMeta: {
                    icon: 'ion-ios-pulse',
                    order: 80,
                },
                controller: 'StatsCtrl'
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.stats')
    .directive('totalprice', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/pages/fuel/stats/total-price.html',
            controller: ['$scope', '$http', function ($scope, $http) {
                $scope.data = {};
                $scope.year = (new Date()).getFullYear();

                $scope.chartConfig = {
                    useHighStocks: true,
                    options: {
                        chart: {
                            zoomType: 'x'
                        },
                        rangeSelector: {
                            enabled: true
                        },
                        navigator: {
                            enabled: true
                        }
                    },
                    series: [{
                        name: '91/96UL - Inköp',
                        data: null
                    },
                        {
                            name: '91/96UL - Externt',
                            data: null
                        },
                        {
                            name: '91/96UL - Faktura',
                            data: null
                        },
                        {
                            name: '100LL - Inköp',
                            data: null
                        },
                        {
                            name: '100LL - Externt',
                            data: null
                        },
                        {
                            name: '100LL - Faktura',
                            data: null
                        }
                    ],
                    yAxis: {
                        title: {
                            text: 'Kr/liter (inkl. skatter)'
                        }
                    },
                    xAxis: {
                        type: 'datetime',
                        ordinal: false
                    },
                    title: {
                        text: 'Prisutveckling'
                    }
                };

                $scope.update = function () {
                    $http.get('api/fuel/stats/price').then(function (response) {
                        $scope.chartConfig.series[0].data = response.data.type_9196.purchase;
                        $scope.chartConfig.series[1].data = response.data.type_9196.external;
                        $scope.chartConfig.series[2].data = response.data.type_9196.invoice;
                        $scope.chartConfig.series[3].data = response.data.type_100LL.purchase;
                        $scope.chartConfig.series[4].data = response.data.type_100LL.external;
                        $scope.chartConfig.series[5].data = response.data.type_100LL.invoice;
                    });
                };

                $scope.update($scope.year);

                setTimeout(function(){
                    $scope.chartConfig.getHighcharts().reflow();
                }, 500);

            }]
        };
    });
angular.module('BlurAdmin.pages.fuel.stats')
    .factory('Stats', ['$http', function ($http) {

    }
    ]);
angular.module('BlurAdmin.pages.fuel.stats')
    .controller('StatsCtrl',
        ['$scope',
            function ($scope) {

            }]);
angular.module('BlurAdmin.pages.fuel.stats')
    .directive('fuelInStock', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/pages/fuel/stats/fuel-in-stock.html',
            controller: ['$scope', '$http', function ($scope, $http) {
                $scope.data = {};

                $scope.chartConfig = {
                    options: {
                        chart: {
                            type: 'column'
                        },
                        plotOptions: {
                            series: {
                                grouping: false,
                                borderWidth: 0
                            }
                        },
                        tooltip: {
                            shared: true,
                            valueSuffix: ' l',
                        }
                    },
                    series: [
                        {
                            color: 'rgb(158, 159, 163)',
                            pointPlacement: -0.15,
                            data: [
                                {
                                    name: '91/96UL',
                                    y: 25000
                                },
                                {
                                    name: '100LL',
                                    y: 10000
                                }],
                            name: 'Kapacitet'
                        },
                        {
                            id: 'main',
                            name: 'Senaste nivå',
                            pointPlacement: -0.05,
                            data: [
                                {
                                    name: '91/96UL',
                                    y: 0
                                },
                                {
                                    name: '100LL',
                                    y: 0
                                }]
                        },
                        {
                            id: 'main1',
                            name: 'Beräknad nivå',
                            pointPlacement: 0.05,
                            data: [
                                {
                                    name: '91/96UL',
                                    y: 0
                                },
                                {
                                    name: '100LL',
                                    y: 0
                                }]
                        },
                        {
                            id: 'main2',
                            name: 'Prognostiserad nivå (30 dagar)',
                            pointPlacement: 0.15,
                            data: [
                                {
                                    name: '91/96UL',
                                    y: 0
                                },
                                {
                                    name: '100LL',
                                    y: 0
                                }]
                        }
                    ],
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: 'Nivå (liter)'
                        }
                    },
                    title: {
                        text: 'Lagernivåer'
                    },
                    subtitle: {
                        text: '91/96: - 100LL: '
                    }
                };

                $scope.update = function () {
                    $http.get('api/fuel/stats/fuelInStock').then(function (response) {
                        $scope.chartConfig.series[1].data[0].y = response.data.type_9196.level;
                        $scope.chartConfig.series[1].data[1].y = response.data.type_100LL.level;
                        $scope.chartConfig.series[2].data[0].y = response.data.type_9196.forecast;
                        $scope.chartConfig.series[2].data[1].y = response.data.type_100LL.forecast;
                        $scope.chartConfig.series[3].data[0].y = response.data.type_9196.forecast30;
                        $scope.chartConfig.series[3].data[1].y = response.data.type_100LL.forecast30;
                        $scope.chartConfig.subtitle.text =
                            "91/96: " + response.data.type_9196.forecastempty + " - " +
                            "100LL: " + response.data.type_100LL.forecastempty;
                    });
                };

                $scope.update();

                setTimeout(function () {
                    $scope.chartConfig.getHighcharts().reflow();
                }, 500);

            }]
        };
    });
angular.module('BlurAdmin.pages.fuel.stats')
    .directive('fuelAlreadyPaid', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/pages/fuel/stats/fuel-already-paid.html',
            controller: ['$scope', '$http', function ($scope, $http) {
                $scope.data = {};
                $scope.year = (new Date()).getFullYear();

                $scope.chartConfig = {
                    options: {
                        chart: {
                            type: 'areaspline'
                        },
                        plotOptions: {
                            areaspline: {
                                stacking: 'normal'
                            }
                        },
                        tooltip: {
                            shared: true,
                            valueSuffix: ' kr',
                            formatter: function () {
                                var s = '<b>' + this.x + '</b>';

                                this.points.forEach(function (point) {
                                    s += '<br/>' + point.series.name + ': ' +
                                        point.y + ' kr';
                                });
                                s += '<br/><b>Totalt: ' + this.points[0].total + ' kr</b>';

                                return s;
                            }
                        }
                    },
                    series: [{
                        name: '91/96UL',
                        data: $scope.data.type_9196
                    },
                        {
                            name: '100LL',
                            data: $scope.data.type_100LL
                        }],
                    xAxis: {
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
                    },
                    yAxis: {
                        title: {
                            text: 'Värde (kr)'
                        }
                    },
                    title: {
                        text: 'Förutbetalat bränsle: ' + $scope.year
                    }
                };

                $scope.update = function (year) {
                    $http.get('api/fuel/stats/fuelAlreadyPaid?year=' + year).then(function (response) {
                        $scope.chartConfig.series[0].data = response.data.type_9196;
                        $scope.chartConfig.series[1].data = response.data.type_100LL;
                        $scope.chartConfig.title.text = 'Förutbetalat bränsle: ' + $scope.year;
                    });
                };

                $scope.update($scope.year);

                setTimeout(function(){
                    $scope.chartConfig.getHighcharts().reflow();
                }, 500);

            }]
        };
    });
angular.module('BlurAdmin.pages.fuel.stats')
    .directive('consumptionTrailingTwelve', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/pages/fuel/stats/consumption-trailing-twelve.html',
            controller: ['$scope', '$http', function ($scope, $http) {
                $scope.data = {};
                $scope.months = {
                    m: 12
                };

                $scope.chartConfig = {
                    options: {
                        chart: {
                            type: 'areaspline'
                        },
                        plotOptions: {
                            areaspline: {
                                stacking: 'normal'
                            }
                        },
                        tooltip: {
                            shared: true,
                            valueSuffix: ' liter',
                            formatter: function () {
                                var s = '<b>' + this.x + ' månader</b>';

                                this.points.forEach(function (point) {
                                    s += '<br/>' + point.series.name + ': ' +
                                        point.y + ' liter';
                                });
                                s += '<br/><b>Totalt: ' + this.points[0].total + ' liter</b>';

                                return s;
                            }
                        }
                    },
                    series: [{
                        name: '91/96UL',
                        data: $scope.data.type_9196
                    },
                        {
                            name: '100LL',
                            data: $scope.data.type_100LL
                        }],
                    yAxis: {
                        title: {
                            text: 'Volym (liter)'
                        }
                    },
                    title: {
                        text: 'Rullande tolv-månaders förbrukning'
                    }
                };

                $scope.update = function (months) {
                    $http.get('api/fuel/stats/trailingTwelve?months=' + months.m).then(function (response) {
                        $scope.chartConfig.series[0].data = response.data.type_9196;
                        $scope.chartConfig.series[1].data = response.data.type_100LL;
                    });
                };

                $scope.update($scope.months);

                setTimeout(function(){
                    $scope.chartConfig.getHighcharts().reflow();
                }, 500);

            }]
        };
    });
angular.module('BlurAdmin.pages.fuel.stats')
    .directive('consumptionPerMonth', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/pages/fuel/stats/consumption-per-month.html',
            controller: ['$scope', '$http', function ($scope, $http) {
                $scope.data = {};
                $scope.year = (new Date()).getFullYear();

                $scope.chartConfig = {
                    options: {
                        chart: {
                            type: 'areaspline'
                        },
                        plotOptions: {
                            areaspline: {
                                stacking: 'normal'
                            }
                        },
                        tooltip: {
                            shared: true,
                            valueSuffix: ' liter',
                            formatter: function () {
                                var s = '<b>' + this.x + '</b>';

                                this.points.forEach(function (point) {
                                    s += '<br/>' + point.series.name + ': ' +
                                        point.y + ' liter';
                                });
                                s += '<br/><b>Totalt: ' + this.points[0].total + ' liter</b>';

                                return s;
                            }
                        }
                    },
                    series: [{
                        name: '91/96UL',
                        data: $scope.data.type_9196
                    },
                        {
                            name: '100LL',
                            data: $scope.data.type_100LL
                        }],
                    xAxis: {
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
                    },
                    yAxis: {
                        title: {
                            text: 'Volym (liter)'
                        }
                    },
                    title: {
                        text: 'Förbrukning per månad: ' + $scope.year
                    }
                };

                $scope.update = function (year) {
                    $http.get('api/fuel/stats/consumptionPerMonth?year=' + year).then(function (response) {
                        $scope.chartConfig.series[0].data = response.data.type_9196;
                        $scope.chartConfig.series[1].data = response.data.type_100LL;
                        $scope.chartConfig.title.text = 'Förbrukning per månad: ' + $scope.year;
                    });
                };

                $scope.update($scope.year);

                setTimeout(function(){
                    $scope.chartConfig.getHighcharts().reflow();
                }, 500);

            }]
        };
    });
angular.module('BlurAdmin.pages.fuel.stats')
    .directive('consumptionByKey', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/pages/fuel/stats/consumption-by-key.html',
            controller: ['$scope', '$http', '$filter', function ($scope, $http, $filter) {
                $scope.data = {};
                var data;

                var d = new Date();
                d.setFullYear(d.getFullYear(), 0, 1);
                var s = new Date(d);
                s.setFullYear(s.getFullYear(), 11, 31);
                $scope.dates = {
                    startDate: d,
                    endDate: s
                };
                $scope.config = {filter: "-1"};

                $scope.chartConfig = {
                    options: {
                        chart: {
                            type: 'pie'
                        },
                        plotOptions: {
                            pie: {
                                dataLabels: {
                                    format: '<b>{point.name}</b>: {point.y} liter'
                                }
                            }
                        },
                        tooltip: {
                            pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.percentage:.1f} %</b><br/>',
                            valueSuffix: ' liter'
                        }
                    },
                    series: [{
                        type: 'pie',
                        name: 'Förbrukning',
                        data: $scope.data
                    }
                    ],
                    title: {
                        text: 'Per nyckel: ' + $scope.dates.startDate.toLocaleDateString() + ' - ' + $scope.dates.endDate.toLocaleDateString()
                    }
                };

                $scope.update = function (dates) {
                    $http.get('api/fuel/stats/consumptionByKey', {
                        params: dates
                    }).then(function (response) {
                        data = response.data;
                        $scope.chartConfig.title.text = 'Per nyckel: ' + $scope.dates.startDate.toLocaleDateString() + ' - ' + $scope.dates.endDate.toLocaleDateString();
                        $scope.filterByType($scope.config.filter);
                    });
                };

                $scope.filterByType = function (type) {
                    if (parseInt(type) !== -1) {
                        $scope.chartConfig.series[0].data = $filter('filter')(data, {fuel_type: type});
                    } else {
                        $scope.chartConfig.series[0].data = data;
                    }
                };

                $scope.update($scope.dates);

                setTimeout(function(){
                    $scope.chartConfig.getHighcharts().reflow();
                }, 500);

            }]
        };
    });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.reports', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.reports', {
                url: '/reports',
                templateUrl: 'app/pages/fuel/reports/reports.html',
                title: 'Avräkningsbesked',
                sidebarMeta: {
                    order: 60,
                },
                controller: 'FuelReportsCtrl',
                resolve: {
                    reports: ['Reports', function (Reports) {
                        return Reports.query({year: (new Date()).getFullYear()});
                    }],
                    year: function () {
                        return {year: (new Date()).getFullYear()};
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.reports')
    .directive('validateReportExists', ['$http', function ($http) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                fuelType: '@'
            },
            link: function ($scope, elem, attrs, ngModel) {
                attrs.$observe('fuelType', function (fuelType) {
                    if (parseInt(fuelType) >= 0) {
                        ngModel.$asyncValidators.reportExists = function (month) {
                            return $http.get('api/fuel/reports/exists/' + $scope.fuelType + '?month=' + month.toISOString());
                        };
                    }
                });
            }
        };
    }]);
angular.module('BlurAdmin.pages.fuel.reports')
    .factory('Reports', ['$resource', function ($resource) {
        return $resource('api/fuel/reports/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.forEach(function (payment) {
                            payment.date = new Date(payment.date);
                            payment.created_at = new Date(payment.created_at);
                            payment.updated_at = new Date(payment.updated_at);
                        });
                        return data;
                    }
                },
                update: {
                    method: 'PUT'
                },
                initiate: {
                    method: 'GET',
                    isArray: false,
                    url: 'api/fuel/reports/initiate/:fuel_type/',
                    cache: false,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.date = new Date(data.date);
                        return data;
                    }
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.fuel.reports')
    .controller('FuelReportsCtrl',
        ['$scope', '$uibModal', 'reports', 'year', 'Reports',
            function ($scope, $uibModal, reports, year, Reports) {
                $scope.reports = reports;
                $scope.year = year;

                $scope.getPayments = function (year) {
                    $scope.reports = Reports.query(year);
                };

                $scope.delete = function (report) {
                    report.$delete().then(function () {
                        $scope.reports = Reports.query(year);
                    });
                };

                $scope.openModal = function (report) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/fuel/reports/report.modal.html',
                        controller: 'ReportModalCtrl',
                        resolve: {
                            report: function () {
                                if (report === undefined) {
                                    return {};
                                }
                                return angular.copy(report);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.reports = Reports.query(year);
                    });

                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/fuel/reports/info.modal.html'
                    })
                };

            }]).controller('ReportModalCtrl',
    ['$scope', '$uibModalInstance', 'report', 'Reports',
        function ($scope, $uibModalInstance, report, Reports) {
            $scope.report = report;
            $scope.manualUsage = false;
            var extraPayments;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (report) {
                if (report.id === undefined) {
                    report.$save().then(function () {
                        $uibModalInstance.close();
                    });
                } else {
                    report.$update().then(function () {
                        $uibModalInstance.close();
                    });
                }
            };

            $scope.getReportData = function (fuel_type, month) {
                if (fuel_type !== undefined && month !== undefined) {
                    Reports.initiate({fuel_type: fuel_type, month: month}).$promise.then(function (response) {
                        var date = $scope.report.date;
                        var fuel = $scope.report.fuel_type;

                        $scope.report = response;
                        $scope.report.date = date;
                        $scope.report.fuel_type = fuel;
                        extraPayments = response.fuel_payments.extra;
                    });
                }
            };

            $scope.recalculatePayments = function () {
                $scope.report.losses = $scope.report.ingoing_supply + $scope.report.total_deliveries - $scope.report.outgoing_supply - $scope.report.monthly_usage;
                var litresLeft = $scope.report.ingoing_supply + $scope.report.total_deliveries - $scope.report.outgoing_supply;

                // Consume fuel in stock
                var extra_payment_usages = [];
                $scope.report.extra_payments_available.some(function (extra_payment) {
                    if (extra_payment.litres_left > litresLeft) {
                        extra_payment_usages.push({
                            invoice_number: extra_payment.payment.delivery.invoice_number,
                            extra_payment_id: extra_payment.id,
                            litres: litresLeft,
                            amount: extra_payment.payment.delivery.total_unit_price * litresLeft
                        });
                        litresLeft = 0;
                        return true;
                    } else {
                        litresLeft -= extra_payment.litres_left;
                        extra_payment_usages.push({
                            invoice_number: extra_payment.payment.delivery.invoice_number,
                            extra_payment_id: extra_payment.id,
                            litres: extra_payment.litres_left,
                            amount: extra_payment.amount_left
                        });
                        return litresLeft === 0;
                    }
                });

                var payments = [];
                if (litresLeft > 0) {
                    $scope.report.pending_deliveries.some(function (delivery) {
                        if (delivery.amountLeft < litresLeft * delivery.price) {
                            litresLeft -= delivery.litres;

                            payments.push({
                                invoiceId: delivery.invoiceId,
                                invoiceNumber: delivery.invoiceNumber,
                                litres: delivery.litres,
                                price: delivery.price,
                                amount: delivery.amountLeft,
                                amountLeft: delivery.amountLeft
                            });
                            return false;
                        } else {
                            var amount;
                            if (delivery.amountLeft - litresLeft * delivery.price < delivery.price) {
                                amount = delivery.amountLeft;
                            } else {
                                amount = delivery.price * litresLeft;
                            }

                            payments.push({
                                invoiceId: delivery.invoiceId,
                                invoiceNumber: delivery.invoiceNumber,
                                litres: litresLeft,
                                price: delivery.price,
                                amount: amount,
                                amountLeft: delivery.amountLeft
                            });
                            return true;
                        }
                    });
                }

                // Recalculate extra payments
                var eP = [];
                extraPayments.forEach(function (extraPayment) {
                    payments.some(function (payment) {
                        if (extraPayment.invoiceId === payment.invoiceId){
                            eP.push({
                                invoiceId: payment.invoiceId,
                                invoice_number: payment.invoice_number,
                                litres: Math.round((payment.amountLeft - payment.amount) / extraPayment.price),
                                amount: payment.amountLeft - payment.amount,
                                price: payment.price
                            });
                            return true;
                        }
                        return false;
                    })
                });

                $scope.report.fuel_payments.stock = extra_payment_usages;
                $scope.report.fuel_payments.fuel = payments;
                $scope.report.fuel_payments.extra = eP;
            };
        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.readings', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.readings', {
                url: '/readings',
                templateUrl: 'app/pages/fuel/readings/readings.html',
                title: 'Avläsningar',
                sidebarMeta: {
                    order: 40,
                },
                controller: 'ReadingsCtrl',
                resolve: {
                    readings: ['Readings',
                        function (Readings) {
                            return Readings.query({
                                month: new Date()
                            });
                        }],
                    month: function () {
                        return {month: new Date()};
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.readings')
    .factory('Readings', ['$resource', function ($resource) {
        return $resource('api/fuel/readings/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.forEach(function (reading) {
                            reading.timestamp = new Date(reading.timestamp);
                            reading.created_at = new Date(reading.created_at);
                            reading.updated_at = new Date(reading.updated_at);
                        });
                        return data;
                    }
                },
                update: {
                    method: 'PUT'
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.fuel.readings')
    .controller('ReadingsCtrl',
        ['$scope', '$uibModal', 'readings', 'month', 'Readings',
            function ($scope, $uibModal, readings, month, Readings) {
                $scope.readings = readings;
                $scope.month = month;
                $scope.orderBy = 'key.number';
                $scope.reverse = false;

                $scope.getReadings = function (month) {
                    $scope.readings = Readings.query(month);
                };

                $scope.delete = function (reading) {
                    reading.$delete().then(function () {
                        $scope.readings = Readings.query(month);
                    });
                };

                $scope.openModal = function (reading) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/fuel/readings/reading.modal.html',
                        controller: 'ReadingModalCtrl',
                        scope: $scope,
                        resolve: {
                            reading: function () {
                                if (reading === undefined) {
                                    return new Readings();
                                }
                                return angular.copy(reading);
                            },
                            keys: ['Keys', function (Keys) {
                                return Keys.query();
                            }]
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.readings = Readings.query(month);
                    });
                };

                $scope.openBulkModal = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/fuel/readings/bulkimport.modal.html',
                        controller: 'BulkModalCtrl',
                        scope: $scope,
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            keys: ['Keys', function (Keys) {
                                return Keys.query();
                            }]
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.readings = Readings.query(month);
                    });
                }

            }]).controller('ReadingModalCtrl',
    ['$scope', '$uibModalInstance', 'reading', 'keys', 'toastr',
        function ($scope, $uibModalInstance, reading, keys, toastr) {
            $scope.keys = keys;
            $scope.type = reading.id === undefined ? undefined : reading.key.fuel_type;
            $scope.isNew = reading.id === undefined;

            $scope.reading = reading;

            $scope.setReadingDefaults = function (fuelType) {
                $scope.readings.some(function (reading) {
                    if (reading.key.fuel_type === parseInt(fuelType)) {
                        $scope.reading.timestamp = reading.timestamp;
                        $scope.reading.reader = reading.reader;
                        return true;
                    }
                    return false;
                });
            };

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (reading) {
                if (reading.id === undefined) {
                    reading.$save().then(function () {
                        $uibModalInstance.close();
                    }, function (rejection) {
                        toastr.error(rejection.data.message);
                    });
                } else {
                    reading.$update().then(function () {
                        $uibModalInstance.close();
                    }, function (rejection) {
                        toastr.error(rejection.data.message);
                    });
                }
            };
        }]).controller('BulkModalCtrl',
    ['$scope', '$uibModalInstance', '$filter', 'Readings', 'keys',
        function ($scope, $uibModalInstance, $filter, Readings, keys) {
            $scope.data = {};

            keys.$promise.then(function (keys) {
                var keygroups = {
                    group9196: [],
                    group100LL: []
                };
                var k9196 = $filter('filter')(keys, {fuel_type: '0'});
                for (var i = 0; i < k9196.length; i++) {
                    var obj = [
                        {
                            meter_value: 0,
                            key: k9196[i++]
                        }];
                    if (i < k9196.length) {
                        obj.push(
                            {
                                meter_value: 0,
                                key: k9196[i++]
                            });
                        if (i < k9196.length) {
                            obj.push(
                                {
                                    meter_value: 0,
                                    key: k9196[i]
                                }
                            );
                        }
                    }
                    keygroups.group9196.push(obj);
                }

                var k100LL = $filter('filter')(keys, {fuel_type: '1'});
                for (i = 0; i < k100LL.length; i++) {
                    var obj1 = [
                        {
                            meter_value: 0,
                            key: k100LL[i++]
                        }];
                    if (i < k100LL.length) {
                        obj1.push(
                            {
                                meter_value: 0,
                                key: k100LL[i++]
                            });
                        if (i < k100LL.length) {
                            obj1.push(
                                {
                                    meter_value: 0,
                                    key: k100LL[i]
                                }
                            );
                        }
                    }
                    keygroups.group100LL.push(obj1);
                }
                $scope.keygroups = keygroups;
            });

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (keygroups, data) {
                var readings = [].concat.apply([], keygroups.group9196.concat(keygroups.group100LL));
                readings.forEach(function (reading) {
                    if (reading.key.fuel_type === 0) {
                        reading.reader = data.f9196.reader;
                        reading.timestamp = data.f9196.timestamp;
                    } else if (reading.key.fuel_type === 1) {
                        reading.reader = data.f100LL.reader;
                        reading.timestamp = data.f100LL.timestamp;
                    }
                });
                Readings.save(readings).$promise.then(function () {
                    $uibModalInstance.close();
                });
            };

        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.pricing', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.pricing', {
                url: '/pricing',
                templateUrl: 'app/pages/fuel/pricing/pricing.html',
                title: 'Prisplanering',
                sidebarMeta: {
                    order: 70,
                },
                controller: 'PricingCtrl',
                resolve: {
                    prices: ['Prices', function (Prices) {
                        return Prices.query();
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.pricing')
    .factory('Prices', ['$resource', function ($resource) {
        return $resource('api/fuel/prices/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.forEach(function (price) {
                            price.valid_from = new Date(price.valid_from);
                        });
                        return data;
                    }
                },
                update: {
                    method: 'PUT'
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.fuel.pricing')
    .controller('PricingCtrl',
        function ($scope, $uibModal, $http, prices, Prices, toastr) {
            $scope.prices = prices;

            $scope.openModal = function (price, minDate) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/pages/fuel/pricing/price.modal.html',
                    controller: 'PriceModalCtrl',
                    resolve: {
                        price: function () {
                            if (price === undefined) {
                                return new Prices({
                                    valid_from: new Date()
                                });
                            }
                            return angular.copy(price);
                        },
                        minDate: function () {
                            return minDate;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.prices = Prices.query();
                });

            };

            $scope.delete = function (price) {
                price.$delete().then(function () {
                    $scope.prices = Prices.query();
                });
            };

            $scope.sendMail = function () {
                $http.post('api/fuel/prices/sendEmails').then(function () {
                    toastr.success('Prisplanering mailad');
                });
            };

        })
    .controller('PriceModalCtrl',
        function ($scope, $uibModalInstance, price, minDate) {
            $scope.price = price;
            $scope.minDate = minDate;
            $scope.isNew = price.id === undefined;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (price) {
                if (price.id === undefined) {
                    price.$save().then(function () {
                        $uibModalInstance.close();
                    });
                } else {
                    price.$update().then(function () {
                        $uibModalInstance.close();
                    });
                }
            };
        });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.log', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.log', {
                url: '/log',
                templateUrl: 'app/pages/fuel/log/log.html',
                title: 'Tankningslogg',
                sidebarMeta: {
                    order: 10,
                },
                controller: 'LogCtrl',
                resolve: {
                    logs: ['$filter', 'Logs',
                        function ($filter, Logs) {
                            var date = new Date();
                            date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                            return Logs.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                        var d2 = new Date(date);
                        d2.setDate(1);
                        return {
                            'startDate': d2,
                            'endDate': date
                        };
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.log')
    .factory('Logs', ['$resource', function ($resource) {
        return $resource('api/fuel/log/:id', {id: '@id'}, {
            query: {
                method: 'GET',
                isArray: true,
                transformResponse: function (response) {
                    var logs = angular.fromJson(response);
                    logs.forEach(function (log) {
                        log.date = new Date(log.date);
                    });
                    return logs;
                }
            },
            update: {
                method: 'PUT'
            },
            lock: {
                method: 'PUT',
                url: 'api/fuel/log/lock'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.fuel.log')
    .controller('LogCtrl',
        ['$scope', '$uibModal', 'logs', 'dates', 'Logs',
            function ($scope, $uibModal, logs, dates, Logs) {
                $scope.logs = logs;
                $scope.dates = dates;

                $scope.openModal = function (log) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/fuel/log/log.modal.html',
                        controller: 'LogModalCtrl',
                        size: 'lg',
                        resolve: {
                            log: function () {
                                return angular.copy(log);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.logs = Logs.query(dates);
                    });
                };

                $scope.getLog = function (dates) {
                    $scope.logs = Logs.query(dates);
                };

                $scope.lock = function (dates) {
                    Logs.lock(dates).then(function () {
                        $scope.getLog(dates);
                    });
                };

                $scope.delete = function (log) {
                    log.$delete().then(function () {
                        $scope.getLog($scope.dates);
                    });
                };

                $scope.calculateDifference = function (newReading, oldReading) {
                    if (newReading >= oldReading) {
                        return newReading - oldReading;
                    }
                    return 99999 + 1 - oldReading + newReading;
                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/fuel/log/info.modal.html'
                    })
                };

            }])
    .controller('LogModalCtrl',
        ['$uibModalInstance', '$scope', 'log',
            function ($uibModalInstance, $scope, log) {
                $scope.log = log;

                $scope.save = function (log) {
                    angular.forEach(log.transactions, function (transaction) {
                        if (transaction.debet > 0) {
                            transaction.amount = transaction.debet;
                        } else {
                            transaction.amount = transaction.kredit * -1;
                        }
                    });
                    log.$update().then(function () {
                        $uibModalInstance.close();
                    });
                };

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.keys', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.keys', {
                url: '/keys',
                templateUrl: 'app/pages/fuel/keys/keys.html',
                title: 'Nycklar',
                sidebarMeta: {
                    order: 20,
                },
                controller: 'KeysCtrl',
                resolve: {
                    keys: ['Keys',
                        function (Keys) {
                            return Keys.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.keys')
    .directive('validateKeyUnique', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, elem, attrs, ngModel) {
                ngModel.$validators.unique = function (value) {
                    return !$scope.$eval(attrs.validateKeyUnique).some(function (key) {
                        return key.number === parseInt(value);
                    });
                };
            }
        };
    });
angular.module('BlurAdmin.pages.fuel.keys')
    .factory('Keys', ['$resource', function ($resource) {
        return $resource('api/fuel/keys/:id', {id: '@id'}, {
            query: {
                params: {
                    withTrashed: true
                },
                isArray: true
            },
            update: {
                method: 'PUT'
            },
            monthlyCheck: {
                method: 'GET',
                url: 'api/fuel/keys/monthlyCheck',
                isArray: true
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.fuel.keys')
    .controller('KeysCtrl',
        ['$scope', '$uibModal', 'keys', 'Keys',
            function ($scope, $uibModal, keys, Keys) {
                $scope.keys = keys;

                $scope.orderBy = 'number';
                $scope.reverse = false;

                $scope.openModal = function (key) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/fuel/keys/key.modal.html',
                        controller: 'KeyModalCtrl',
                        scope: $scope,
                        resolve: {
                            key: function () {
                                if (key === undefined) {
                                    return {counter_max: 99999};
                                }
                                return angular.copy(key);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.keys = Keys.query();
                    });

                };

                $scope.showHistory = function (key) {
                    $uibModal.open({
                        templateUrl: 'app/pages/fuel/keys/key-history.modal.html',
                        controller: 'KeyHistoryModalCtrl',
                        resolve: {
                            key: function () {
                                return key;
                            }
                        }
                    });
                };

                $scope.delete = function (instructor) {
                    instructor.$delete().then(function () {
                        $scope.keys = Keys.query();
                    });
                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/fuel/keys/info.modal.html'
                    })
                };

            }]).controller('KeyModalCtrl',
    ['$scope', '$uibModalInstance', '$filter', 'key', 'Keys',
        function ($scope, $uibModalInstance, $filter, key, Keys) {
            $scope.isNew = key.id === undefined;
            $scope.key = key;
            $scope.originalType = key.type;
            $scope.originalHolder = key.holder;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.hasServiceKey = function () {
                return $filter('filter')($scope.keys, {fuel_type: $scope.key.fuel_type}).some(function (key) {
                    return !!key.is_service;
                });
            };

            $scope.hasMasterKey = function () {
                return $filter('filter')($scope.keys, {fuel_type: $scope.key.fuel_type}).some(function (key) {
                    return !!key.is_master;
                });
            };

            $scope.save = function (key) {
                if (key.id === undefined) {
                    Keys.save(key, function () {
                        $uibModalInstance.close();
                    });
                } else {
                    key.$update().then(function () {
                        $uibModalInstance.close();
                    });
                }
            };

        }]).controller('KeyHistoryModalCtrl', ['$scope', '$uibModalInstance', 'key', function ($scope, $uibModalInstance, key) {
    $scope.key = key;

    $scope.getFromDate = function (date) {
        var result = new Date(date + ' 12:00:00');
        result.setDate(result.getDate() + 1);
        return result.toISOString().substr(0, 10);
    };

    $scope.close = function () {
        $uibModalInstance.dismiss();
    };
}]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.invoicing', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.invoicing', {
                url: '/invoicing',
                templateUrl: 'app/pages/fuel/invoicing/invoicing.html',
                title: 'Fakturering',
                sidebarMeta: {
                    order: 55,
                },
                controller: 'InvoicingCtrl',
                resolve: {
                    data: ['Dispensings', function (Dispensings) {
                        var d = new Date();
                        d.setMonth(d.getMonth() - 1);
                        return Dispensings.monthlySum({
                            'month': d,
                        });
                    }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.invoicing')
    .controller('InvoicingCtrl',
        function ($scope, $http, data, Dispensings, toastr) {
            $scope.data = data;
            var d = new Date();
            d.setMonth(d.getMonth() - 1);
            $scope.month = {
                month: d
            };

            $scope.orderBy = 'holder';
            $scope.reverse = false;

            $scope.getData = function (month) {
                $scope.data = Dispensings.monthlySum(month);
            };

            $scope.sendReports = function (month) {
                $http.post('api/fuel/keys/sendReports', month).then(function () {
                    toastr.success('Rapporter skickade utan problem');
                });
            };
        });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.dispensings', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.dispensings', {
                url: '/dispensings',
                templateUrl: 'app/pages/fuel/dispensings/dispensings.html',
                title: 'Tanklogg',
                sidebarMeta: {
                    order: 5,
                },
                controller: 'DispensingsCtrl',
                resolve: {
                    dispensings: ['$filter', 'Dispensings',
                        function ($filter, Dispensings) {
                            var date = new Date();
                            return Dispensings.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setFullYear(date.getFullYear(), date.getMonth(), 1);
                        var d2 = new Date();
                        return {
                            'startDate': date,
                            'endDate': d2
                        };
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.dispensings')
    .factory('Dispensings', ['$resource', function ($resource) {
        return $resource('api/fuel/dispensings/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                },
                update: {
                    method: 'PUT'
                },
                monthlySum: {
                    method: 'GET',
                    url: 'api/fuel/dispensings/monthlySum',
                    isArray: true
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.fuel.dispensings')
    .controller('DispensingsCtrl',
        ['$scope', '$uibModal', '$http', 'dates', 'dispensings', 'Dispensings',
            function ($scope, $uibModal, $http, dates, dispensings, Dispensings) {
                $scope.dispensings = dispensings;
                $scope.dates = dates;
                $scope.orderBy = 'timestamp';
                $scope.reverse = true;

                $scope.getDispensings = function (dates) {
                    $scope.dispensings = Dispensings.query(dates);
                };
                
                $scope.fetchCDH = function () {
                    $http.post('api/fuel/dispensings/fetchCDH/', {}).then(
                        function (response) {
                            $scope.getDispensings($scope.dates);
                        }
                    )
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel.deliveries', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel.deliveries', {
                url: '/deliveries',
                templateUrl: 'app/pages/fuel/deliveries/deliveries.html',
                title: 'Bränsleleveranser',
                sidebarMeta: {
                    order: 30,
                },
                controller: 'DeliveriesCtrl',
                resolve: {
                    deliveries: ['Deliveries',
                        function (Deliveries) {
                            return Deliveries.query({year: (new Date()).getFullYear()});
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.fuel.deliveries')
    .factory('Deliveries', ['$resource', function ($resource) {
        return $resource('api/fuel/deliveries/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.forEach(function (delivery) {
                            delivery.date = new Date(delivery.date);
                            delivery.due_date = new Date(delivery.due_date);
                        });
                        return data;
                    }
                },
                update: {
                    method: 'PUT'
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.fuel.deliveries')
    .controller('DeliveriesCtrl',
        ['$scope', '$uibModal', 'deliveries', 'Deliveries',
            function ($scope, $uibModal, deliveries, Deliveries) {
                $scope.deliveries = deliveries;
                $scope.year = {year: (new Date()).getFullYear()};
                $scope.orderBy = 'date';
                $scope.reverse = true;

                $scope.getDeliveries = function (year) {
                    $scope.deliveries = Deliveries.query(year);
                };

                $scope.delete = function (delivery) {
                    delivery.$delete().then(function () {
                        $scope.deliveries = Deliveries.query($scope.year);
                    });
                };

                $scope.openModal = function (delivery) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/fuel/deliveries/delivery.modal.html',
                        controller: 'DeliveryModalCtrl',
                        resolve: {
                            delivery: function () {
                                if (delivery === undefined) {
                                    return new Deliveries();
                                }
                                return angular.copy(delivery);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.deliveries = Deliveries.query($scope.year);
                    });

                };

                $scope.showPayments = function (payments) {
                    $uibModal.open({
                        templateUrl: 'app/pages/fuel/deliveries/delivery-payments.modal.html',
                        controller: 'DeliveryPaymentsModalCtrl',
                        resolve: {
                            payments: function () {
                                return payments;
                            }
                        }
                    });
                };

            }]).controller('DeliveryModalCtrl',
    ['$scope', '$uibModalInstance', 'delivery',
        function ($scope, $uibModalInstance, delivery) {
            $scope.data = {};

            delivery.price_incl_tax = true;
            $scope.delivery = delivery;

            $scope.suggestAmount = function(delivery){
                return Math.round(delivery.litres * (delivery.price_incl_tax ? delivery.price : (delivery.price + delivery.co2_tax + delivery.energy_tax)));
            };

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (delivery) {
                delivery.price = delivery.price_incl_tax ? delivery.price - delivery.co2_tax - delivery.energy_tax : delivery.price;
                if (delivery.id === undefined) {
                    delivery.$save().then(function () {
                        $uibModalInstance.close();
                    });
                } else {
                    delivery.$update().then(function () {
                        $uibModalInstance.close();
                    });
                }
            };
        }])
    .controller('DeliveryPaymentsModalCtrl',
        ['$scope', '$uibModalInstance', 'payments', function ($scope, $uibModalInstance, payments) {
            $scope.payments = payments;

            $scope.close = function () {
                $uibModalInstance.close();
            };
        }]);
angular.module('BlurAdmin.pages.fuel.checks')
    .controller('ChecksCtrl',
        function ($scope, $http, keys, Keys, toastr, $uibModal) {
            $scope.keys = keys;
            var d = new Date();
            d.setMonth(d.getMonth() - 1);
            $scope.month = {
                month: d
            };

            $scope.orderBy = 'number';
            $scope.reverse = false;

            $scope.getKeys = function (month) {
                $scope.keys = Keys.monthlyCheck(month);
            };

            $scope.calculateDifference = function (newReading, oldReading, counterMax) {
                if (newReading >= oldReading) {
                    return newReading - oldReading;
                }
                return counterMax + 1 - oldReading + newReading;
            };

            $scope.getMasterDifference = function (keys, fuelType) {
                var diff = 0;
                keys.some(function (key) {
                    if (key.number === 0 && key.fuel_type === fuelType) {
                        if (key.reading_end.meter_value >= key.reading_start.meter_value) {
                            diff = key.reading_end.meter_value - key.reading_start.meter_value;
                            return true;
                        }
                        diff = key.counter_max + 1 - key.reading_start.meter_value + key.reading_end.meter_value;
                        return true;
                    }
                    return false;
                });
                return diff;
            };

            $scope.sendReports = function (month) {
                $http.post('api/fuel/keys/sendReports', month).then(function () {
                    toastr.success('Rapporter skickade utan problem');
                });
            };

            $scope.noInactive = function (key) {
                return !(key.holder === 'INAKTIV' && key.reading_start.meter_value === key.reading_end.meter_value && key.reading_start.id !== key.reading_end.id);
            };

            $scope.openInfoModal = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/fuel/checks/info.modal.html'
                })
            };

        });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.brandflyg.rescuers', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('brandflyg.rescuers', {
                url: '/rescuers',
                templateUrl: 'app/pages/brandflyg/rescuers/rescuers.html',
                title: 'Räddningstjänster',
                sidebarMeta: {
                    order: 10,
                },
                controller: 'RescuersCtrl',
                resolve: {
                    rescuers: ['Rescuers',
                        function (Rescuers) {
                            return Rescuers.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.brandflyg.rescuers')
    .factory('Rescuers', ['$resource', function ($resource) {
        return $resource('api/brandflyg/rescuers/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            },
            restore: {
                url: 'api/brandflyg/rescuers/:id/restore',
                method: 'PUT'
            },
            invoice: {
                url: 'api/brandflyg/rescuers/invoice',
                method: 'GET',
                isArray: true,
                transformResponse: function (response) {
                    var rescuers = angular.fromJson(response);

                    rescuers.forEach(function (rescuer) {
                        rescuer.fires.forEach(function (fire) {
                            fire.report.date = new Date(fire.report.date);

                            var start = fire.start.split(':');
                            var end = fire.end.split(':');

                            fire.start = new Date(Date.UTC(1970, 1, 1, start[0], start[1], start[2]));
                            fire.end = new Date(Date.UTC(1970, 1, 1, end[0], end[1], end[2]));
                        });
                    });

                    return rescuers;
                }
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.brandflyg.rescuers')
    .controller('RescuersCtrl',
        ['$scope', '$uibModal', 'rescuers', 'Rescuers',
            function ($scope, $uibModal, rescuers, Rescuers) {
                $scope.rescuers = rescuers;

                $scope.openModal = function (rescuer) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/brandflyg/rescuers/rescuer.modal.html',
                        controller: 'RescuerModalCtrl',
                        resolve: {
                            rescuer: function () {
                                if (rescuer === undefined) {
                                    return {};
                                }
                                return angular.copy(rescuer);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.rescuers = Rescuers.query();
                    });
                };

                $scope.delete = function (rescuer) {
                    rescuer.$delete().then(function () {
                        $scope.rescuers = Rescuers.query();
                    });
                };

                $scope.restore = function (rescuer) {
                    rescuer.$restore().then(function () {
                        $scope.rescuers = Rescuers.query();
                    });
                };

                $scope.showDel = function (rescuer) {
                    if ($scope.showDeleted) return true;
                    return rescuer.deleted_at === null;
                };

            }]).controller('RescuerModalCtrl',
    ['$scope', '$uibModalInstance', 'rescuer', 'Rescuers',
        function ($scope, $uibModalInstance, rescuer, Rescuers) {
            $scope.isNew = rescuer.id === undefined;
            $scope.rescuer = rescuer;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (rescuer) {
                if (rescuer.id === undefined) {
                    Rescuers.save(rescuer, function () {
                        $uibModalInstance.close();
                    });
                } else {
                    rescuer.$update().then(function () {
                        $uibModalInstance.close();
                    });
                }
            };

        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.brandflyg.reports', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('brandflyg.reports', {
                url: '/reports',
                templateUrl: 'app/pages/brandflyg/reports/reports.html',
                title: 'Insatsrapporter',
                sidebarMeta: {
                    order: 20,
                },
                controller: 'FireReportsCtrl',
                resolve: {
                    reports: ['$filter', 'FireReports',
                        function ($filter, FireReports) {
                            var date = new Date();
                            date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                            return FireReports.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                        var d2 = new Date(date);
                        d2.setDate(1);
                        return {
                            'startDate': d2,
                            'endDate': date
                        };
                    }
                }
            });
    }
})();
angular.module('BlurAdmin.pages.brandflyg.reports')
    .factory('FireReports', ['$resource', function ($resource) {

        return $resource('api/brandflyg/reports/:id', {id: '@id'}, {
            query: {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    var records = angular.fromJson(data);
                    records.forEach(function (report) {
                        report.date = new Date(report.date);
                        var takeoff = report.takeoff.split(':');
                        var landing = report.landing.split(':');
                        var block_off = report.block_off.split(':');
                        var block_on = report.block_on.split(':');

                        report.takeoff = new Date(Date.UTC(1970, 1, 1, takeoff[0], takeoff[1], takeoff[2]));
                        report.landing = new Date(Date.UTC(1970, 1, 1, landing[0], landing[1], landing[2]));
                        report.block_off = new Date(Date.UTC(1970, 1, 1, block_off[0], block_off[1], block_off[2]));
                        report.block_on = new Date(Date.UTC(1970, 1, 1, block_on[0], block_on[1], block_on[2]));

                        report.sumOfFires = 0;
                        report.fires.forEach(function (fire) {
                            var start = fire.start.split(':');
                            var end = fire.end.split(':');

                            fire.start = new Date(Date.UTC(1970, 1, 1, start[0], start[1], start[2]));
                            fire.end = new Date(Date.UTC(1970, 1, 1, end[0], end[1], end[2]));
                            report.sumOfFires += Math.round((fire.end.getTime() - fire.start.getTime()) / (100 * 60 * 60)) / 10;
                        });
                    });

                    return records;
                }
            },
            update: {
                method: 'PUT'
            },
            lockPeriod: {
                method: 'PUT'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.brandflyg.reports')
    .controller('FireReportsCtrl',
        ['$window', '$scope', '$uibModal', 'reports', 'dates', 'FireReports', 'Rescuers',
            function ($window, $scope, $uibModal, reports, dates, FireReports, Rescuers) {
                $scope.reports = reports;
                $scope.dates = dates;

                $scope.delete = function (record) {
                    record.$delete().then(function () {
                        $scope.updateAll(dates);
                    });
                };

                $scope.updateAll = function (dates) {
                    $scope.reports = FireReports.query(dates);
                };

                $scope.getPdf = function (report) {
                    $window.open('api/brandflyg/reports/' + report.id + '.pdf?');
                };

                $scope.openModal = function (report) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/brandflyg/reports/report.modal.html',
                        controller: 'ReportModalCtrl',
                        size: 'lg',
                        resolve: {
                            report: function () {
                                return angular.copy(report);
                            },
                            rescuers: function () {
                                return Rescuers.query();
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.updateAll(dates);
                    });
                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/brandflyg/reports/info.modal.html'
                    })
                };

            }]).controller('ReportModalCtrl',
    ['$scope', '$uibModalInstance', 'report', 'rescuers',
        function ($scope, $uibModalInstance, report, rescuers) {
            $scope.data = {};

            $scope.report = report;
            $scope.rescuers = rescuers;

            $scope.remove = function (index) {
                $scope.report.fires.splice(index, 1);
            };

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (record) {
                record.$update().then(function () {
                    $uibModalInstance.close();
                });
            };
        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.brandflyg.invoice', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('brandflyg.invoice', {
                url: '/invoice',
                templateUrl: 'app/pages/brandflyg/invoice/invoicing.html',
                title: 'Fakturering',
                sidebarMeta: {
                    order: 30,
                },
                controller: 'FireInvoiceCtrl',
                resolve: {
                    reports: ['$filter', 'FireReports',
                        function ($filter, FireReports) {
                            var date = new Date();
                            date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                            return FireReports.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                        var d2 = new Date(date);
                        d2.setDate(1);
                        return {
                            'startDate': d2,
                            'endDate': date
                        };
                    },
                    rescuers: ['$filter', 'Rescuers',
                        function ($filter, Rescuers) {
                            var date = new Date();
                            date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                            return Rescuers.invoice({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.brandflyg.invoice')
    .controller('FireInvoiceCtrl',
        function ($scope, $window, FireReports, Rescuers, reports, rescuers, dates, $uibModal) {
            $scope.reports = reports;
            $scope.rescuers = rescuers;
            $scope.dates = dates;

            $scope.updateAll = function (dates) {
                $scope.reports = FireReports.query(dates);
                $scope.rescuers = Rescuers.invoice(dates);
            };

            $scope.getPdf = function (rescuers) {
                var match = rescuers.some(function (rescuer) {
                    if (rescuer.active) {
                        $window.open('api/brandflyg/rescuers/' + rescuer.id + '.pdf?startDate=' + $scope.dates.startDate.toJSON() + '&endDate=' + $scope.dates.endDate.toJSON() + '&invoice=' + prompt('Ange fakturanummer:'));
                        return true;
                    }
                    return false;
                });

                if (!match) {
                    $window.open('api/brandflyg/reports.pdf?startDate=' + $scope.dates.startDate.toJSON() + '&endDate=' + $scope.dates.endDate.toJSON() + '&invoice=' + prompt('Ange fakturanummer:'));
                }
            };

            $scope.getFakeLanding = function (report) {
                return new Date(report.block_off.getTime() + (report.block - report.sumOfFires) * 60 * 60 * 1000);
            };

            $scope.lockPeriod = function (dates) {
                FireReports.lockPeriod(dates, function () {
                    $scope.reports = FireReports.query(dates);
                });
            };

            $scope.openInfoModal = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/brandflyg/invoice/info.modal.html'
                })
            };
        }
    );
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.users', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.users', {
                url: '/users',
                templateUrl: 'app/pages/admin/users/users.html',
                title: 'Användare',
                sidebarMeta: {
                    order: 20
                },
                controller: 'UsersCtrl',
                resolve: {
                    users: ['Users',
                        function (Users) {
                            return Users.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.users')
    .factory('Users', ['$resource', function ($resource) {
        return $resource('api/admin/users/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.admin.users')
    .controller('UsersCtrl',
        ['$scope', '$uibModal', 'Users', 'users',
            function ($scope, $uibModal, Users, users) {
                $scope.users = users;

                $scope.delete = function (user) {
                    user.$delete().then(function () {
                        $scope.users = Users.query();
                    });
                };

                $scope.openModal = function (user) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/admin/users/user.modal.html',
                        controller: 'UserModalCtrl',
                        resolve: {
                            user: function () {
                                if (user === null) {
                                    return {};
                                }
                                return angular.copy(user);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.users = Users.query();
                    });

                };

            }])
    .controller('UserModalCtrl',
        ['$scope', '$uibModalInstance', 'user', 'Users',
            function ($scope, $uibModalInstance, user, Users) {
                $scope.isNew = user === undefined;
                $scope.user = user;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (user) {
                    if (user.id === undefined) {
                        Users.save(user, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        user.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.settings', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.settings', {
                url: '/settings',
                templateUrl: 'app/pages/admin/settings/settings.html',
                title: 'Inställningar',
                sidebarMeta: {
                    order: 10
                },
                controller: 'SettingsCtrl',
                resolve: {
                    settings: ['Settings',
                        function (Settings) {
                            return Settings.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.settings')
    .factory('Settings', ['$resource', function ($resource) {
        return $resource('api/admin/settings/:id', {id: '@id'}, {
            query: {
                method: 'GET',
                isArray: false
            },
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.admin.settings')
    .controller('SettingsCtrl',
        ['$scope', '$uibModal', '$timeout', 'Settings', 'settings',
            function ($scope, $uibModal, $timeout, Settings, settings) {
                $scope.data = settings;

                $scope.activeTab = {
                    act: 0
                };

                $scope.openModal = function (setting) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/admin/settings/setting.modal.html',
                        controller: 'SettingModalCtrl',
                        resolve: {
                            setting: function () {
                                if (setting instanceof Settings) {
                                    return angular.copy(setting);
                                } else {
                                    return new Settings(setting);
                                }
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        var activeTab = $scope.activeTab.act;
                        $scope.data = Settings.query();
                        $scope.data.$promise.then(function () {
                            $timeout(function () {
                                $scope.activeTab.act = activeTab;
                            });
                        });
                    });

                };

            }])
    .controller('SettingModalCtrl',
        ['$scope', '$uibModalInstance', 'setting',
            function ($scope, $uibModalInstance, setting) {

                switch (setting.type) {
                    case 1: // Email
                        $scope.inputType = {
                            type: 'email',
                            max: '',
                            min: ''
                        };
                        break;
                    case 2: // Integer
                        setting.value = parseInt(setting.value);
                        $scope.inputType = {
                            type: 'number',
                            max: Infinity,
                            min: -Infinity
                        };
                        break;
                    case 3: // Unsigned integer
                        setting.value = parseInt(setting.value);
                        $scope.inputType = {
                            type: 'number',
                            max: Infinity,
                            min: 0
                        };
                        break;
                    case 6: // Text
                        $scope.inputType = {
                            type: 'text',
                            max: '',
                            min: ''
                        };
                        break;
                    case 7: // Date
                        setting.value = new Date(setting.value);
                        $scope.inputType = {
                            type: 'date',
                            max: Infinity,
                            min: -Infinity
                        };
                        break;
                    default:
                        $scope.inputType = {
                            type: 'text',
                            max: '',
                            min: ''
                        };
                }

                $scope.setting = setting;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (setting) {
                    // Convert into yyyy-mm-dd if date
                    if (setting.value instanceof Date) {
                        setting.value = setting.value.toISOString().split('T')[0];
                    }

                    setting.$update().then(function () {
                        $uibModalInstance.close();
                    });
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.insurance', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.insurance', {
                url: '/insurance',
                templateUrl: 'app/pages/admin/insurance/insurance.html',
                title: 'Försäkringsinfo',
                sidebarMeta: {
                    order: 35
                },
                controller: 'AdminInsuranceCtrl'
            });
    }
})();

angular.module('BlurAdmin.pages.admin.insurance')
    .factory('AdminInsurance', ['$resource', function ($resource) {
        return $resource('api/admin/insurance/:year', {year: '@year'}, {
            sync: {
                method: 'POST',
                url: 'api/admin/insurance/:year/sync'
            },
            send: {
                method: 'POST',
                url: 'api/admin/insurance/:year/send'
            }
        });
    }]);

angular.module('BlurAdmin.pages.admin.insurance')
    .controller('AdminInsuranceCtrl',
        ['$scope', '$http', '$uibModal', 'toastr', 'AdminInsurance',
            function ($scope, $http, $uibModal, toastr, AdminInsurance) {
                // Initialize with current year
                $scope.year = {year: (new Date()).getFullYear()};
                $scope.data = null;
                $scope.statistics = null;
                $scope.recipients = null;

                $scope.loadYear = function (year) {
                    // Clear existing data before loading
                    $scope.data = null;
                    $scope.statistics = null;
                    $scope.recipients = null;

                    AdminInsurance.get({year: year.year}, function (data) {
                        $scope.data = data;
                        $scope.statistics = data.statistics;
                        $scope.recipients = data.recipients;
                    }, function (error) {
                        toastr.error('Kunde inte ladda data för ' + year.year, 'Fel');
                    });
                };

                $scope.syncRecipients = function (year) {
                    $http.post('api/admin/insurance/' + year.year + '/sync', {}).then(
                        function (response) {
                            toastr.success(response.data.message, 'Synkronisering lyckad');
                            $scope.loadYear(year);
                        },
                        function (error) {
                            var message = error.data && error.data.message ? error.data.message : 'Ett fel uppstod';
                            toastr.error(message, 'Synkronisering misslyckades');
                        }
                    );
                };

                $scope.sendEmails = function (year) {
                    if ($scope.statistics.unconfirmed === 0) {
                        toastr.info('Alla har redan bekräftat', 'Information');
                        return;
                    }

                    $http.post('api/admin/insurance/' + year.year + '/send', {}).then(
                        function (response) {
                            var message = response.data.message;
                            if (response.data.failed && response.data.failed.length > 0) {
                                toastr.warning(message, 'Skickat med varningar');
                            } else {
                                toastr.success(message, 'Email skickade');
                            }
                            $scope.loadYear(year);
                        },
                        function (error) {
                            var message = error.data && error.data.message ? error.data.message : 'Ett fel uppstod';
                            toastr.error(message, 'Skickande misslyckades');
                        }
                    );
                };

                $scope.getConfirmationRate = function () {
                    if (!$scope.statistics || $scope.statistics.total === 0) return 0;
                    return Math.round(($scope.statistics.confirmed / $scope.statistics.total) * 100);
                };

                $scope.formatDate = function (dateString) {
                    if (!dateString) return '-';
                    return new Date(dateString).toLocaleString('sv-SE', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/admin/insurance/info.modal.html'
                    });
                };

                // Load current year on init
                $scope.loadYear($scope.year);
            }]);

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.heaters', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.heaters', {
                url: '/heaters',
                templateUrl: 'app/pages/admin/heaters/heaters.html',
                title: 'Motorvärmare',
                sidebarMeta: {
                    order: 25
                },
                controller: 'HeatersCtrl',
                resolve: {
                    heaters: ['Heaters',
                        function (Heaters) {
                            return Heaters.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.heaters')
    .factory('Heaters', ['$resource', function ($resource) {
        return $resource('api/admin/heaters/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.admin.heaters')
    .controller('HeatersCtrl',
        ['$scope', '$uibModal', 'Heaters', 'heaters',
            function ($scope, $uibModal, Heaters, heaters) {
                $scope.heaters = heaters;

                $scope.delete = function (heater) {
                    heater.$delete().then(function () {
                        $scope.heaters = Heaters.query();
                    });
                };

                $scope.openModal = function (heater) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/admin/heaters/heater.modal.html',
                        controller: 'HeaterModalCtrl',
                        resolve: {
                            heater: function () {
                                if (heater === null) {
                                    return {};
                                }
                                return angular.copy(heater);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.heaters = Heaters.query();
                    });

                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/admin/heaters/info.modal.html'
                    })
                };

            }])
    .controller('HeaterModalCtrl',
        ['$scope', '$uibModalInstance', 'heater', 'Heaters',
            function ($scope, $uibModalInstance, heater, Heaters) {
                $scope.isNew = heater === undefined;
                $scope.heater = heater;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (heater) {
                    if (heater.id === undefined) {
                        Heaters.save(heater, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        heater.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.events', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.events', {
                url: '/events',
                templateUrl: 'app/pages/admin/events/eventlog.html',
                title: 'Händelselogg',
                sidebarMeta: {
                    order: 30
                },
                controller: 'EventsCtrl',
                resolve: {
                    pagination: ['Events',
                        function (Events) {
                            return Events.get({page: 1});
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.events')
    .factory('Events', ['$resource', function ($resource) {
        return $resource('api/admin/eventlog');
    }]);
angular.module('BlurAdmin.pages.admin.events')
    .controller('EventsCtrl',
        ['$scope', '$uibModal', 'Events', 'pagination',
            function ($scope, $uibModal, Events, pagination) {
                $scope.pagination = pagination;
                $scope.currentPage = 1;

                $scope.openModal = function (event) {
                    $uibModal.open({
                        templateUrl: 'app/pages/admin/events/event.modal.html',
                        controller: 'EventModalCtrl',
                        resolve: {
                            event: function () {
                                return event;
                            }
                        }
                    });
                };

                $scope.pageChange = function (newPage) {
                    $scope.pagination = Events.get({page: newPage});
                };

            }])
    .controller('EventModalCtrl',
        ['$scope', '$uibModalInstance', 'event',
            function ($scope, $uibModalInstance, event) {
                $scope.event = event;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };
            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.depkaps', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.depkaps', {
                url: '/depkaps',
                templateUrl: 'app/pages/admin/depkaps/depkaps.html',
                title: 'Deponerat kapital',
                sidebarMeta: {
                    order: 27
                },
                controller: 'AdminDepkapsCtrl',
                resolve: {
                    depkaps: ['AdminDepkaps',
                        function (AdminDepkaps) {
                            return AdminDepkaps.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.depkaps')
    .factory('AdminDepkaps', ['$resource', function ($resource) {
        return $resource('api/admin/depkaps/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.admin.depkaps')
    .controller('AdminDepkapsCtrl',
        ['$scope', '$uibModal', 'AdminDepkaps', 'depkaps',
            function ($scope, $uibModal, AdminDepkaps, depkaps) {
                $scope.depkaps = depkaps;

                $scope.delete = function (depkap) {
                    depkap.$delete().then(function () {
                        $scope.depkaps = AdminDepkaps.query();
                    });
                };

                $scope.openModal = function (depkap) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/admin/depkaps/depkap.modal.html',
                        controller: 'AdminDepkapModalCtrl',
                        resolve: {
                            depkap: function () {
                                if (depkap === null) {
                                    return {};
                                }
                                return angular.copy(depkap);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.depkaps = AdminDepkaps.query();
                    });

                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/admin/depkaps/info.modal.html'
                    })
                };

            }])
    .controller('AdminDepkapModalCtrl',
        ['$scope', '$uibModalInstance', 'depkap', 'AdminDepkaps',
            function ($scope, $uibModalInstance, depkap, AdminDepkaps) {
                $scope.isNew = depkap === undefined;
                $scope.depkap = depkap;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (depkap) {
                    if (depkap.id === undefined) {
                        AdminDepkaps.save(depkap, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        depkap.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.budget', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.budget', {
                url: '/budget',
                templateUrl: 'app/pages/admin/budget/budget.html',
                title: 'Flygbudget',
                sidebarMeta: {
                    order: 40
                },
                controller: 'AdminBudgetCtrl'
            });
    }
})();

angular.module('BlurAdmin.pages.admin.budget')
    .factory('AdminBudget', ['$resource', function ($resource) {
        return $resource('api/admin/flightBudgets/:year', {year: '@year'}, {
            query: {
                method: 'GET',
                isArray: false
            },
            save: {
                method: 'POST',
                url: 'api/admin/flightBudgets'
            }
        });
    }]);

angular.module('BlurAdmin.pages.admin.budget')
    .controller('AdminBudgetCtrl',
        ['$scope', '$http', 'toastr', 'AdminBudget',
            function ($scope, $http, toastr, AdminBudget) {
                $scope.year = {year: (new Date()).getFullYear()};
                $scope.data = null;
                $scope.grid = null;

                $scope.loadYear = function (year) {
                    $scope.data = null;
                    $scope.grid = null;

                    AdminBudget.query({year: year.year}, function (data) {
                        $scope.data = data;
                        $scope.grid = data.grid;
                    }, function () {
                        toastr.error('Kunde inte ladda data', 'Fel');
                    });
                };

                $scope.save = function () {
                    var budgets = [];
                    angular.forEach($scope.grid, function (regs, flygkod) {
                        angular.forEach(regs, function (hours, reg) {
                            var h = parseFloat(hours) || 0;
                            if (h > 0) {
                                budgets.push({
                                    flygkod: flygkod,
                                    reg: reg,
                                    hours: h
                                });
                            }
                        });
                    });

                    AdminBudget.save({}, {
                        year: $scope.year.year,
                        budgets: budgets
                    }, function () {
                        toastr.success('Budget sparad', 'OK');
                    }, function () {
                        toastr.error('Kunde inte spara budget', 'Fel');
                    });
                };

                $scope.getRowTotal = function (kod) {
                    if (!$scope.grid || !$scope.grid[kod]) return 0;
                    var sum = 0;
                    angular.forEach($scope.grid[kod], function (hours) {
                        sum += parseFloat(hours) || 0;
                    });
                    return sum;
                };

                $scope.getColumnTotal = function (reg) {
                    if (!$scope.grid) return 0;
                    var sum = 0;
                    angular.forEach($scope.grid, function (regs) {
                        sum += parseFloat(regs[reg]) || 0;
                    });
                    return sum;
                };

                $scope.getGrandTotal = function () {
                    if (!$scope.grid) return 0;
                    var sum = 0;
                    angular.forEach($scope.grid, function (regs) {
                        angular.forEach(regs, function (hours) {
                            sum += parseFloat(hours) || 0;
                        });
                    });
                    return sum;
                };

                $scope.loadYear($scope.year);
            }]);

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.aircraft', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.aircraft', {
                url: '/aircraft',
                templateUrl: 'app/pages/admin/aircraft/aircraft.html',
                title: 'Flygplan',
                sidebarMeta: {
                    order: 22
                },
                controller: 'AircraftCtrl',
                resolve: {
                    aircraft: ['Aircraft',
                        function (Aircraft) {
                            return Aircraft.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.aircraft')
    .factory('Aircraft', ['$resource', function ($resource) {
        return $resource('api/admin/aircraft/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            }
        });
    }]);
angular.module('BlurAdmin.pages.admin.aircraft')
    .controller('AircraftCtrl',
        ['$scope', '$uibModal', 'Aircraft', 'aircraft',
            function ($scope, $uibModal, Aircraft, aircrafts) {
                $scope.aircrafts = aircrafts;

                $scope.delete = function (aircraft) {
                    aircraft.$delete().then(function () {
                        $scope.aircrafts = Aircraft.query();
                    });
                };

                $scope.openModal = function (aircraft) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/admin/aircraft/aircraft.modal.html',
                        controller: 'AircraftModalCtrl',
                        resolve: {
                            aircraft: function () {
                                if (aircraft === null) {
                                    return {
                                        reg: '',
                                        included_in_saab: true,
                                        included_in_salary: true
                                    };
                                }
                                return angular.copy(aircraft);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.aircrafts = Aircraft.query();
                    });

                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/admin/aircraft/info.modal.html'
                    })
                };

            }])
    .controller('AircraftModalCtrl',
        ['$scope', '$uibModalInstance', 'aircraft', 'Aircraft',
            function ($scope, $uibModalInstance, aircraft, Aircraft) {
                $scope.isNew = aircraft === undefined;
                $scope.aircraft = aircraft;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (aircraft) {
                    if (aircraft.id === undefined) {
                        Aircraft.save(aircraft, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        aircraft.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin.accounts', [])
        .config(routeConfig);

        function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin.accounts', {
                url: '/accounts',
                templateUrl: 'app/pages/admin/accounts/accounts.html',
                title: 'Kontoplan',
                sidebarMeta: {
                    order: 25
                },
                controller: 'AdminAccountsCtrl',
                resolve: {
                    accounts: ['AdminAccounts',
                        function (AdminAccounts) {
                            return AdminAccounts.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.admin.accounts')
    .controller('AdminAccountsCtrl',
        ['$scope', '$uibModal', 'AdminAccounts', 'accounts',
            function ($scope, $uibModal, AdminAccounts, accounts) {
                $scope.accounts = accounts;

                $scope.delete = function (account) {
                    account.$delete().then(function () {
                        $scope.accounts = AdminAccounts.query();
                    });
                };

                $scope.openModal = function (account) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/admin/accounts/account.modal.html',
                        controller: 'AdminAccountModalCtrl',
                        resolve: {
                            account: function () {
                                if (account === null) {
                                    return {};
                                }
                                return angular.copy(account);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.accounts = AdminAccounts.query();
                    });

                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/admin/accounts/info.modal.html'
                    })
                };

            }])
    .controller('AdminAccountModalCtrl',
        ['$scope', '$uibModalInstance', 'account', 'AdminAccounts',
            function ($scope, $uibModalInstance, account, AdminAccounts) {
                $scope.isNew = account === undefined;
                $scope.account = account;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (account) {
                    if (account.id === undefined) {
                        AdminAccounts.save(account, function () {
                            $uibModalInstance.close();
                        });
                    } else {
                        account.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

            }]);
angular.module('BlurAdmin.pages.admin.accounts')
    .factory('AdminAccounts', ['$resource', function ($resource) {
        return $resource('api/admin/accounts/:id', {id: '@id'}, {
            update: {
                method: 'PUT'
            }
        });
    }]);
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('stopableInterval', stopableInterval);

    function stopableInterval($window) {
        "ngInject";
        return {
            start: function (interval, calback, time) {
                function startInterval() {
                    return interval(calback, time);
                }

                var i = startInterval();

                angular.element($window).bind('focus', function () {
                    if (i) interval.cancel(i);
                    i = startInterval();
                });

                angular.element($window).bind('blur', function () {
                    if (i) interval.cancel(i);
                });
            }
        }
    }

})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('preloader', preloader);

    function preloader($q) {
        "ngInject";
        return {
            loadImg: function (src) {
                var d = $q.defer();
                var img = new Image();
                img.src = src;
                img.onload = function () {
                    d.resolve();
                };
                return d.promise;
            }
        }
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('fileReader', fileReader);

    function fileReader($q) {
        "ngInject";
        var onLoad = function (reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.resolve(reader.result);
                });
            };
        };

        var onError = function (reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.reject(reader.result);
                });
            };
        };

        var onProgress = function (reader, scope) {
            return function (event) {
                scope.$broadcast('fileProgress',
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        };

        var getReader = function (deferred, scope) {
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        };

        var readAsDataURL = function (file, scope) {
            var deferred = $q.defer();

            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);

            return deferred.promise;
        };

        return {
            readAsDataUrl: readAsDataURL
        };
    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('baUtil', baUtil);

    function baUtil() {
        "ngInject";
        this.isDescendant = function (parent, child) {
            var node = child.parentNode;
            while (node != null) {
                if (node == parent) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        };

        this.hexToRGB = function (hex, alpha) {
            var r = parseInt(hex.slice(1, 3), 16);
            var g = parseInt(hex.slice(3, 5), 16);
            var b = parseInt(hex.slice(5, 7), 16);
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        }
    }
})();

/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('zoomIn', zoomIn);

    function zoomIn($timeout, $rootScope) {
        "ngInject";
        return {
            restrict: 'A',
            link: function ($scope, elem) {
                var delay = 1000;

                if ($rootScope.$pageFinishedLoading) {
                    delay = 100;
                }

                $timeout(function () {
                    elem.removeClass('full-invisible');
                    elem.addClass('animated zoomIn');
                }, delay);
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('trackWidth', trackWidth);

    function trackWidth() {
        "ngInject";
        return {
            scope: {
                trackWidth: '=',
                minWidth: '=',
            },
            link: function (scope, element) {
                scope.trackWidth = $(element).width() < scope.minWidth;
                scope.prevTrackWidth = scope.trackWidth;

                $(window).resize(function () {
                    var trackWidth = $(element).width() < scope.minWidth;
                    if (trackWidth !== scope.prevTrackWidth) {
                        scope.$apply(function () {
                            scope.trackWidth = trackWidth;
                        });
                    }
                    scope.prevTrackWidth = trackWidth;
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('scrollPosition', scrollPosition);

    function scrollPosition() {
        "ngInject";
        return {
            scope: {
                scrollPosition: '=',
                maxHeight: '='
            },
            link: function (scope) {
                $(window).on('scroll', function () {
                    var scrollTop = $(window).scrollTop() > scope.maxHeight;
                    if (scrollTop !== scope.prevScrollTop) {
                        scope.$apply(function () {
                            scope.scrollPosition = scrollTop;
                        });
                    }
                    scope.prevScrollTop = scrollTop;
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('ngFileSelect', ngFileSelect);

    function ngFileSelect() {
        "ngInject";
        return {
            link: function ($scope, el) {
                el.bind('change', function (e) {
                    $scope.file = (e.srcElement || e.target).files[0];
                    $scope.getFile();
                })
            }
        }
    }

})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('ionSlider', ionSlider);

    function ionSlider($timeout) {
        "ngInject";
        return {
            restrict: 'EA',
            template: '<div></div>',
            replace: true,
            scope: {
                min: '=',
                max: '=',
                type: '@',
                prefix: '@',
                maxPostfix: '@',
                prettify: '=',
                prettifySeparator: '@',
                grid: '=',
                gridMargin: '@',
                postfix: '@',
                step: '@',
                hideMinMax: '@',
                hideFromTo: '@',
                from: '=',
                to: '=',
                disable: '=',
                onChange: '=',
                onFinish: '=',
                values: '=',
                timeout: '@'
            },
            link: function ($scope, $element) {
                $element.ionRangeSlider({
                    min: $scope.min,
                    max: $scope.max,
                    type: $scope.type,
                    prefix: $scope.prefix,
                    maxPostfix: $scope.maxPostfix,
                    prettify_enabled: $scope.prettify,
                    prettify_separator: $scope.prettifySeparator,
                    grid: $scope.grid,
                    gridMargin: $scope.gridMargin,
                    postfix: $scope.postfix,
                    step: $scope.step,
                    hideMinMax: $scope.hideMinMax,
                    hideFromTo: $scope.hideFromTo,
                    from: $scope.from,
                    to: $scope.to,
                    disable: $scope.disable,
                    onChange: $scope.onChange,
                    onFinish: $scope.onFinish,
                    values: $scope.values
                });

                $scope.$watch('min', function (value) {
                    $timeout(function () {
                        $element.data("ionRangeSlider").update({min: value});
                    });
                }, true);
                $scope.$watch('max', function (value) {
                    $timeout(function () {
                        $element.data("ionRangeSlider").update({max: value});
                    });
                });
                $scope.$watch('from', function (value) {
                    $timeout(function () {
                        $element.data("ionRangeSlider").update({from: value});
                    });
                });
                $scope.$watch('to', function (value) {
                    $timeout(function () {
                        $element.data("ionRangeSlider").update({to: value});
                    });
                });
                $scope.$watch('disable', function (value) {
                    $timeout(function () {
                        $element.data("ionRangeSlider").update({disable: value});
                    });
                });
            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('includeWithScope', includeWithScope);

    function includeWithScope() {
        "ngInject";
        return {
            restrict: 'AE',
            templateUrl: function (ele, attrs) {
                return attrs.includeWithScope;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('autoFocus', autoFocus);

    function autoFocus($timeout, $parse) {
        "ngInject";
        return {
            link: function (scope, element, attrs) {
                var model = $parse(attrs.autoFocus);
                scope.$watch(model, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                            element[0].select();
                        });
                    }
                });
                element.bind('blur', function () {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    }

})();
/**
 * Auto expand textarea field
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('autoExpand', autoExpand);

    function autoExpand() {
        "ngInject";
        return {
            restrict: 'A',
            link: function ($scope, elem) {
                elem.bind('keydown', function ($event) {
                    var element = $event.target;
                    $(element).height(0);
                    var height = $(element)[0].scrollHeight;
                    height = (height < 16) ? 16 : height;
                    $(element).height(height);
                });

                // Expand the textarea as soon as it is added to the DOM
                setTimeout(function () {
                    var element = elem;
                    $(element).height(0);
                    var height = $(element)[0].scrollHeight;
                    height = (height < 16) ? 16 : height;
                    $(element).height(height);
                }, 0)
            }
        };
    }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('animatedChange', animatedChange);

    function animatedChange($timeout) {
        "ngInject";
        return {
            link: function (scope, element) {
                $timeout(function () {
                    var newValue = element.attr('new-value');
                    var oldvalue = parseInt(element.html());

                    function changeValue(val) {
                        $timeout(function () {
                            element.html(val);
                        }, 30);
                    }

                    if (newValue > oldvalue) {
                        for (var i = oldvalue; i <= newValue; i++) {
                            changeValue(i);
                        }
                    } else {
                        for (var j = oldvalue; j >= newValue; j--) {
                            changeValue(j);
                        }
                    }
                    $timeout(function () {
                        element.next().find('i').addClass('show-arr');
                    }, 500);
                }, 3500);
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .config(toastrLibConfig);

    function toastrLibConfig(toastrConfig) {
        "ngInject";
        angular.extend(toastrConfig, {
            closeButton: true,
            closeHtml: '<button>&times;</button>',
            timeOut: 5000,
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 0,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ppr', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('ppr', {
                url: '/ppr',
                templateUrl: 'app/pages/ppr/requests.html',
                title: 'PPR',
                sidebarMeta: {
                    icon: 'fa fa-id-card',
                    order: 54,
                },
                controller: 'RequestsCtrl',
                resolve: {
                    requests: ['Requests', '$filter',
                        function (Requests, $filter) {
                            var date = new Date();
                            date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                            return Requests.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                        var d2 = new Date(date);
                        d2.setDate(1);
                        return {
                            'startDate': d2,
                            'endDate': date
                        };
                    }
                }
            });
    }

})();

angular.module('BlurAdmin.pages.ppr')
    .factory('Requests', ['$resource', function ($resource) {
        return $resource('api/ppr/requests/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.forEach(function (request) {
                            request.arrival = new Date(request.arrival);
                            request.departure = new Date(request.departure);
                        });
                        return data;
                    }
                },
                update: {
                    method: 'PUT'
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.ppr')
    .controller('RequestsCtrl',
        ['$scope', '$uibModal', 'requests', 'dates', 'Requests',
            function ($scope, $uibModal, requests, dates, Requests) {
                $scope.requests = requests;
                $scope.dates = dates;

                $scope.getRequests = function (dates) {
                    $scope.requests = Requests.query(dates);
                };

                $scope.delete = function (request) {
                    request.$delete().then(function () {
                        $scope.requests = Requests.query(dates);
                    });
                };

                $scope.openModal = function (request) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/ppr/request.modal.html',
                        controller: 'RequestModalCtrl',
                        resolve: {
                            request: function () {
                                return angular.copy(request);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.requests = Requests.query(dates);
                    });

                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/ppr/info.modal.html'
                    })
                };

            }]).controller('RequestModalCtrl',
    ['$scope', '$uibModalInstance', 'request',
        function ($scope, $uibModalInstance, request) {
            $scope.data = {};

            $scope.request = request;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (request) {
                request.$update().then(function () {
                    $uibModalInstance.close();
                });
            };
        }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.orders', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('orders', {
                url: '/orders',
                templateUrl: 'app/pages/orders/orders.html',
                title: 'Provlektioner',
                sidebarMeta: {
                    icon: 'fa fa-gift',
                    order: 60,
                },
                controller: 'OrdersCtrl',
                resolve: {
                    orders: ['Orders',
                        function (Orders) {
                            return Orders.query();
                        }]
                }
            });
    }
})();
angular.module('BlurAdmin.pages.orders')
    .factory('Orders', ['$resource', function ($resource) {
        return $resource('api/orders/:id', {id: '@id'}, {
            query: {
                method: 'GET',
                isArray: true,
                transformResponse: function (response) {
                    var data = angular.fromJson(response);
                    data.forEach(function (order) {
                        order.purchased_at = new Date(order.purchased_at);
                        if (order.booked_at) order.booked_at = new Date(order.booked_at);
                        if (order.used_at) order.used_at = new Date(order.used_at);
                        order.expires = new Date(order.expires);
                    });
                    return data;
                }
            },
            update: {
                method: 'PUT'
            },
            sendMail: {
                method: 'PUT',
                url: 'api/orders/:id/sendMail'
            }
        });
    }
    ]);
angular.module('BlurAdmin.pages.orders')
    .controller('OrdersCtrl',
        ['$scope', '$uibModal', 'orders', 'Orders',
            function ($scope, $uibModal, orders, Orders) {
                $scope.orders = orders;
                $scope.filter = {searchText: null, showUsed: false};

                $scope.openModal = function (order) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/orders/order.modal.html',
                        controller: 'OrderModalCtrl',
                        resolve: {
                            order: function () {
                                if (order === undefined) {
                                    return {
                                        code: 'Koden genereras automatiskt'
                                    };
                                }
                                return angular.copy(order);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.orders = Orders.query();
                    });

                };

                $scope.delete = function (order) {
                    order.$delete().then(function () {
                        $scope.orders = Orders.query();
                    });
                };

                $scope.showUsedFilter = function (order) {
                    if ($scope.filter.showUsed) return true;
                    return !order.used && !order.has_expired;
                };

                $scope.openQuestionModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/orders/question.modal.html'
                    })
                };

                $scope.openInfoModal = function (orders) {
                    $uibModal.open({
                        templateUrl: 'app/pages/orders/info.modal.html',
                        controller: ['$scope', 'orders', function($scope, orders){
                            $scope.orders = orders;
                        }],
                        resolve: {
                            orders: function(){
                                return orders;
                            }
                        }
                    })
                };

            }])
    .controller('OrderModalCtrl',
        ['$scope', '$uibModalInstance', 'order', 'Orders', '$window',
            function ($scope, $uibModalInstance, order, Orders, $window) {
                $scope.isNew = order.id === undefined;
                $scope.order = order;

                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

                $scope.save = function (order) {
                    if (order.id === undefined) {
                        Orders.save(order, function (order) {
                            if ($window.confirm('Vill du även skicka instruktionsmail?')) {
                                Orders.sendMail(order, function () {
                                    $uibModalInstance.close();
                                });
                            } else {
                                $uibModalInstance.close();
                            }
                        });
                    } else {
                        order.$update().then(function () {
                            $uibModalInstance.close();
                        });
                    }
                };

                $scope.sendMail = function (order) {
                    order.$sendMail().then(function () {
                        $uibModalInstance.close();
                    });
                };

            }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.login', ['ngCookies'])
        .run(authBootstrap)
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('login', {
                url: '/login',
                title: 'Logga in',
                templateUrl: 'auth.html',
                controller: 'LoginCtrl'
            })
            .state('logout', {
                url: '/logout',
                controller: function ($http, $state, $rootScope) {
                    $http.post('api/logout').then(
                        function () {
                            $rootScope.$isLoggedIn = false;
                            $state.go('login');
                        },
                        function () {
                            //TODO: FIX
                        }
                    )
                }
            })
            .state('reset', {
                url: '/password/reset/{token}',
                controller: 'LoginCtrl',
                templateUrl: 'reset.html'
            })
        ;
    }

    function authBootstrap($rootScope, $cookies, $state) {
        "ngInject";
        var user = $cookies.getObject('user');
        if (!!user) {
            $rootScope.user = user;
            $rootScope.$isLoggedIn = true;
        } else {
            $rootScope.$isLoggedIn = false;
            $state.go('login');
        }
    }
})();
angular.module('BlurAdmin.pages.login')
    .controller('LoginCtrl', function ($scope, $http, $rootScope, $state, $cookies, $stateParams, toastr) {
        $scope.login = function (credentials) {
            $http.post('api/login', credentials).then(function (response) {
                $rootScope.user = response.data;
                $rootScope.$isLoggedIn = true;
                $state.go('dashboard');
            }, function (response) {
                $rootScope.user = null;
                toastr.error(response.data.message);
            });
        };

        $scope.sendResetLink = function (data) {
            $http.post('api/password/sendResetLink', data).then(function (response) {
                toastr.success('Återställningslänk har mailats');
            }, function (response) {
                toastr.error('Emailadressen kan inte hittas');
            });
        };

        $scope.resetPassword = function (data) {
            $http.post('api/password/reset', {
                token: $stateParams.token,
                email: data.email,
                password: data.password,
                password_confirmation: data.password_confirmation
            }).then(function (response) {
                $rootScope.user = response.data;
                $rootScope.$isLoggedIn = true;
                $state.go('dashboard');
            }, function (response){
                toastr.error('Något gick fel, försök igen');
            });
        }
    });
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dagbesked', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('dagbesked', {
                url: '/dagbesked/records',
                templateUrl: 'app/pages/dagbesked/records.html',
                title: 'Dagbesked',
                sidebarMeta: {
                    icon: 'fa fa-credit-card',
                    order: 50,
                },
                controller: 'RecordsCtrl',
                resolve: {
                    records: ['Records', '$filter',
                        function (Records, $filter) {
                            var date = new Date();
                            date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                            return Records.query({
                                'startDate': $filter('date')(date, 'yyyy-MM-01'),
                                'endDate': $filter('date')(date, 'yyyy-MM-dd')
                            });
                        }],
                    dates: function () {
                        var date = new Date();
                        date.setFullYear(date.getFullYear(), date.getMonth(), 0);
                        var d2 = new Date(date);
                        d2.setDate(1);
                        return {
                            'startDate': d2,
                            'endDate': date
                        };
                    }
                }
            });
    }

})();

angular.module('BlurAdmin.pages.dagbesked')
    .factory('Records', ['$resource', function ($resource) {
        return $resource('api/dagbesked/records/:id', {id: '@id'}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (response) {
                        var data = angular.fromJson(response);
                        data.forEach(function (record) {
                            record.date = new Date(record.date);
                        });
                        return data;
                    }
                },
                update: {
                    method: 'PUT'
                },
                importFlights: {
                    method: 'POST',
                    url: 'api/dagbesked/records/import.flights'
                },
                lockInvoices: {
                    method: 'PUT',
                    url: 'api/dagbesked/records/invoices'
                },
                lockPeriod: {
                    method: 'PUT',
                    url: 'api/dagbesked/records/lockPeriod'
                },
                unlockPeriod: {
                    method: 'PUT',
                    url: 'api/dagbesked/records/unlockPeriod'
                }
            }
        );
    }
    ]);
angular.module('BlurAdmin.pages.dagbesked')
    .controller('RecordsCtrl',
        ['$scope', '$uibModal', '$http', 'records', 'toastr', 'dates', 'Records', 'Instructors',
            function ($scope, $uibModal, $http, records, toastr, dates, Records, Instructors) {
                $scope.records = records;
                $scope.dates = dates;

                $scope.getRecords = function (dates) {
                    $scope.records = Records.query(dates);
                };

                $scope.delete = function (record) {
                    record.$delete().then(function () {
                        $scope.records = Records.query(dates);
                    });
                };

                $scope.importFlights = function (dates) {
                    Records.importFlights(dates, function () {
                        $scope.records = Records.query(dates);
                        if (confirm("Vill du även uppdatera spärrdatum för import till " + dates.endDate.toISOString().substr(0, 10) + "?")) {
                            $http.put('api/admin/settings/updateDagbeskedDate', {date: dates.endDate.toISOString()}).then(function () {
                                toastr.success('Datum uppdaterat!');
                            });
                        }
                    });
                };

                $scope.lockInvoices = function (dates) {
                    Records.lockInvoices(dates, function () {
                        $scope.records = Records.query(dates);
                    });
                };

                $scope.lockPeriod = function (dates) {
                    Records.lockPeriod(dates, function () {
                        $scope.records = Records.query(dates);
                    });
                };

                $scope.unlockPeriod = function (dates) {
                    Records.unlockPeriod(dates, function () {
                        $scope.records = Records.query(dates);
                    });
                };

                $scope.openModal = function (record) {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/pages/dagbesked/record.modal.html',
                        controller: 'RecordModalCtrl',
                        resolve: {
                            record: function () {
                                return angular.copy(record);
                            },
                            instructors: function () {
                                return Instructors.query();
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.records = Records.query(dates);
                    });

                };

                $scope.showInfo = function (record) {
                    $uibModal.open({
                        templateUrl: 'app/pages/dagbesked/record-info.modal.html',
                        controller: 'RecordInfoModalCtrl',
                        resolve: {
                            record: function () {
                                return record;
                            }
                        }
                    });
                };

                $scope.openInfoModal = function () {
                    $uibModal.open({
                        templateUrl: 'app/pages/dagbesked/info.modal.html'
                    })
                };

            }]).controller('RecordModalCtrl',
    ['$scope', '$uibModalInstance', 'record', 'instructors',
        function ($scope, $uibModalInstance, record, instructors) {
            $scope.data = {};

            $scope.record = record;
            $scope.instructors = instructors;

            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            $scope.save = function (record) {
                angular.forEach(record.transactions, function (transaction) {
                    if (transaction.debet > 0) {
                        transaction.amount = transaction.debet;
                    } else {
                        transaction.amount = transaction.kredit * -1;
                    }
                });
                record.$update().then(function () {
                    $uibModalInstance.close();
                });
            };
        }])
    .controller('RecordInfoModalCtrl',
        ['$scope', '$uibModalInstance', 'record', function ($scope, $uibModalInstance, record) {
            $scope.record = record;

            $scope.close = function () {
                $uibModalInstance.close();
            };
        }])
;
angular.module('BlurAdmin.commons.interceptors', [])
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('authHttpResponseInterceptor');
        $httpProvider.interceptors.push('errorHttpResponseInterceptor');
        $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
    });
angular.module('BlurAdmin.commons.interceptors')
    .factory('errorHttpResponseInterceptor', function ($q, $injector) {
        return {
            responseError: function (rejection) {
                if (rejection.status !== 406 && rejection.status !== 401) {
                    var scope = $injector.get('$rootScope').$new();
                    scope.error = rejection.data;
                    $injector.get('$uibModal').open({
                        template: '<div class="modal-header"><h4 class="modal-title">{{error.heading || "Okänt fel"}}</h4></div><div class="modal-body">{{error.message || "Ett okänt fel har inträffat, försök igen eller kontakta admin om felet kvarstår."}}</div>',
                        scope: scope
                    });
                }
                return $q.reject(rejection);
            }
        };
    });
angular.module('BlurAdmin.commons.interceptors')
    .factory('authHttpResponseInterceptor', function ($q, $injector, $rootScope, $cookies) {
        return {
            responseError: function (rejection) {
                if (rejection.status === 401 && rejection.config.url !== "api/login") {
                    $cookies.remove('user');
                    $rootScope.$isLoggedIn = false;
                    $injector.get('$state').go('login');
                }
                return $q.reject(rejection);
            }
        };
    });
angular.module('BlurAdmin.commons', ['BlurAdmin.commons.interceptors']);
angular.module('BlurAdmin.commons')
    .filter("total", function () {
        return function (items, field) {
            var total = 0, i = 0;
            for (i = 0; i < items.length; i++) total += items[i][field];
            return total;
        };
    });
angular.module('BlurAdmin.commons')
    .filter('sumOfValue', function () {
        return function (data, key) {
            if (typeof (data) === 'undefined' || typeof (key) === 'undefined') {
                return 0;
            }
            var sum = 0;
            for (var i = 0; i < data.length; i++) {
                sum = sum + (parseFloat(data[i][key]) || 0);
            }
            return sum;
        };
    });
angular.module('BlurAdmin.commons')
    .filter('noGreaterThanZero', function () {
        return function (data, key) {
            if (typeof (data) === 'undefined' || typeof (key) === 'undefined') {
                return 0;
            }
            var sum = 0;
            for (var i = 0; i < data.length; i++) {
                if ((parseFloat(data[i][key]) || 0) > 0) {
                    sum += 1;
                }
            }
            return sum;
        };
    });
angular.module('BlurAdmin.commons')
    .directive('transactionsEditor', function (AdminAccounts) {
        return {
            restrict: 'E',
            templateUrl: 'app/commons/partials/transactionsEditor.tpl.html',
            scope: {
                transactions: '=ngModel',
                amount: '='
            },
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                scope.accounts = AdminAccounts.query();
                scope.$watch('transactions', function (transactions) {
                    var sum = 0;
                    var amount = 0;
                    transactions.forEach(function (transaction) {
                        if (transaction.debet > 0) {
                            sum += transaction.debet;
                            amount += transaction.debet;
                        } else {
                            sum -= transaction.kredit;
                            amount += transaction.kredit;
                        }
                    });
                    if (sum === 0) {
                        if (transactions.length !== 0) {
                            scope.amount = amount / 2;
                        }
                        ctrl.$setValidity('sumIsZero', true);
                    } else {
                        ctrl.$setValidity('sumIsZero', false);
                    }
                }, true);

                scope.remove = function (index) {
                    scope.transactions.splice(index, 1);
                };
            }
        };
    });
angular.module('BlurAdmin.commons')
    .directive('smartFloat', function () {
        var FLOAT_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.float = function (value) {
                    return FLOAT_REGEXP.test(value) || !value;
                };

                ctrl.$parsers.unshift(function (viewValue) {
                    if (FLOAT_REGEXP.test(viewValue)) {
                        if (typeof viewValue === "number")
                            return viewValue;
                        else
                            return parseFloat(viewValue.replace(',', '.'));
                    }
                    return viewValue;
                });
            }
        };
    });
angular.module('BlurAdmin.commons')
    .directive('pushToArray', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.bind('click', function () {
                    var array = scope.$eval(attrs.pushToArray);
                    scope.$apply(function () {
                        array.push({});
                    });
                });
            }
        };
    });
angular.module('BlurAdmin.commons')
    .directive('prompt', [
        function () {
            return {
                scope: {
                    prompt: '='
                },
                link: function (scope, element, attr) {
                    var msg = attr.promptMessage || "Ange:";
                    element.bind('click', function () {
                        scope.prompt = prompt(msg);
                        scope.$apply();
                    });
                }
            };
        }]);
angular.module('BlurAdmin.commons')
    .directive('ngConfirmClick', [
        function () {
            return {
                link: function (scope, element, attr) {
                    var msg = attr.ngConfirmClick || "Are you sure?";
                    var clickAction = attr.confirmedClick;
                    element.bind('click', function (event) {
                        if (window.confirm(msg)) {
                            scope.$eval(clickAction);
                        } else {
                            event.preventDefault();
                        }
                    });
                }
            };
        }]);

angular.module('BlurAdmin.commons')
    .directive('pwdMatch', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                pwdMatch: '='
            },
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch(function () {
                    return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || scope.pwdMatch === ctrl.$modelValue;
                }, function (currentValue) {
                    ctrl.$setValidity('match', currentValue);
                });
            }
        };
    });
angular.module('BlurAdmin.commons')
    .directive('convertToNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function (val) {
                    return '' + val;
                });
            }
        };
    });
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('themeLayoutSettings', themeLayoutSettings);

    function themeLayoutSettings(baConfig) {
        "ngInject";
        var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
        var mobileClass = isMobile ? 'mobile' : '';
        var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
        angular.element(document.body).addClass(mobileClass).addClass(blurClass);

        return {
            blur: baConfig.theme.blur,
            mobile: isMobile,
        }
    }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .run(themeRun);

    function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
        "ngInject";
        var whatToWait = [];

        var theme = themeLayoutSettings;
        if (theme.blur) {
            if (theme.mobile) {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
            } else {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
            }
        }

        $q.all(whatToWait).then(function () {
            $rootScope.$pageFinishedLoading = true;
        });

        $timeout(function () {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 7000);

        $rootScope.$baSidebarService = baSidebarService;
    }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('BlurAdmin.theme')
        .constant('layoutSizes', {
            resWidthCollapseSidebar: 1200,
            resWidthHideSidebar: 1200
        })
        .constant('layoutPaths', {
            images: {
                root: IMAGES_ROOT,
                profile: IMAGES_ROOT + 'app/profile/'
            }
        })
        .constant('colorHelper', {
            tint: function (color, weight) {
                return mix('#ffffff', color, weight);
            },
            shade: function (color, weight) {
                return mix('#000000', color, weight);
            },
        });

    function shade(color, weight) {
        return mix('#000000', color, weight);
    }

    function tint(color, weight) {
        return mix('#ffffff', color, weight);
    }

    //SASS mix function
    function mix(color1, color2, weight) {
        // convert a decimal value to hex
        function d2h(d) {
            return d.toString(16);
        }

        // convert a hex value to decimal
        function h2d(h) {
            return parseInt(h, 16);
        }

        var result = "#";
        for (var i = 1; i < 7; i += 2) {
            var color1Part = h2d(color1.substr(i, 2));
            var color2Part = h2d(color2.substr(i, 2));
            var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
            result += ('0' + resultPart).slice(-2);
        }
        return result;
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    var basic = {
        default: '#ffffff',
        defaultText: '#666666',
        border: '#dddddd',
        borderDark: '#aaaaaa',
    };

    // main functional color scheme
    var colorScheme = {
        primary: '#209e91',
        info: '#2dacd1',
        success: '#90b900',
        warning: '#dfb81c',
        danger: '#e85656',
    };

    // dashboard colors for charts
    var dashboardColors = {
        blueStone: '#005562',
        surfieGreen: '#0e8174',
        silverTree: '#6eba8c',
        gossip: '#b9f2a1',
        white: '#10c4b5',
    };

    angular.module('BlurAdmin.theme')
        .provider('baConfig', configProvider);

    function configProvider(colorHelper) {
        "ngInject";
        var conf = {
            theme: {
                blur: false,
            },
            colors: {
                default: basic.default,
                defaultText: basic.defaultText,
                border: basic.border,
                borderDark: basic.borderDark,

                primary: colorScheme.primary,
                info: colorScheme.info,
                success: colorScheme.success,
                warning: colorScheme.warning,
                danger: colorScheme.danger,

                primaryLight: colorHelper.tint(colorScheme.primary, 30),
                infoLight: colorHelper.tint(colorScheme.info, 30),
                successLight: colorHelper.tint(colorScheme.success, 30),
                warningLight: colorHelper.tint(colorScheme.warning, 30),
                dangerLight: colorHelper.tint(colorScheme.danger, 30),

                primaryDark: colorHelper.shade(colorScheme.primary, 15),
                infoDark: colorHelper.shade(colorScheme.info, 15),
                successDark: colorHelper.shade(colorScheme.success, 15),
                warningDark: colorHelper.shade(colorScheme.warning, 15),
                dangerDark: colorHelper.shade(colorScheme.danger, 15),

                dashboard: {
                    blueStone: dashboardColors.blueStone,
                    surfieGreen: dashboardColors.surfieGreen,
                    silverTree: dashboardColors.silverTree,
                    gossip: dashboardColors.gossip,
                    white: dashboardColors.white,
                },
            }
        };

        conf.changeTheme = function (theme) {
            angular.merge(conf.theme, theme)
        };

        conf.changeColors = function (colors) {
            angular.merge(conf.colors, colors)
        };

        conf.$get = function () {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .config(config);

    function config(baConfigProvider, colorHelper) {
        "ngInject";
        //baConfigProvider.changeTheme({blur: true});
        //
        //baConfigProvider.changeColors({
        //  default: 'rgba(#000000, 0.2)',
        //  defaultText: '#ffffff',
        //  dashboard: {
        //    white: '#ffffff',
        //  },
        //});
    }
})();

'use strict';

angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    'ui.slimscroll',

    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'BlurAdmin.commons',

    'angularUtils.directives.dirPagination',
    'ngResource',
    'ng-currency',
    'ngMessages',
    'highcharts-ng',
    'angular.filter',
    'angular-loading-bar'
]);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.stats', [
        'BlurAdmin.pages.stats.landings',
        'BlurAdmin.pages.stats.flighthours',
        'BlurAdmin.pages.stats.flightcodestats'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('stats', {
                url: '/stats',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Statistik',
                sidebarMeta: {
                    icon: 'fa fa-calculator',
                    order: 69,
                },
            });
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.salaries', [
        'BlurAdmin.pages.salaries.tariffs',
        'BlurAdmin.pages.salaries.flightTypes',
        'BlurAdmin.pages.salaries.breakdown',
        'BlurAdmin.pages.salaries.instructors'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('salaries', {
                url: '/salaries',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Löner',
                sidebarMeta: {
                    icon: 'fa fa-credit-card',
                    order: 35,
                },
            });
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.saab', [
        'BlurAdmin.pages.saab.invoice',
        'BlurAdmin.pages.saab.accounts'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('saab', {
                url: '/saab',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Saabflygningar',
                sidebarMeta: {
                    icon: 'fa fa-fighter-jet',
                    order: 30,
                },
            });
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.kiosk', [
        'BlurAdmin.pages.kiosk.purchases',
        'BlurAdmin.pages.kiosk.products'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('kiosk', {
                url: '/kiosk',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Kiosk',
                sidebarMeta: {
                    icon: 'fa fa-coffee',
                    order: 10,
                },
            });
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.jour', [
        'BlurAdmin.pages.jour.signs',
        'BlurAdmin.pages.jour.workgroups',
        'BlurAdmin.pages.jour.overview',
        'BlurAdmin.pages.jour.check'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('jour', {
                url: '/jour',
                template: '<ui-view></ui-view>',
                title: 'Jour',
                sidebarMeta: {
                    icon: 'fa fa-eye',
                    order: 20,
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.fuel', [
        'BlurAdmin.pages.fuel.log',
        'BlurAdmin.pages.fuel.keys',
        'BlurAdmin.pages.fuel.readings',
        'BlurAdmin.pages.fuel.deliveries',
        'BlurAdmin.pages.fuel.reports',
        'BlurAdmin.pages.fuel.checks',
        'BlurAdmin.pages.fuel.pricing',
        'BlurAdmin.pages.fuel.stats',
        'BlurAdmin.pages.fuel.dispensings',
        'BlurAdmin.pages.fuel.invoicing',
        'BlurAdmin.pages.fuel.taxreturn',
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('fuel', {
                url: '/fuel',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Bränsle',
                sidebarMeta: {
                    icon: 'fa fa-truck',
                    order: 40,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                title: 'Dashboard',
            });
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.brandflyg', [
        'BlurAdmin.pages.brandflyg.invoice',
        'BlurAdmin.pages.brandflyg.rescuers',
        'BlurAdmin.pages.brandflyg.reports'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('brandflyg', {
                url: '/brandflyg',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Brandflyg',
                sidebarMeta: {
                    icon: 'fa fa-fire',
                    order: 70,
                },
            });
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.admin', [
        'BlurAdmin.pages.admin.users',
        'BlurAdmin.pages.admin.settings',
        'BlurAdmin.pages.admin.events',
        'BlurAdmin.pages.admin.heaters',
        'BlurAdmin.pages.admin.aircraft',
        'BlurAdmin.pages.admin.accounts',
        'BlurAdmin.pages.admin.depkaps',
        'BlurAdmin.pages.admin.insurance',
        'BlurAdmin.pages.admin.budget'
    ])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        "ngInject";
        $stateProvider
            .state('admin', {
                url: '/admin',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'Administration',
                sidebarMeta: {
                    icon: 'fa fa-cog',
                    order: 80,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
        'ui.router',

        'BlurAdmin.pages.dashboard',
        'BlurAdmin.pages.kiosk',
        'BlurAdmin.pages.brandflyg',
        'BlurAdmin.pages.jour',
        'BlurAdmin.pages.fuel',
        'BlurAdmin.pages.dagbesked',
        'BlurAdmin.pages.saab',
        'BlurAdmin.pages.orders',
        'BlurAdmin.pages.admin',
        'BlurAdmin.pages.login',
        'BlurAdmin.pages.salaries',
        'BlurAdmin.pages.ppr',
        'BlurAdmin.pages.stats'
    ])
        .config(routeConfig);


    function routeConfig($urlRouterProvider, $locationProvider, $compileProvider, $httpProvider) {
        "ngInject";
        $urlRouterProvider.otherwise('/dashboard');
        $locationProvider.html5Mode(true);
        $compileProvider.debugInfoEnabled(false);
        $httpProvider.useApplyAsync(true);
    }

})
();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/commons/partials/dirPagination.tpl.html','<ul class="pagination" ng-if="1 < pages.length || !autoHide">\n    <li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }">\n        <a href="" ng-click="setCurrent(1)">&laquo;</a>\n    </li>\n    <li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }">\n        <a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a>\n    </li>\n    <li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }">\n        <a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a>\n    </li>\n\n    <li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }">\n        <a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a>\n    </li>\n    <li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == pagination.last }">\n        <a href="" ng-click="setCurrent(pagination.last)">&raquo;</a>\n    </li>\n</ul>');
$templateCache.put('app/commons/partials/profile.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">\xC4ndra profil</h4>\n</div>\n<div class="modal-body">\n    <form name="profileForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : profileForm.email.$invalid && !profileForm.email.$pristine}">\n            <label for="email">Mailadress</label>\n            <input id="email" name="email" class="form-control" type="email" ng-model="user.email" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : profileForm.password.$invalid}">\n            <label for="password">L\xF6senord (minimum 6 tecken)</label>\n            <input id="password" name="password" class="form-control" type="password" ng-model="user.password">\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : profileForm.password_confirmation.$invalid}">\n            <label for="password_confirmation">Bekr\xE4fta l\xF6senord</label>\n            <input id="password_confirmation" name="password_confirmation" class="form-control" type="password" ng-model="user.password_confirmation" ng-disabled="user.password == null || user.password == \'\'" pwd-match="user.password">\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(user)" ng-disabled="profileForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/commons/partials/transactionsEditor.tpl.html','<table class="table">\n    <thead>\n    <tr>\n        <th>Konto</th>\n        <th>Debet</th>\n        <th>Kredit</th>\n        <th></th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat="transaction in transactions">\n        <td>\n            <input placeholder="Konto" class="form-control" type="number" ng-model="transaction.account" uib-typeahead="account.number as (account.number + \' \' + account.name) for account in accounts | filter:$viewValue | limitTo:15" min="1000" max="9999" required>\n        </td>\n        <td>\n            <input placeholder="Debet" class="form-control" type="text" ng-model="transaction.debet" min="0" ng-currency ng-disabled="!!transaction.kredit">\n        </td>\n        <td>\n            <input placeholder="Kredit" class="form-control" type="text" ng-model="transaction.kredit" min="0" ng-currency ng-disabled="!!transaction.debet">\n        </td>\n        <td>\n            <button type="button" ng-click="remove($index)" class="btn btn-xs btn-danger"><span class="glyphicon glyphicon-remove"></span></button>\n        </td>\n    </tr>\n    </tbody>\n</table>');
$templateCache.put('app/pages/dagbesked/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad rad \xE4r en rad som \xE4nnu inte exporterats.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad rad \xE4r en rad som har exporterats.\n    </div>\n</div>');
$templateCache.put('app/pages/dagbesked/record-info.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Information</h4>\n</div>\n<div class="modal-body">\n    <label>Datum</label>\n    <p>{{::record.date | date:\'shortDate\'}}</p>\n    <label>Pilotnummer</label>\n    <p>{{::record.pilot_nr || \'-\'}}</p>\n    <label>Kommentar</label>\n    <p>{{::record.comment}}</p>\n    <label>Instrukt\xF6r</label>\n    <p>{{::record.instructor.name || \'-\'}}</p>\n    <label>Flygplan</label>\n    <p>{{::record.aircraft || \'-\'}}</p>\n    <label>Tacho</label>\n    <p>{{::record.tacho || \'-\'}}</p>\n    <label>Belopp</label>\n    <p>{{::record.amount | currency:\'kr\'}}</p>\n    <label>Kontering (export till: {{::record.typeText}})</label>\n    <table class="table">\n        <thead>\n        <tr>\n            <th>Konto</th>\n            <th>Debet</th>\n            <th>Kredit</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="transaction in record.transactions">\n            <td>{{::transaction.account}}</td>\n            <td>{{::transaction.debet}}</td>\n            <td>{{::transaction.kredit}}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/dagbesked/record.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">\xC4ndra rad</h4>\n</div>\n<div class="modal-body">\n    <form name="recordForm" novalidate>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : recordForm.date.$invalid && !recordForm.date.$pristine}">\n                <label for="date">Datum</label>\n                <input id="date" name="date" class="form-control" type="date" ng-model-options="{timezone : \'UTC\'}" ng-model="record.date" required>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : recordForm.pilot_nr.$invalid && !recordForm.pilot_nr.$pristine}">\n                <label for="pilot_nr">Pilotnummer</label>\n                <input id="pilot_nr" name="pilot_nr" class="form-control" type="number" ng-model="record.pilot_nr" ng-required="record.type == 1" min="1000" max="9999">\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : recordForm.comment.$invalid && !recordForm.comment.$pristine}">\n            <label for="comment">Kommentar</label>\n            <input id="comment" name="comment" class="form-control" type="text" ng-model="record.comment" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : recordForm.instructor.$invalid && !recordForm.instructor.$pristine}">\n            <label for="instructor">Instrukt\xF6r</label>\n            <select id="instructor" class="form-control" ng-model="record.instructor" ng-options="instructor as instructor.name for instructor in instructors track by instructor.id">\n                <option value="">V\xE4lj instrukt\xF6r</option>\n            </select>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : recordForm.aircraft.$invalid && !recordForm.aircraft.$pristine}">\n                <label for="aircraft">Flygplan</label>\n                <input id="aircraft" name="aircraft" class="form-control" type="text" ng-model="record.aircraft" maxlength="6">\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : recordForm.tacho.$invalid && !recordForm.tacho.$pristine}">\n                <label for="tacho">Tacho</label>\n                <input id="tacho" name="tacho" class="form-control" type="text" ng-model="record.tacho" smart-float>\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : recordForm.amount.$invalid && !recordForm.amount.$pristine}">\n            <label for="amount">Belopp</label>\n            <input id="amount" name="amount" class="form-control" type="text" min="0" ng-model="record.amount" ng-disabled="record.type !== 3" ng-currency required>\n        </div>\n        <div class="form-group" ng-if="record.type != 3">\n            <label>Kontering</label>\n            <transactions-editor ng-model="record.transactions" amount="record.amount"></transactions-editor>\n        </div>\n        <div class="text-center">\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="record.type" uib-btn-radio="1" ng-disabled="record.transactions.length > 2">Till MWL</label>\n                <label class="btn btn-primary" ng-model="record.type" uib-btn-radio="2">Till Visma</label>\n                <label class="btn btn-primary" ng-model="record.type" uib-btn-radio="3" ng-disabled="record.transactions.length !== 0">Faktureras</label>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(record)" ng-disabled="recordForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-warning" push-to-array="record.transactions" ng-disabled="(record.type === 1 && record.transactions.length === 2) || record.type === 3">L\xE4gg till\n            transaktion\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/dagbesked/records.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control">\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" id="endDate" name="endDate" ng-model="dates.endDate" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getRecords(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li><a href="" ng-click="importFlights(dates)" class="text-center"><i class="fa fa-cloud-download"></i> H\xE4mta flygningar</a></li>\n                <li class="divider"></li>\n                <li>\n                    <a href="/api/dagbesked/records/export.csv?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}" target="_blank" ng-confirm-click="Exportera alla rader till CSV?" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Exportera CSV</a></li>\n                <li><a href="/api/dagbesked/records/export.sie?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}" target="_blank" ng-confirm-click="Exportera rader till SIE?" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Exportera\n                    SIE</a></li>\n                <li><a href="" ng-confirm-click="L\xE5s alla faktureringsrader?" confirmed-click="lockInvoices(dates)" class="text-center"><i class="fa fa-lock"></i> L\xE5s faktureringsrader</a></li>\n                <li><a href="/api/dagbesked/records/export.pdf?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}" target="_blank" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a></li>\n                <li class="divider"></li>\n                <li><a href="" ng-confirm-click="L\xE5s perioden angiven period?" confirmed-click="lockPeriod(dates)" class="text-center"><i class="fa fa-lock"></i> L\xE5s period</a></li>\n                <li><a href="" ng-confirm-click="L\xE5s upp angiven period?" confirmed-click="unlockPeriod(dates)" class="text-center"><i class="fa fa-unlock"></i> L\xE5s upp period</a></li>\n            </ul>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-condensed table-hover" st-table="dRecords" st-safe-src="records">\n            <thead>\n            <tr>\n                <th st-sort="date" st-sort-default="reverse">Datum</th>\n                <th st-sort="aircraft">Flygplan</th>\n                <th st-sort="pilot_nr">Pilotnummer</th>\n                <th st-sort="comment">Kommentar</th>\n                <th st-sort="instructor.short">Instrukt\xF6r</th>\n                <th st-sort="tacho">Tacho</th>\n                <th st-sort="amount">Summa</th>\n                <th st-sort="type">Typ</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="record in dRecords" ng-class="{\'success\' : record.exported, \'warning\' : !record.exported}">\n                <td>{{::record.date | date:\'shortDate\'}}</td>\n                <td>{{::record.aircraft}}</td>\n                <td>{{::record.pilot_nr}}</td>\n                <td>{{::record.comment}}</td>\n                <td>{{::record.instructor.short}}</td>\n                <td>{{::record.tacho === null ? \'-\' : record.tacho + \' h\'}}</td>\n                <td>{{::record.amount === null ? \'-\' : record.amount + \' kr\'}}</td>\n                <td>{{::record.typeText}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button class="btn btn-info btn-xs" type="button" ng-click="showInfo(record)" ng-show="record.exported">\n                            <i class="fa fa-info fa-fw"></i>\n                        </button>\n                        <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(record)" ng-disabled="record.exported">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(record)" ng-confirm-click="Radera raden?" ng-disabled="record.exported">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <th colspan="5">Summa</th>\n                <th>{{records | sumOfValue:\'tacho\' | number:1}} h</th>\n                <th colspan="3">{{records | sumOfValue:\'amount\' | currency:\'kr\'}}</th>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/dashboard/dashboard.html','');
$templateCache.put('app/pages/orders/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> Information</span>\n</div>\n<div class="modal-body">\n    <p>\n        <strong>Antal s\xE5lda provlektioner: </strong>{{orders.length}} st.\n    </p>\n    <p>\n        <strong>Antal utest\xE5ende: </strong>{{(orders | filter:{used:false, has_expired:false}).length}} st.\n    </p>\n    <p>\n        <strong>Skuld: </strong>{{orders | filter:{used:false, has_expired:false} | sumOfValue:\'price\' | currency}}\n    </p>\n</div>');
$templateCache.put('app/pages/orders/order.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny order\' : \'Redigera \' + order.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="orderForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : orderForm.name.$invalid && !orderForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="order.name" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : orderForm.email.$invalid && !orderForm.email.$pristine}">\n            <label for="email">Email</label>\n            <input id="email" name="email" class="form-control" type="email" ng-model="order.email" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : orderForm.phone.$invalid && !orderForm.phone.$pristine}">\n            <label for="phone">Telefon</label>\n            <input id="phone" name="phone" class="form-control" type="text" ng-model="order.phone">\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : orderForm.city.$invalid && !orderForm.city.$pristine}">\n            <label for="city">Stad</label>\n            <input id="city" name="city" class="form-control" type="text" ng-model="order.city">\n        </div>\n        <div class="form-group">\n            <label for="code">Kod</label>\n            <input id="code" name="code" class="form-control" type="text" ng-model="order.code" disabled="disabled">\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6">\n                <label for="price">Pris</label>\n                <input type="text" class="form-control" ng-model="order.price" id="price" name="price" min="0" required ng-currency>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="transaction_fee">Transaktionskostnad</label>\n                <input type="text" class="form-control" ng-model="order.transaction_fee" id="transaction_fee" name="transaction_fee" min="0" required ng-currency>\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : orderForm.purchased_at.$invalid && !orderForm.purchased_at.$pristine}">\n            <label for="purchased_at">K\xF6pt</label>\n            <input id="purchased_at" name="purchased_at" class="form-control" type="datetime-local" ng-model="order.purchased_at" ng-disabled="!isNew" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : orderForm.expires.$invalid && !orderForm.expires.$pristine}">\n            <label for="expires">Utg\xE5ngsdatum</label>\n            <input id="expires" name="expires" class="form-control" type="date" ng-model="order.expires" required>\n        </div>\n        <div class="text-center">\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="order.has_booking" uib-btn-radio="true">Har bokat</label>\n                <label class="btn btn-primary" ng-model="order.has_booking" uib-btn-radio="false">Har ej bokat</label>\n            </div>\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="order.used" uib-btn-radio="true">F\xF6rbrukad</label>\n                <label class="btn btn-primary" ng-model="order.used" uib-btn-radio="false">Ej f\xF6rbrukad</label>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(order)" ng-disabled="orderForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-warning" ng-hide="isNew" ng-confirm-click="Vill du verkligen skicka ut instruktionerna igen?" confirmed-click="sendMail(order)">Skicka\n            instruktionsmail\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/orders/orders.html','<div ba-panel>\n    <form class="form-inline text-center" novalidate>\n        <input id="search" class="form-control" placeholder="S\xF6k" style="width: 25%" type="text" ng-model="filter.searchText" autofocus>\n        <button type="button" class="btn btn-warning btn-with-icon" ng-model="filter.showUsed" uib-btn-checkbox>\n            <i ng-class="{\'fa fa-eye\' : !filter.showUsed, \'fa fa-eye-slash\' : filter.showUsed}"></i>\n            {{filter.showUsed ? \'D\xF6lj f\xF6rbrukade\' : \'Visa f\xF6rbrukade\'}}\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li><a href="" ng-click="openModal()" class="text-center"><i class="fa fa-plus"></i> Ny provlektion</a></li>\n                <li class="divider"></li>\n                <li>\n                    <a href="api/orders/export.sie" target="_blank" class="text-center" ng-confirm-click="Samtliga icke-exporterade provlektioner kommer exporteras. Vill du forts\xE4tta?">\n                        <i class="fa fa-floppy-o fa-fw"></i> Skapa SIE\n                    </a>\n                </li>\n            </ul>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-info-circle fa-2x" ng-click="openInfoModal(orders)"></i>\n            <i class="fa fa-question-circle fa-2x" ng-click="openQuestionModal()"></i>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-condensed table-hover" st-table="dOrders" st-safe-src="orders">\n            <thead>\n            <tr>\n                <th st-sort="name">Namn</th>\n                <th st-sort="email">Email</th>\n                <th st-sort="code">Kod</th>\n                <th st-sort="purchased_at" st-sort-default="reverse">K\xF6pt</th>\n                <th st-sort="booked_at">Bokning</th>\n                <th st-sort="used_at">Anv\xE4nd</th>\n                <th st-sort="exported">Exporterad</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="order in dOrders | filter:filter.searchText | filter:showUsedFilter | itemsPerPage: 20" ng-class="{\'info\' : order.has_booking && !order.used, \'danger\' : order.used, \'warning\' : order.has_expired}">\n                <td>{{::order.name}}</td>\n                <td>{{::order.email}}</td>\n                <td>{{::order.code}}</td>\n                <td>{{::order.purchased_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                <td>{{::order.booked_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                <td>{{::order.used_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                <td>{{::order.exported ? \'Ja\' : \'Nej\'}}</td>\n                <td>\n                    <div class="pull-right">\n                        <a class="btn btn-info btn-xs" href="api/orders/{{::order.id}}/pdf" target="_blank"><i class="fa fa-floppy-o fa-fw"></i></a>\n                        <button type="button" class="btn btn-primary btn-xs" ng-disabled="order.used" ng-click="openModal(order)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" ng-disabled="order.used" confirmed-click="delete(order)" ng-confirm-click="Radera {{::order.name}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="8" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/orders/question.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-info">\n        En ljusbl\xE5 provlektion \xE4r en provlektion som har gjort en bokning.\n    </div>\n    <div class="alert bg-warning">\n        En gulmarkerad provlektion \xE4r en provlektion som har g\xE5tt ut.\n    </div>\n    <div class="alert bg-danger">\n        En r\xF6dmarkerad provlektion \xE4r en provlektion som har anv\xE4nts.\n    </div>\n</div>');
$templateCache.put('app/pages/ppr/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad rad \xE4r en rad som \xE4nnu inte exporterats.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad rad \xE4r en rad som har exporterats.\n    </div>\n</div>');
$templateCache.put('app/pages/ppr/record-info.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Information</h4>\n</div>\n<div class="modal-body">\n    <label>Datum</label>\n    <p>{{::record.date | date:\'shortDate\'}}</p>\n    <label>Pilotnummer</label>\n    <p>{{::record.pilot_nr || \'-\'}}</p>\n    <label>Kommentar</label>\n    <p>{{::record.comment}}</p>\n    <label>Instrukt\xF6r</label>\n    <p>{{::record.instructor.name || \'-\'}}</p>\n    <label>Flygplan</label>\n    <p>{{::record.aircraft || \'-\'}}</p>\n    <label>Tacho</label>\n    <p>{{::record.tacho || \'-\'}}</p>\n    <label>Belopp</label>\n    <p>{{::record.amount | currency:\'kr\'}}</p>\n    <label>Kontering (export till: {{::record.typeText}})</label>\n    <table class="table">\n        <thead>\n        <tr>\n            <th>Konto</th>\n            <th>Debet</th>\n            <th>Kredit</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="transaction in record.transactions">\n            <td>{{::transaction.account}}</td>\n            <td>{{::transaction.debet}}</td>\n            <td>{{::transaction.kredit}}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/ppr/request.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;\n    </button>\n    <h4 class="modal-title">\xC4ndra rad</h4>\n</div>\n<div class="modal-body">\n    <form name="requestForm" novalidate>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : requestForm.aircraft.$invalid && !requestForm.aircraft.$pristine}">\n                <label for="aircraft">Registrering</label>\n                <input id="aircraft" name="aircraft" class="form-control text-uppercase" type="text" ng-model="request.aircraft" required>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : requestForm.aircraft_type.$invalid && !requestForm.aircraft_type.$pristine}">\n                <label for="aircraft_type">Flygplanstyp</label>\n                <input id="aircraft_type" name="aircraft_type" class="form-control" type="text" ng-model="request.aircraft_type" required>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : requestForm.arrival.$invalid && !requestForm.arrival.$pristine}">\n                <label for="arrival">Ankomst</label>\n                <input id="arrival" name="arrival" class="form-control" type="datetime-local" ng-model="request.arrival" required>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : requestForm.departure.$invalid && !requestForm.departure.$pristine}">\n                <label for="departure">Avg\xE5ng</label>\n                <input id="departure" name="departure" class="form-control" type="datetime-local" ng-model="request.departure" required>\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : requestForm.name.$invalid && !requestForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="request.name" required>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : requestForm.phone.$invalid && !requestForm.phone.$pristine}">\n                <label for="phone">Telefon</label>\n                <input id="phone" name="phone" class="form-control" type="text" ng-model="request.phone" required>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : requestForm.email.$invalid && !requestForm.email.$pristine}">\n                <label for="email">Email</label>\n                <input id="email" name="departure" class="form-control" type="email" ng-model="request.email" required>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-4" ng-class="{\'has-error\' : requestForm.passengers.$invalid && !requestForm.passengers.$pristine}">\n                <label for="passengers">Passagerare</label>\n                <input id="passengers" name="passengers" class="form-control" type="number" min="0" ng-model="request.passengers" required>\n            </div>\n            <div class="form-group col-md-4" ng-class="{\'has-error\' : requestForm.rooms.$invalid && !requestForm.rooms.$pristine}">\n                <label for="rooms">Rum</label>\n                <select id="rooms" class="form-control" name="rooms" ng-model="request.rooms">\n                    <option value="0">0</option>\n                    <option value="1">1</option>\n                    <option value="2">2</option>\n                    <option value="3">3</option>\n                </select>\n            </div>\n            <div class="form-group col-md-4" ng-class="{\'has-error\' : requestForm.fuel.$invalid && !requestForm.fuel.$pristine}">\n                <label for="fuel">Br\xE4nsle</label>\n                <select id="fuel" class="form-control" name="fuel" ng-model="request.fuel">\n                    <option value="Inget">Inget</option>\n                    <option value="91/96 UL">91/96 UL</option>\n                    <option value="100LL">100LL</option>\n                </select>\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : requestForm.message.$invalid && !requestForm.message.$pristine}">\n            <label for="message">Meddelande</label>\n            <textarea id="message" name="message" class="form-control" ng-model="record.message"></textarea>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(request)" ng-disabled="requestForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/ppr/requests.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control">\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" id="endDate" name="endDate" ng-model="dates.endDate" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getRequests(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li><a href="/api/ppr/requests/export.pdf?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}" target="_blank" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a></li>\n            </ul>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-condensed table-hover" st-table="dRequests" st-safe-src="requests">\n            <thead>\n            <tr>\n                <th st-sort="arrival" st-sort-default="reverse">Ankomst</th>\n                <th st-sort="departure">Avg\xE5ng</th>\n                <th st-sort="aircraft">Registrering</th>\n                <th st-sort="aircraft_type">Typ</th>\n                <th st-sort="name">Namn</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="request in dRequests | itemsPerPage: 20">\n                <td>{{::request.arrival | date:\'short\'}}</td>\n                <td>{{::request.departure | date:\'short\'}}</td>\n                <td>{{::request.aircraft}}</td>\n                <td>{{::request.aircraft_type}}</td>\n                <td>{{::request.name}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(request)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(request)" ng-confirm-click="Radera f\xF6rfr\xE5gan?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="9" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/accounts/account.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Nytt konto\' : \'Redigera konto\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="accountForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.number.$invalid && !accountForm.number.$pristine}">\n            <label for="number">Kontonummer</label>\n            <input id="number" name="number" class="form-control" type="number" min="1000" max="9999" ng-model="account.number" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.name.$invalid && !accountForm.name.$pristine}">\n            <label for="name">Kontonamn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="account.name" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(account)" ng-disabled="accountForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/accounts/accounts.html','<div class="col-md-12" ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()">\n            <i class="fa fa-plus"></i> Nytt konto\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dAccounts" st-safe-src="accounts">\n            <thead>\n            <tr>\n                <th st-sort="number" st-sort-default="true">Kontonummer</th>\n                <th st-sort="name">Namn</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="account in dAccounts | itemsPerPage: 20">\n                <td>{{::account.number}}</td>\n                <td>{{::account.name}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(account)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(account)" ng-confirm-click="Radera {{account.number}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="8" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/accounts/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <p>Styr hur de olika bokningsobjekten ska hanteras av olika delsystem d\xE5 flygningar/bokningar importeras fr\xE5n myWebLog.</p>\n    <ul>\n        <li><strong>Saab: </strong>Flygplanet kan anv\xE4ndas f\xF6r Saabflygningar</li>\n        <li><strong>L\xF6n: </strong>Flygplanet kan anv\xE4ndas f\xF6r skolning i LFK</li>\n        <li><strong>Dagbesked: </strong>Flygningar med flygplanet ing\xE5r i importen till dagbeskedet</li>\n        <li><strong>Landningsrapport: </strong>Flygningar med flygplanet ing\xE5r i landningsrapporten som skickas till Saab</li>\n        <li><strong>Brandflyg: </strong>Flygplanet anv\xE4nds f\xF6r brandflyg i LFK</li>\n        <li><strong>Provlektioner: </strong>Flygplanet kan bokas av kunder som k\xF6pt provlektioner</li>\n    </ul>\n</div>');
$templateCache.put('app/pages/admin/aircraft/aircraft.html','<div class="col-md-12" ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()">\n            <i class="fa fa-plus"></i> Nytt flygplan\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dAircraft" st-safe-src="aircrafts">\n            <thead>\n            <tr>\n                <th st-sort="reg" st-sort-default="true">Registrering</th>\n                <th st-sort="included_in_saab">Saab</th>\n                <th st-sort="included_in_salary">L\xF6n</th>\n                <th st-sort="included_in_db">Dagbesked</th>\n                <th st-sort="included_in_landing_report">Landningsrapport</th>\n                <th st-sort="included_in_brandflyg">Brandflyg</th>\n                <th st-sort="included_in_bookings">Provlektioner</th>\n                <th st-sort="included_in_taxreturn">Br\xE4nsleskatt</th>\n                <th st-sort="fuel_consumption">Br\xE4nslef\xF6rbrukning</th>\n                <th st-sort="fuel_type">Br\xE4nsletyp</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="aircraft in dAircraft | itemsPerPage: 20">\n                <td>{{::aircraft.reg}}</td>\n                <td>{{::aircraft.included_in_saab ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.included_in_salary ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.included_in_db ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.included_in_landing_report ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.included_in_brandflyg ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.included_in_bookings ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.included_in_taxreturn ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::aircraft.fuel_consumption}}</td>\n                <td>{{::aircraft.fuel_type == 0 ? \'91/96\' : \'100LL\'}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(aircraft)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(aircraft)" ng-confirm-click="Radera {{aircraft.reg}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="8" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/aircraft/aircraft.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Nytt flygplan\' : \'Redigera flygplan\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="aircraftForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.reg.$invalid && !accountForm.reg.$pristine}">\n            <label for="reg">Registrering</label>\n            <input id="reg" name="reg" class="form-control text-uppercase" type="text" ng-model="aircraft.reg" required>\n        </div>\n        <div class="text-center">\n            <div class="btn-group" style="margin-bottom: 5px">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_saab" uib-btn-radio="true">Ing\xE5r i Saabfaktura</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_saab" uib-btn-radio="false">Ing\xE5r ej i Saabfaktura</label>\n            </div>\n            <div class="btn-group" style="margin-bottom: 5px">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_salary" uib-btn-radio="true">Ing\xE5r i l\xF6nespec.</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_salary" uib-btn-radio="false">Ing\xE5r ej i l\xF6nespec.</label>\n            </div>\n            <div class="btn-group" style="margin-bottom: 5px">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_db" uib-btn-radio="true">Ing\xE5r i dagbeskedimport</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_db" uib-btn-radio="false">Ing\xE5r ej i dagbeskedimport</label>\n            </div>\n            <div class="btn-group" style="margin-bottom: 5px">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_landing_report" uib-btn-radio="true">Ing\xE5r i landningsrapport</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_landing_report" uib-btn-radio="false">Ing\xE5r ej i landningsrapport</label>\n            </div>\n            <div class="btn-group" style="margin-bottom: 5px">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_brandflyg" uib-btn-radio="true">Ing\xE5r i brandflygsimport</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_brandflyg" uib-btn-radio="false">Ing\xE5r ej i brandflygsimport</label>\n            </div>\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_bookings" uib-btn-radio="true">Kan bokas av provlektioner</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_bookings" uib-btn-radio="false">Kan ej bokas av provlektioner</label>\n            </div>\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="aircraft.included_in_taxreturn" uib-btn-radio="true">Inkluderas i br\xE4nsleskatt</label>\n                <label class="btn btn-primary" ng-model="aircraft.included_in_taxreturn" uib-btn-radio="false">Inkluderas ej i br\xE4nsleskatt</label>\n            </div>\n        </div>\n        <div class="form-group">\n            <label for="fuel_consumption">Br\xE4nslef\xF6rbrukning</label>\n            <input id="fuel_consumption" name="fuel_consumption" class="form-control" type="number" min="0" ng-model="aircraft.fuel_consumption" required>\n        </div>\n        <div class="form-group">\n            <label>Br\xE4nsletyp</label>\n            <select name="fuel_type" class="form-control" ng-model="aircraft.fuel_type" convert-to-number required>\n                <option value="0">AVGAS 91/96 UL</option>\n                <option value="1">AVGAS 100LL</option>\n            </select>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(aircraft)" ng-disabled="accountForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/aircraft/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <p>Styr hur de olika bokningsobjekten ska hanteras av olika delsystem d\xE5 flygningar/bokningar importeras fr\xE5n myWebLog.</p>\n    <ul>\n        <li><strong>Saab: </strong>Flygplanet kan anv\xE4ndas f\xF6r Saabflygningar</li>\n        <li><strong>L\xF6n: </strong>Flygplanet kan anv\xE4ndas f\xF6r skolning i LFK</li>\n        <li><strong>Dagbesked: </strong>Flygningar med flygplanet ing\xE5r i importen till dagbeskedet</li>\n        <li><strong>Landningsrapport: </strong>Flygningar med flygplanet ing\xE5r i landningsrapporten som skickas till Saab</li>\n        <li><strong>Brandflyg: </strong>Flygplanet anv\xE4nds f\xF6r brandflyg i LFK</li>\n        <li><strong>Provlektioner: </strong>Flygplanet kan bokas av kunder som k\xF6pt provlektioner</li>\n    </ul>\n</div>');
$templateCache.put('app/pages/admin/budget/budget.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only">\xC5r</label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control" placeholder="\xC5r">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="loadYear(year)">\n            <i class="fa fa-refresh"></i> Visa\n        </button>\n    </form>\n\n    <div ng-if="data" style="margin-top: 20px;">\n        <div class="table-responsive">\n            <table class="table table-condensed table-bordered">\n                <thead>\n                <tr>\n                    <th>Flygkod</th>\n                    <th ng-repeat="reg in data.aircraft">{{reg}}</th>\n                    <th>Summa</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="kod in data.flygkoder">\n                    <td><strong>{{kod}}</strong></td>\n                    <td ng-repeat="reg in data.aircraft">\n                        <input type="number" ng-model="grid[kod][reg]" class="form-control input-sm" style="width: 70px;" min="0" step="1">\n                    </td>\n                    <td><strong>{{getRowTotal(kod) | number:0}}</strong></td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <td><strong>Summa</strong></td>\n                    <td ng-repeat="reg in data.aircraft"><strong>{{getColumnTotal(reg) | number:0}}</strong></td>\n                    <td><strong>{{getGrandTotal() | number:0}}</strong></td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n        <div class="text-center" style="margin-top: 15px;">\n            <button type="button" class="btn btn-primary btn-with-icon" ng-click="save()">\n                <i class="fa fa-save"></i> Spara budget\n            </button>\n        </div>\n    </div>\n\n    <div ng-if="!data" class="text-center" style="padding: 60px 20px;">\n        <i class="fa fa-bar-chart fa-4x text-muted"></i>\n        <h3>V\xE4lj ett \xE5r och klicka "Visa"</h3>\n    </div>\n</div>\n');
$templateCache.put('app/pages/admin/depkaps/depkap.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny revers\' : \'Redigera revers\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="depkapForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : depkapForm.number.$invalid && !depkapForm.number.$pristine}">\n            <label for="number">Nummer</label>\n            <input id="number" name="number" class="form-control" type="number" min="1" max="9999" ng-model="depkap.number" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : depkapForm.pilot_number.$invalid && !depkapForm.pilot_number.$pristine}">\n            <label for="number">Pilotnummer</label>\n            <input id="pilot_number" name="number" class="form-control" type="number" min="1000" max="9999" ng-model="depkap.pilot_number" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : depkapForm.level.$invalid && !depkapForm.level.$pristine}">\n            <label for="level">Niv\xE5</label>\n            <select id="level" name="level" class="form-control" ng-model="depkap.level" required convert-to-number>\n                <option value="1">D1</option>\n                <option value="2">D2</option>\n                <option value="3">D3</option>\n            </select>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : depkapForm.amount.$invalid && !depkapForm.amount.$pristine}">\n            <label for="number">V\xE4rde</label>\n            <input id="amount" name="amount" class="form-control" type="number" min="0" max="99999" ng-model="depkap.amount" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(depkap)" ng-disabled="depkapForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/depkaps/depkaps.html','<div class="col-md-12" ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()">\n            <i class="fa fa-plus"></i> Ny revers\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dDepkaps" st-safe-src="depkaps">\n            <thead>\n            <tr>\n                <th st-sort="number" st-sort-default="true">Nummer</th>\n                <th st-sort="pilot_nr">Pilotnummer</th>\n                <th st-sort="name">Namn</th>\n                <th st-sort="level">Niv\xE5</th>\n                <th st-sort="amount">V\xE4rde</th>\n                <th st-sort="membership">Medlemskap</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="depkap in dDepkaps" ng-class="{\'bg-danger\' : depkap.level !== depkap.mwl_level && depkap.mwl_level !== -1,\n                           \'bg-warning\' : depkap.level !== depkap.mwl_level && depkap.mwl_level === -1}">\n                <td>{{::depkap.number}}</td>\n                <td>{{::depkap.pilot_number}}</td>\n                <td>{{::depkap.name}}</td>\n                <td>{{::depkap.level}}</td>\n                <td>{{::depkap.amount | currency}}</td>\n                <td>{{::depkap.membership}}</td>\n                <td>\n                    <div class="pull-right" ng-hide="depkap.number === 0">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(depkap)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(depkap)" ng-confirm-click="Radera {{depkap.number}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <th colspan="4">Summa</th>\n                <th colspan="3">{{depkaps | sumOfValue:\'amount\' | currency}}</th>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/depkaps/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <p>Sammanst\xE4llning av aktiva reverser.</p>\n\n    <p>Kontroll g\xF6rs mot MWL d\xE4r reversregistret st\xE4ms av mot medlemsregistret. Reverser som har\n    matchande medlemmar med felaktigt D0/D1/D2/D3-medlemskap r\xF6dmarkeras. \xD6vriga felaktiga medlemskap gulmarkeras.</p>\n\n    <p>Kontroll g\xF6rs ocks\xE5 att det inte finns medlemmar med D1/D2/D3-medlemskap som inte har en aktiv revers.</p>\n</div>');
$templateCache.put('app/pages/admin/events/event.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{event.message}}</h4>\n</div>\n<div class="modal-body">\n    <table class="table">\n        <thead>\n        <tr>\n            <th>Attribut</th>\n            <th>Tidigare v\xE4rde</th>\n            <th>Nytt v\xE4rde</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="attribute in event.attributes">\n            <td>{{attribute.attribute}}</td>\n            <td>{{attribute.old_value}}</td>\n            <td>{{attribute.new_value || \'-\'}}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>');
$templateCache.put('app/pages/admin/events/eventlog.html','<div class="row">\n    <div class="col-md-12" ba-panel>\n        <div class="table-responsive">\n            <table class="table table-condensed table-hover">\n                <thead>\n                <tr>\n                    <th>H\xE4ndelse</th>\n                    <th>Anv\xE4ndare</th>\n                    <th>Tidpunkt</th>\n                    <th style="width: 10px"></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr dir-paginate="event in pagination.data | itemsPerPage:pagination.per_page" total-items="pagination.total" current-page="currentPage">\n                    <td>{{::event.message}}</td>\n                    <td>{{::event.user ? event.user.first_name + \' \' + event.user.last_name : \'System\'}}</td>\n                    <td>{{::event.created_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                    <td>\n                        <button class="btn btn-info btn-xs" ng-disabled="event.attributes.length === 0" ng-click="openModal(event)">\n                            <i class="fa fa-info fa-fw"></i>\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <td colspan="4" class="text-center">\n                        <dir-pagination-controls boundary-links="true" template-url="app/commons/partials/dirPagination.tpl.html" on-page-change="pageChange(newPageNumber)"></dir-pagination-controls>\n                    </td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/heaters/heater.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny motorv\xE4rmare\' : \'Redigera motorv\xE4rmare\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="heaterForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.slot.$invalid && !heaterForm.slot.$pristine}">\n            <label for="slot">Hangarfack</label>\n            <input id="slot" name="slot" class="form-control" type="number" min="0" max="16" ng-model="heater.slot" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.aircraft.$invalid && !heaterForm.aircraft.$pristine}">\n            <label for="aircraft">Flygplan</label>\n            <input id="aircraft" name="aircraft" class="form-control" type="text" ng-model="heater.aircraft" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.device_id.$invalid && !heaterForm.device_id.$pristine}">\n            <label for="device_id">Device ID</label>\n            <input id="device_id" name="device_id" class="form-control" type="number" min="0" ng-model="heater.device_id" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.client_id.$invalid && !heaterForm.client_id.$pristine}">\n            <label for="client_id">Client ID</label>\n            <input id="client_id" name="device_id" class="form-control" type="number" min="0" ng-model="heater.client_id" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.offset.$invalid && !heaterForm.offset.$pristine}">\n            <label for="offset">Tid innan bokning</label>\n            <input id="offset" name="offset" class="form-control" type="number" min="0" max="360" ng-model="heater.offset" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.overrun.$invalid && !heaterForm.overrun.$pristine}">\n            <label for="overrun">Tid efter bokning</label>\n            <input id="overrun" name="overrun" class="form-control" type="number" min="0" max="120" ng-model="heater.overrun" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.min_repeat.$invalid && !heaterForm.min_repeat.$pristine}">\n            <label for="min_repeat">Minsta rep.</label>\n            <input id="min_repeat" name="min_repeat" class="form-control" type="number" min="0" max="8" ng-model="heater.min_repeat" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : heaterForm.temperature_limit.$invalid && !heaterForm.temperature_limit.$pristine}">\n            <label for="temperature_limit">Temperaturgr\xE4ns</label>\n            <input id="temperature_limit" name="temperature_limit" class="form-control" type="number" step="0.1" min="-20" max="20" ng-model="heater.temperature_limit" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(heater)" ng-disabled="heaterForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/heaters/heaters.html','<div class="col-md-12" ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()">\n            <i class="fa fa-plus"></i> Ny motorv\xE4rmare\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dHeaters" st-safe-src="heaters">\n            <thead>\n            <tr>\n                <th st-sort="slot" st-sort-default="true">Hangarfack</th>\n                <th st-sort="aicraft">Flygplan</th>\n                <th st-sort="device_id">Device ID</th>\n                <th st-sort="client_id">Client ID</th>\n                <th st-sort="offset">Tid innan bokning</th>\n                <th st-sort="overrun">Tid efter bokning</th>\n                <th st-sort="min_repeat">Minsta rep.</th>\n                <th st-sort="temperature_limit">Temperaturgr\xE4ns</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="heater in dHeaters | itemsPerPage: 20">\n                <td>{{::heater.slot}}</td>\n                <td>{{::heater.aircraft}}</td>\n                <td>{{::heater.device_id}}</td>\n                <td>{{::heater.client_id}}</td>\n                <td>{{::heater.offset}} min</td>\n                <td>{{::heater.overrun}} min</td>\n                <td>{{::heater.min_repeat}} h</td>\n                <td>{{::heater.temperature_limit}} grader</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(heater)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(heater)" ng-confirm-click="Radera {{heater.aircraft}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="9" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/heaters/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <p>De flygplan/hangarfack som ing\xE5r i automatstyrningen av motorv\xE4rmarna.</p>\n    <p>Innan en ny motorv\xE4rmare kan l\xE4ggas till h\xE4r m\xE5ste den l\xE4ggas upp hos Telldus (http://live.telldus.com).\n        Den kan sedan l\xE4ggas upp h\xE4r. Alla IDn f\xE5s ut genom Telldus API (http://api.telldus.com).</p>\n    <p>Hangarfack \xE4r vilket hangarfack respektive motorv\xE4rmare sitter i. <strong>OBS: Hangarfack och alla IDn\n        h\xF6r ihop s\xE5 att \xE4ndra hangarfack h\xE4r g\xF6r ingen skillnad. \xC4ndra "Flygplan" om ett flygplan byter\n        hangarfack.</strong></p>\n    <p>Flygplan \xE4r vilket flygplan som st\xE5r i det aktuella hangarfacket. M\xE5ste st\xE4mma exakt med vad flygplanet heter i\n        myWebLog.</p>\n    <p>Tid innan bokning \xE4r det antal minuter motorv\xE4rmaren ska starta innan bokningen startar.</p>\n</div>');
$templateCache.put('app/pages/admin/insurance/info.modal.html','<div class="modal-content">\n    <div class="modal-header">\n        <button type="button" class="close" ng-click="$dismiss()">&times;</button>\n        <h4 class="modal-title">\n            <i class="fa fa-info-circle"></i> F\xF6rs\xE4kringsinfo - Hj\xE4lp\n        </h4>\n    </div>\n    <div class="modal-body">\n        <h4>S\xE5 h\xE4r anv\xE4nder du f\xF6rs\xE4kringsinfosystemet</h4>\n\n        <div class="panel panel-default">\n            <div class="panel-heading">\n                <strong>Steg 1: Synkronisera mottagare</strong>\n            </div>\n            <div class="panel-body">\n                <ol>\n                    <li>Ange \xE5ret i f\xE4ltet (t.ex. 2026)</li>\n                    <li>Klicka p\xE5 <strong>"Visa"</strong> f\xF6r att ladda data f\xF6r \xE5ret</li>\n                    <li>V\xE4lj <strong>"\xC5tg\xE4rd" \u2192 "Synkronisera med MWL"</strong></li>\n                    <li>Systemet h\xE4mtar alla aktiva medlemmar fr\xE5n myWebLog och skapar mottagare med unika bekr\xE4ftelsel\xE4nkar</li>\n                </ol>\n                <div class="alert alert-warning">\n                    <strong>OBS:</strong> Synkronisering ers\xE4tter alla befintliga mottagare f\xF6r \xE5ret.\n                </div>\n            </div>\n        </div>\n\n        <div class="panel panel-default">\n            <div class="panel-heading">\n                <strong>Steg 2: L\xE4gg till PDF-fil</strong>\n            </div>\n            <div class="panel-body">\n                <p>Innan du kan skicka emails m\xE5ste du l\xE4gga till PDF-filen p\xE5 servern:</p>\n                <code>resources/assets/insurance-\xC5\xC5\xC5\xC5.pdf</code>\n                <p style="margin-top: 10px;">Exempel: <code>resources/assets/insurance-2026.pdf</code></p>\n                <p class="text-muted">Denna fil skickas som bilaga till alla mottagare.</p>\n            </div>\n        </div>\n\n        <div class="panel panel-default">\n            <div class="panel-heading">\n                <strong>Steg 3: Skicka emails</strong>\n            </div>\n            <div class="panel-body">\n                <ol>\n                    <li>V\xE4lj <strong>"\xC5tg\xE4rd" \u2192 "Skicka emails"</strong></li>\n                    <li>Systemet skickar email med PDF-bilaga och bekr\xE4ftelsel\xE4nk till alla som inte f\xE5tt email \xE4nnu</li>\n                    <li>Emails k\xF6as f\xF6r att undvika serverproblem</li>\n                </ol>\n                <div class="alert alert-info">\n                    <strong>Tips:</strong> Du kan synkronisera igen senare f\xF6r att l\xE4gga till nya medlemmar och sedan skicka till endast dem.\n                </div>\n            </div>\n        </div>\n\n        <div class="panel panel-default">\n            <div class="panel-heading">\n                <strong>Steg 4: F\xF6lj upp bekr\xE4ftelser</strong>\n            </div>\n            <div class="panel-body">\n                <p>Mottagare klickar p\xE5 l\xE4nken i emailet f\xF6r att bekr\xE4fta att de tagit del av informationen.</p>\n                <p>Tabellen visar i realtid:</p>\n                <ul>\n                    <li><i class="fa fa-check text-success"></i> <strong>Skickad:</strong> N\xE4r emailet skickades</li>\n                    <li><i class="fa fa-check-circle text-success"></i> <strong>Bekr\xE4ftad:</strong> N\xE4r mottagaren klickade p\xE5 l\xE4nken</li>\n                </ul>\n                <p>Bekr\xE4ftelseprocenten uppdateras automatiskt.</p>\n            </div>\n        </div>\n\n        <div class="panel panel-info">\n            <div class="panel-heading">\n                <strong>Anpassningar</strong>\n            </div>\n            <div class="panel-body">\n                <p><strong>Filtrera medlemmar:</strong> Redigera <code>app/Services/InsuranceInfoService.php</code> metoden <code>getActiveMembers()</code> f\xF6r att \xE4ndra vilka medlemstyper som f\xE5r email.</p>\n                <p><strong>Email-mall:</strong> Redigera <code>resources/views/emails/insurance.blade.php</code> f\xF6r att \xE4ndra email-texten.</p>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-primary" ng-click="$dismiss()">St\xE4ng</button>\n    </div>\n</div>\n');
$templateCache.put('app/pages/admin/insurance/insurance.html','<div ba-panel ba-panel-title="F\xF6rs\xE4kringsinfo">\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only">\xC5r</label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control" placeholder="\xC5r (t.ex. 2026)">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="loadYear(year)">\n            <i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon">\n                <i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid || !data" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">\xC5tg\xE4rder</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li>\n                    <a href="" ng-confirm-click="Synkronisera mottagare fr\xE5n MWL f\xF6r {{year.year}}? Detta kommer att l\xE4gga till nya medlemmar, ta bort uttr\xE4dda och uppdatera \xE4ndrade uppgifter. Bekr\xE4ftelser och skickade emails p\xE5verkas inte." confirmed-click="syncRecipients(year)">\n                        <i class="fa fa-refresh"></i> Synkronisera med MWL\n                    </a>\n                </li>\n                <li ng-class="{\'disabled\': statistics.unconfirmed === 0}">\n                    <a href="" ng-if="statistics.unconfirmed > 0" ng-confirm-click="Skicka email till {{statistics.unconfirmed}} obekr\xE4ftade mottagare f\xF6r {{year.year}}?" confirmed-click="sendEmails(year)">\n                        <i class="fa fa-envelope"></i> Skicka emails ({{statistics.unconfirmed}})\n                    </a>\n                    <a href="" ng-if="statistics.unconfirmed === 0" class="text-muted" disabled="disabled">\n                        <i class="fa fa-envelope"></i> Skicka emails (alla bekr\xE4ftade)\n                    </a>\n                </li>\n            </ul>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n\n    <!-- Statistics Panel -->\n    <div ng-if="data && statistics" style="margin-top: 20px;">\n        <div class="row">\n            <div class="col-md-3">\n                <div class="panel panel-default text-center">\n                    <div class="panel-body">\n                        <h3>{{statistics.total}}</h3>\n                        <p class="text-muted">Totalt mottagare</p>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-3">\n                <div class="panel panel-default text-center">\n                    <div class="panel-body">\n                        <h3>{{statistics.sent}}</h3>\n                        <p class="text-muted">Skickade</p>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-3">\n                <div class="panel panel-default text-center">\n                    <div class="panel-body">\n                        <h3>{{statistics.confirmed}}</h3>\n                        <p class="text-muted">Bekr\xE4ftade</p>\n                    </div>\n                </div>\n            </div>\n            <div class="col-md-3">\n                <div class="panel panel-default text-center">\n                    <div class="panel-body">\n                        <h3>{{getConfirmationRate()}}%</h3>\n                        <p class="text-muted">Procent</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!-- Recipients Table -->\n    <div ng-if="data && recipients" class="table-responsive" style="margin-top: 20px;">\n        <table class="table table-hover table-condensed" st-table="dRecipients" st-safe-src="recipients">\n            <thead>\n            <tr>\n                <th st-sort="name" st-sort-default="true">Namn</th>\n                <th st-sort="pilot_nr">Pilotnummer</th>\n                <th st-sort="email">Email</th>\n                <th st-sort="membership">Medlemskap</th>\n                <th>Skickad</th>\n                <th>Bekr\xE4ftad</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-if="recipients.length === 0">\n                <td colspan="6" class="text-center" style="padding: 40px;">\n                    <i class="fa fa-users fa-3x text-muted"></i>\n                    <h4>Inga mottagare \xE4nnu</h4>\n                    <p class="text-muted">Anv\xE4nd "Synkronisera med MWL" f\xF6r att h\xE4mta medlemmar</p>\n                </td>\n            </tr>\n            <tr dir-paginate="recipient in dRecipients | itemsPerPage: 50" ng-if="recipients.length > 0">\n                <td>{{recipient.name}}</td>\n                <td>{{recipient.pilot_nr}}</td>\n                <td>{{recipient.email}}</td>\n                <td>{{recipient.membership}}</td>\n                <td>\n                    <span ng-if="recipient.sent_at">\n                        <i class="fa fa-check text-success"></i>\n                        <small>{{formatDate(recipient.sent_at)}}</small>\n                    </span>\n                    <span ng-if="!recipient.sent_at" class="text-muted">-</span>\n                </td>\n                <td>\n                    <span ng-if="recipient.confirmed_at">\n                        <i class="fa fa-check-circle text-success"></i>\n                        <small>{{formatDate(recipient.confirmed_at)}}</small>\n                    </span>\n                    <span ng-if="!recipient.confirmed_at" class="text-muted">-</span>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot ng-if="recipients.length > 50">\n            <tr>\n                <td colspan="6" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n\n    <!-- Empty State -->\n    <div ng-if="!data" class="text-center" style="padding: 60px 20px;">\n        <i class="fa fa-info-circle fa-4x text-muted"></i>\n        <h3>V\xE4lj ett \xE5r och klicka "Visa"</h3>\n        <p class="text-muted">Ange \xE5ret i f\xE4ltet ovan och klicka p\xE5 "Visa" f\xF6r att se eller skapa f\xF6rs\xE4kringsinformation f\xF6r det \xE5ret.</p>\n    </div>\n</div>\n');
$templateCache.put('app/pages/admin/settings/setting.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;\n    </button>\n    <h4 class="modal-title">Redigera {{setting.description}}</h4>\n</div>\n<div class="modal-body">\n    <form name="settingForm" novalidate>\n        <div class="form-group">\n            <label for="description">Inst\xE4llning</label>\n            <input id="description" name="description" class="form-control" type="text" ng-model="setting.description" disabled="disabled">\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : settingForm.value.$invalid && !settingForm.value.$pristine}">\n            <label for="value">V\xE4rde</label>\n            <input id="value" name="value" class="form-control" max="{{::inputType.max}}" min="{{::inputType.min}}" type="{{::inputType.type}}" ng-model="setting.value" ng-required="{{::!setting.nullable}}" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(setting)" ng-disabled="settingForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/settings/settings.html','<div ba-panel>\n    <uib-tabset active="activeTab.act">\n        <uib-tab index="$index" ng-repeat="(category, settings) in data">\n            <uib-tab-heading>{{::category}}</uib-tab-heading>\n            <table class="table table-hover">\n                <thead>\n                <tr>\n                    <th>Inst\xE4llning</th>\n                    <th>V\xE4rde</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat="setting in settings">\n                    <td>{{::setting.description}}</td>\n                    <td>{{::setting.value}}</td>\n                    <td>\n                        <div class="pull-right">\n                            <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(setting)">\n                                <i class="fa fa-pencil fa-fw"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/admin/users/user.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny anv\xE4ndare\' : \'Redigera anv\xE4ndare\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="userForm" novalipassword>\n        <div class="form-group" ng-class="{\'has-error\' : userForm.email.$invalid && !userForm.email.$pristine}">\n            <label for="email">Mailadress</label>\n            <input id="email" name="email" class="form-control" type="email" ng-model="user.email" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : userForm.firstName.$invalid && !userForm.firstName.$pristine}">\n            <label for="firstName">F\xF6rnamn</label>\n            <input id="firstName" name="firstName" class="form-control" type="text" ng-model="user.first_name" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : userForm.lastName.$invalid && !userForm.lastName.$pristine}">\n            <label for="lastName">Efternamn</label>\n            <input id="lastName" name="lastName" class="form-control" type="text" ng-model="user.last_name" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : userForm.password.$invalid && !userForm.password.$pristine}">\n            <label for="password">L\xF6senord</label>\n            <input id="password" name="password" class="form-control" type="password" ng-model="user.password">\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : userForm.password_confirmation.$invalid && !userForm.password_confirmation.$pristine}">\n            <label for="password_confirmation">Bekr\xE4fta l\xF6senord</label>\n            <input id="password_confirmation" name="password_confirmation" class="form-control" type="password" ng-model="user.password_confirmation" data-match="user.password" ng-required="user.password.length">\n        </div>\n        <label>Beh\xF6righeter</label>\n\n        <div class="text-center">\n            <div class="btn-group form-group">\n                <label class="btn" ng-class="{\'btn-success\' : user.kiosk, \'btn-danger\' : !user.kiosk}" ng-model="user.kiosk" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Kiosk</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.jour, \'btn-danger\' : !user.jour}" ng-model="user.jour" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Jour</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.saab, \'btn-danger\' : !user.saab}" ng-model="user.saab" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Saab</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.salaries, \'btn-danger\' : !user.salaries}" ng-model="user.salaries" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">L\xF6ner</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.fuel, \'btn-danger\' : !user.fuel}" ng-model="user.fuel" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Br\xE4nsle</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.stats, \'btn-danger\' : !user.stats}" ng-model="user.stats" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Statistik</label>\n            </div>\n            <div class="btn-group form-group">\n                <label class="btn" ng-class="{\'btn-success\' : user.dagbesked, \'btn-danger\' : !user.dagbesked}" ng-model="user.dagbesked" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Dagbesked</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.orders, \'btn-danger\' : !user.orders}" ng-model="user.orders" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Order</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.brandflyg, \'btn-danger\' : !user.brandflyg}" ng-model="user.brandflyg" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Brandflyg</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.ppr, \'btn-danger\' : !user.ppr}" ng-model="user.ppr" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">PPR</label>\n                <label class="btn" ng-class="{\'btn-success\' : user.admin, \'btn-danger\' : !user.admin}" ng-model="user.admin" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">Admin</label>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(user)" ng-disabled="userForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/admin/users/users.html','<div class="col-md-12" ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()">\n            <i class="fa fa-plus"></i> Ny anv\xE4ndare\n        </button>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dUsers" st-safe-src="users">\n            <thead>\n            <tr>\n                <th st-sort="email" st-sort-default="true">Email</th>\n                <th st-sort="first_name">F\xF6rnamn</th>\n                <th st-sort="last_name">Efternamn</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="user in dUsers | itemsPerPage: 20">\n                <td>{{::user.email}}</td>\n                <td>{{::user.first_name}}</td>\n                <td>{{::user.last_name}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(user)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(user)" ng-confirm-click="Radera {{user.first_name + user.last_name}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="4" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/brandflyg/invoice/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad flygning \xE4r en flygning som \xE4nnu inte exporterats/l\xE5sts.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad flygning \xE4r en flygning som har exporterats/l\xE5sts.\n    </div>\n</div>');
$templateCache.put('app/pages/brandflyg/invoice/invoicing.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control">\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" id="endDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" name="endDate" ng-model="dates.endDate" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="updateAll(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li><a href="" ng-confirm-click="Vill du verkligen l\xE5sa alla flygningar mellan aktuella datum?" confirmed-click="lockPeriod(dates)" class="text-center"><i class="fa fa-pause"></i> L\xE5s period</a></li>\n                <li class="divider"></li>\n                <li>\n                    <a href="" ng-click="getPdf(rescuers)" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a>\n                </li>\n            </ul>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <uib-tabset>\n        <uib-tab heading="L\xE4nsstyrelsen">\n            <div class="table-responsive">\n                <table class="table table-hover table-condensed" st-table="dReports" st-safe-src="reports">\n                    <thead>\n                    <tr>\n                        <th st-sort-default="true">Datum</th>\n                        <th>Registrering</th>\n                        <th>\xC4rendenummer</th>\n                        <th>Kommentar</th>\n                        <th>Br\xE4nder</th>\n                        <th>Start</th>\n                        <th>Slut</th>\n                        <th>Tid</th>\n                        <th>\xE1-pris</th>\n                        <th>Summa</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="report in dReports" ng-class="{\'success\' : report.exported, \'warning\' : !report.exported}">\n                        <td>{{::report.date | date:\'shortDate\'}}</td>\n                        <td>{{::report.aircraft}}</td>\n                        <td>{{::report.sos_number}}</td>\n                        <td>{{::report.comment}}</td>\n                        <td>{{report.noFires = report.fires.length}} st.</td>\n                        <td>{{::report.block_off | date:\'shortTime\':\'UTC\'}}</td>\n                        <td>{{getFakeLanding(report) | date:\'shortTime\':\'UTC\'}}</td>\n                        <td>{{report.netBlock = report.block - report.sumOfFires | number : 1}} h</td>\n                        <td>{{::report.tariff | currency:\'kr\':0}}</td>\n                        <td>{{(report.amount = report.netBlock * report.tariff) | currency:\'kr\':0}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="4">Summa</th>\n                        <th colspan="3">{{reports | sumOfValue:\'noFires\'}} st</th>\n                        <th colspan="2">{{reports | sumOfValue:\'netBlock\' | number:1}} h</th>\n                        <th colspan="2">{{reports | sumOfValue:\'amount\' | currency:\'kr\':0}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab ng-repeat="rescuer in rescuers" active="rescuer.active">\n            <uib-tab-heading>{{::rescuer.name}}</uib-tab-heading>\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dFires" st-safe-src="rescuer.fires">\n                    <thead>\n                    <tr>\n                        <th st-sort-default="true">Datum</th>\n                        <th>Registrering</th>\n                        <th>\xC4rendenummer</th>\n                        <th>Kommentar</th>\n                        <th>Start</th>\n                        <th>Slut</th>\n                        <th>Tid</th>\n                        <th>\xE1-pris</th>\n                        <th>Summa</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="fire in dFires" ng-class="{\'success\' : fire.report.exported, \'warning\' : !fire.report.exported}">\n                        <td>{{::fire.report.date | date:\'shortDate\'}}</td>\n                        <td>{{::fire.report.aircraft}}</td>\n                        <td>{{::fire.sos_number}}</td>\n                        <td>{{::fire.comment}}</td>\n                        <td>{{::fire.start | date:\'shortTime\':\'UTC\'}}</td>\n                        <td>{{::fire.end | date:\'shortTime\':\'UTC\'}}</td>\n                        <td>{{::fire.time}} h</td>\n                        <td>{{::fire.report.tariff | currency:\'kr\':0}}</td>\n                        <td>{{fire.amount = fire.time * fire.report.tariff | currency:\'kr\':0}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="6">Summa</th>\n                        <th colspan="2">{{rescuer.fires | sumOfValue:\'time\' | number:1}} h</th>\n                        <th>{{rescuer.fires | sumOfValue:\'amount\' | currency:\'kr\':0}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/brandflyg/reports/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad flygning \xE4r en flygning som \xE4nnu inte exporterats/l\xE5sts.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad flygning \xE4r en flygning som har exporterats/l\xE5sts.\n    </div>\n</div>');
$templateCache.put('app/pages/brandflyg/reports/report.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">\xC4ndra rapport</h4>\n</div>\n<div class="modal-body row">\n    <form name="reportForm" novalidate>\n        <div class="col-xs-6">\n            <uib-accordion>\n                <uib-accordion-group is-open="status.flightOpen">\n                    <uib-accordion-heading>\n                        <i ng-class="{\'fa fa-lock\' : status.flightLocked, \'fa fa-unlock\' : !status.flightLocked}" ng-init="status.flightLocked = true" confirmed-click="status.flightLocked = !status.flightLocked" ng-confirm-click="Dessa uppgifter har h\xE4mtats fr\xE5n myWebLog och ska normalt inte beh\xF6va \xE4ndras.\n                \xC4ndrar du dem betyder det att det troligen kommer bli en skillnad mellan myWebLog och insatsrapporten. \xD6nskar du l\xE5sa upp f\xE4lten tryck OK annars Avbryt"></i>\n                        Flyginformation <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': status.flightOpen, \'glyphicon-chevron-right\': !status.flightOpen}"></i>\n                    </uib-accordion-heading>\n                    <div class="row">\n                        <div class="form-group col-md-6" ng-class="{\'has-error\' : reportForm.date.$invalid && !reportForm.date.$pristine}">\n                            <label for="date">Datum</label>\n                            <input id="date" name="date" class="form-control" ng-model-options="{timezone : \'UTC\'}" type="date" ng-model="report.date" ng-readonly="status.flightLocked" required>\n                        </div>\n                        <div class="form-group col-md-6" ng-class="{\'has-error\' : reportForm.aircraft.$invalid && !reportForm.aircraft.$pristine}">\n                            <label for="aircraft">Registrering</label>\n                            <input id="aircraft" name="aircraft" class="form-control text-uppercase" ng-pattern="/\\b([A-Z,a-z,0-9]{2}-[A-Z,a-z]{3})|\\b([A-Z,a-z]{1}-[A-Z,a-z,0-9]{4})/" type="text" ng-model="report.aircraft" ng-readonly="status.flightLocked" required>\n                        </div>\n                    </div>\n                    <!--<div class="form-group col-md-6"\n                         ng-class="{\'has-error\' : reportForm.aircraft_type.$invalid && !reportForm.aircraft_type.$pristine}">\n                        <label for="aircraft_type">Flygplanstyp</label>\n                        <input id="aircraft_type"\n                               name="aircraft_type"\n                               class="form-control"\n                               type="text"\n                               ng-readonly="status.flightLocked"\n                               ng-model="report.aircraft_type"\n                               required/>\n                    </div>-->\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.pilot.$invalid && !reportForm.pilot.$pristine}">\n                        <label for="pilot">Bef\xE4lhavare</label>\n                        <input id="pilot" name="pilot" class="form-control text-capitalize" type="text" ng-readonly="status.flightLocked" ng-model="report.pilot" required>\n                    </div>\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.lookout.$invalid && !reportForm.lookout.$pristine}">\n                        <label for="lookout">Spanare</label>\n                        <input id="lookout" name="lookout" class="form-control text-capitalize" type="text" ng-readonly="status.flightLocked" ng-model="report.lookout" required>\n                    </div>\n                    <div class="row">\n                        <div class="form-group col-md-6" ng-class="{\'has-error\' : reportForm.departure.$invalid && !reportForm.departure.$pristine}">\n                            <label for="departure">Startflygplats</label>\n                            <input id="departure" name="departure" class="form-control text-uppercase" maxlength="4" type="text" ng-readonly="status.flightLocked" ng-model="report.departure" required>\n                        </div>\n                        <div class="form-group col-md-6" ng-class="{\'has-error\' : reportForm.arrival.$invalid && !reportForm.arrival.$pristine}">\n                            <label for="arrival">Landningsflygplats</label>\n                            <input id="arrival" name="arrival" class="form-control text-uppercase" maxlength="4" ng-readonly="status.flightLocked" type="text" ng-model="report.arrival" required>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="form-group col-md-6">\n                            <label for="block_off">Block off</label>\n                            <input type="time" id="block_off" name="block_off" class="form-control" ng-readonly="status.flightLocked" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{report.block_on}}" ng-model="report.block_off" required>\n                        </div>\n                        <div class="form-group col-md-6">\n                            <label for="block_on">Block on</label>\n                            <input type="time" id="block_on" name="block_on" class="form-control" ng-readonly="status.flightLocked" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{report.block_off}}" ng-model="report.block_on" required>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="form-group col-md-4" ng-class="{\'has-error\' : reportForm.takeoff.$invalid && !reportForm.takeoff.$pristine}">\n                            <label for="takeoff">Starttid</label>\n                            <input id="takeoff" name="takeoff" ng-readonly="status.flightLocked" class="form-control" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{report.landing}}" type="time" ng-model="report.takeoff" required>\n                        </div>\n                        <div class="form-group col-md-4" ng-class="{\'has-error\' : reportForm.landing.$invalid && !reportForm.landing.$pristine}">\n                            <label for="landing">Landningstid</label>\n                            <input id="landing" name="landing" ng-readonly="status.flightLocked" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{report.takeoff}}" class="form-control" type="time" ng-model="report.landing" required>\n                        </div>\n                        <div class="form-group col-md-4" ng-class="{\'has-error\' : reportForm.tacho.$invalid && !reportForm.tacho.$pristine}">\n                            <label for="tacho">Tacho</label>\n                            <input id="tacho" name="tacho" ng-readonly="status.flightLocked" class="form-control" type="text" ng-model="report.tacho" smart-float>\n                        </div>\n                    </div>\n                </uib-accordion-group>\n                <uib-accordion-group is-open="status.missionOpen">\n                    <uib-accordion-heading>\n                        Insatsinformation <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': status.missionOpen, \'glyphicon-chevron-right\': !status.missionOpen}"></i>\n                    </uib-accordion-heading>\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.sos_number.$invalid && !reportForm.sos_number.$pristine}">\n                        <label for="sos_number">\xC4rendenummer</label>\n                        <input id="sos_number" name="sos_number" class="form-control" type="text" ng-model="report.sos_number" required>\n                    </div>\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.route.$invalid && !reportForm.route.$pristine}">\n                        <label for="route">Flygslinga</label>\n                        <select id="route" name="route" class="form-control" ng-model="report.route" convert-to-number required>\n                            <option value="0">S\xF6dra slingan</option>\n                            <option value="1">Norra slingan</option>\n                            <option value="2">Annan (specificera i kommentar)</option>\n                        </select>\n                    </div>\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.fire_level.$invalid && !reportForm.fire_level.$pristine}">\n                        <label for="fire_level">Brandrisk</label>\n                        <select id="fire_level" name="fire_level" class="form-control" ng-model="report.fire_level" convert-to-number required>\n                            <option value="1">Mycket liten (1)</option>\n                            <option value="2">Liten (2)</option>\n                            <option value="3">Normal (3)</option>\n                            <option value="4">Stor (4)</option>\n                            <option value="5">Mycket stor (5)</option>\n                            <option value="5E">Extremt stor (5E)</option>\n                        </select>\n                    </div>\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.comment.$invalid && !reportForm.comment.$pristine}">\n                        <label for="comment">Kommentar</label>\n                        <input id="comment" name="comment" class="form-control" type="text" ng-model="report.comment">\n                    </div>\n                </uib-accordion-group>\n                <uib-accordion-group is-open="status.payOpen">\n                    <uib-accordion-heading>\n                        <i ng-class="{\'fa fa-lock\' : status.payLocked, \'fa fa-unlock\' : !status.payLocked}" ng-init="status.payLocked = true" confirmed-click="status.payLocked = !status.payLocked" ng-confirm-click="Varning! Ska normalt inte beh\xF6va \xE4ndras, var f\xF6rsiktig!"></i>\n                        Betalinformation\n                        <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': status.payOpen, \'glyphicon-chevron-right\': !status.payOpen}"></i>\n                    </uib-accordion-heading>\n                    <div class="form-group" ng-class="{\'has-error\' : reportForm.tariff.$invalid && !reportForm.tariff.$pristine}">\n                        <label for="tariff">Tariff</label>\n                        <input id="tariff" name="tariff" ng-disabled="status.payLocked" class="form-control" type="text" ng-model="report.tariff">\n                    </div>\n                </uib-accordion-group>\n            </uib-accordion>\n        </div>\n        <div class="col-xs-6">\n            <label>Br\xE4nder</label>\n            <uib-accordion>\n                <uib-accordion-group close-others="false" is-open="status.open" ng-repeat="fire in report.fires">\n                    <uib-accordion-heading>\n                        <button class="btn btn-danger btn-xs" type="button" ng-click="remove($index)" style="margin-right: 10px">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                        Brand: {{fire.sos_number}} <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i>\n                    </uib-accordion-heading>\n                    <ng-form name="fireForm">\n                        <div class="form-group" ng-class="{\'has-error\' : fireForm.rescuer.$invalid && !fireForm.rescuer.$pristine}">\n                            <label for="rescuer">R\xE4ddningstj\xE4nst</label>\n                            <select id="rescuer" name="rescuer" class="form-control" ng-model="fire.rescuer" ng-options="rescuer as rescuer.name for rescuer in rescuers track by rescuer.id" required>\n                            </select>\n                        </div>\n                        <div class="form-group" ng-class="{\'has-error\' : fireForm.sos_number.$invalid && !fireForm.sos_number.$pristine}">\n                            <label for="sos_number1">\xC4rendenummer (f\xF6r branden)</label>\n                            <input class="form-control" type="text" name="sos_number" id="sos_number1" ng-model="fire.sos_number" maxlength="20" required>\n                        </div>\n                        <div class="form-group" ng-class="{\'has-error\' : fireForm.start.$invalid && !fireForm.start.$pristine}">\n                            <label for="fire_start">Start</label>\n                            <input class="form-control" type="time" name="start" max="{{fire.end}}" ng-model-options="{allowInvalid: true, timezone : \'UTC\'}" ng-model="fire.start" id="fire_start" required>\n                        </div>\n                        <div class="form-group" ng-class="{\'has-error\' : fireForm.end.$invalid && !fireForm.end.$pristine}">\n                            <label for="fire_end">Slut</label>\n                            <input class="form-control" name="end" type="time" min="{{fire.start}}" ng-model-options="{allowInvalid: true, timezone : \'UTC\'}" ng-model="fire.end" id="fire_end" required>\n                        </div>\n                        <div class="form-group">\n                            <label for="fireComment">Kommentar</label>\n                            <input class="form-control" type="text" name="comment" ng-model="fire.comment" id="fireComment" maxlength="254">\n                        </div>\n                    </ng-form>\n                </uib-accordion-group>\n            </uib-accordion>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(report)" ng-disabled="reportForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-warning" push-to-array="report.fires" ng-disabled="reportForm.fireForm.$invalid">L\xE4gg till brand\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/brandflyg/reports/reports.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control">\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" id="endDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" name="endDate" ng-model="dates.endDate" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="updateAll(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-hover table-condensed" st-table="dReports" st-safe-src="reports">\n            <thead>\n            <tr>\n                <th st-sort="date" st-sort-default="true">Datum</th>\n                <th st-sort="aircraft">Flygplan</th>\n                <th st-sort="sos_number">\xC4rendenummer</th>\n                <th st-sort="comment">Kommentar</th>\n                <th st-sort="block_off">Block off</th>\n                <th st-sort="block_on">Block on</th>\n                <th st-sort="tacho">Tacho</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="report in dReports" ng-class="{\'success\' : report.exported, \'warning\' : !report.exported}">\n                <td>{{::report.date | date:\'shortDate\'}}</td>\n                <td>{{::report.aircraft}}</td>\n                <td>{{::report.sos_number}}</td>\n                <td>{{::report.comment}}</td>\n                <td>{{::report.block_off | date:\'shortTime\':\'UTC\'}}</td>\n                <td>{{::report.block_on | date:\'shortTime\':\'UTC\'}}</td>\n                <td>{{::report.tacho | number : 1}} h</td>\n                <td>\n                    <div class="pull-right">\n                        <button class="btn btn-info btn-xs" type="button" ng-click="getPdf(report)">\n                            <i class="fa fa-signal"></i>\n                        </button>\n                        <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(report)" ng-disabled="report.exported">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(report)" ng-confirm-click="Radera raden?" ng-disabled="report.exported">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/brandflyg/rescuers/rescuer.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny r\xE4ddningstj\xE4nst\' : \'Redigera \' + rescuer.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="rescuerForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : rescuerForm.name.$invalid && !rescuerForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="rescuer.name" maxlength="255" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(rescuer)" ng-disabled="rescuerForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/brandflyg/rescuers/rescuers.html','<div ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-warning btn-with-icon" ng-model="showDeleted" uib-btn-checkbox uib-btn-checkbox-true="1" uib-btn-checkbox-false="0">\n            <i ng-class="{\'fa fa-eye\' : !showDeleted, \'fa fa-eye-slash\' : showDeleted}"></i> {{showDeleted ? \'D\xF6lj\n            raderade\' : \'Visa raderade\'}}\n        </button>\n        <button class="btn btn-primary btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Ny r\xE4ddningstj\xE4nst\n        </button>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dRescuers" st-safe-src="rescuers">\n            <thead>\n            <tr>\n                <th>Namn</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="rescuer in dRescuers | filter:showDel">\n                <td>{{::rescuer.name}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" ng-show="rescuer.deleted_at == null" class="btn btn-primary btn-xs" ng-click="openModal(rescuer)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" ng-show="rescuer.deleted_at == null" class="btn btn-danger btn-xs" confirmed-click="delete(rescuer)" ng-confirm-click="Radera {{rescuer.name}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                        <button type="button" ng-hide="rescuer.deleted_at == null" class="btn btn-warning btn-xs" confirmed-click="restore(rescuer)" ng-confirm-click="\xC5terst\xE4lla {{rescuer.aircraft}}?">\n                            \xC5terst\xE4ll\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/checks/checks.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="month" class="sr-only"></label>\n            <input type="month" id="month" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" name="month" ng-model="month.month" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getKeys(month)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <button type="button" class="btn btn-primary btn-with-icon" ng-confirm-click="M\xE5nadsrapporter kommer nu skickas ut till samtliga nyckelinnehavare med en registrerad e-post, vill du forts\xE4tta?" confirmed-click="sendReports(month)"><i class="fa fa-send"></i> Skicka m\xE5nadsrapporter\n        </button>\n        <a href="api/fuel/keys/monthlyCheck/pdf?month={{month.month.toISOString()}}" target="_blank" class="btn btn-primary btn-with-icon"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'number\'; reverse=!reverse">Nyckel</th>\n                        <th ng-click="orderBy=\'holder\'; reverse=!reverse">Kund</th>\n                        <th ng-click="orderBy=\'reading_start.meter_value\'; reverse=!reverse">F\xF6reg\xE5ende</th>\n                        <th ng-click="orderBy=\'reading_end.meter_value\'; reverse=!reverse">Nuvarande</th>\n                        <th>F\xF6rs\xE4ljning</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="key in type_9196 = (keys | filter:{fuel_type:\'0\', is_master:false} | filter:noInactive) | orderBy:orderBy:reverse | itemsPerPage: 20" pagination-id="f9196" ng-class="{\'bg-warning\': key.reading_start.id === key.reading_end.id, \'bg-danger\': key.holder === \'INAKTIV\' && key.reading_start.id !== key.reading_end.id}">\n                        <td>{{::key.number}}</td>\n                        <td>{{::key.holder}}</td>\n                        <td>{{::key.reading_start.meter_value}}</td>\n                        <td>{{::key.reading_end.meter_value}}</td>\n                        <td>{{key.litres = calculateDifference(key.reading_end.meter_value,\n                            key.reading_start.meter_value, key.counter_max)}}\n                            liter\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="4">Summa</th>\n                        <th>{{type_9196 | sumOfValue:\'litres\' | number}} liter</th>\n                    </tr>\n                    <tr>\n                        <th colspan="4">Summa registrerad p\xE5 master</th>\n                        <th>{{getMasterDifference(keys, 0) | number}} liter</th>\n                    </tr>\n                    <tr>\n                        <th colspan="4">Antal fakturor</th>\n                        <th>{{type_9196 | filter:{type:\'3\'} | noGreaterThanZero:\'litres\' | number}} st.</th>\n                    </tr>\n                    <tr>\n                        <td colspan="5" class="text-center">\n                            <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'number\'; reverse=!reverse">Nyckel</th>\n                        <th ng-click="orderBy=\'holder\'; reverse=!reverse">Kund</th>\n                        <th ng-click="orderBy=\'reading_start.meter_value\'; reverse=!reverse">F\xF6reg\xE5ende</th>\n                        <th ng-click="orderBy=\'reading_end.meter_value\'; reverse=!reverse">Nuvarande</th>\n                        <th>F\xF6rs\xE4ljning</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="key in type_100LL = (keys | filter:{fuel_type:\'1\', is_master:false} | filter:noInactive) | orderBy:orderBy:reverse | itemsPerPage:20" pagination-id="f100LL" ng-class="{\'bg-warning\': key.reading_start.id === key.reading_end.id, \'bg-danger\': key.holder === \'INAKTIV\' && key.reading_start.id !== key.reading_end.id}">\n                        <td>{{::key.number}}</td>\n                        <td>{{::key.holder}}</td>\n                        <td>{{::key.reading_start.meter_value}}</td>\n                        <td>{{::key.reading_end.meter_value}}</td>\n                        <td>{{key.litres = calculateDifference(key.reading_end.meter_value,\n                            key.reading_start.meter_value, key.counter_max)}}\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="4">Summa</th>\n                        <th>{{type_100LL | sumOfValue:\'litres\' | number}} liter</th>\n                    </tr>\n                    <tr>\n                        <th colspan="4">Summa registrerad p\xE5 master</th>\n                        <th>{{getMasterDifference(keys, 1) | number}} liter</th>\n                    </tr>\n                    <tr>\n                        <th colspan="4">Antal fakturor</th>\n                        <th>{{type_100LL | filter:{type:\'3\'} | noGreaterThanZero:\'litres\' | number}} st.</th>\n                    </tr>\n                    <tr>\n                        <td colspan="5" class="text-center">\n                            <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/checks/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad rad inneb\xE4r att det \xE4r samma avl\xE4sning som ligger n\xE4rmast (i tiden) b\xE5de start och slut p\xE5\n        m\xE5naden. Betyder allts\xE5 att det saknas en avl\xE4sning f\xF6r aktuell nyckel eller att den har hamnat p\xE5 fel datum.\n    </div>\n    <div class="alert bg-danger">\n        En r\xF6dmarkerad rad \xE4r en INAKTIV nyckel som \xE4nd\xE5 har f\xF6rbrukning registrerad p\xE5 sig.\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/deliveries/deliveries.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getDeliveries(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()"><i class="fa fa-plus"></i> Ny leverans\n        </button>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-condensed">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'date\'; reverse=!reverse">Datum</th>\n                        <th ng-click="orderBy=\'invoice_number\'; reverse=!reverse">Fakturanr</th>\n                        <th ng-click="orderBy=\'litres\'; reverse=!reverse">Antal liter</th>\n                        <th ng-click="orderBy=\'price\'; reverse=!reverse">\xE1-pris</th>\n                        <th ng-click="orderBy=\'energy_tax\'; reverse=!reverse">Energiskatt</th>\n                        <th ng-click="orderBy=\'co2_tax\'; reverse=!reverse">CO2-skatt</th>\n                        <th ng-click="orderBy=\'total_unit_price\'; reverse=!reverse">Totalpris</th>\n                        <th ng-click="orderBy=\'total_amount\'; reverse=!reverse">Totalbelopp</th>\n                        <th ng-click="orderBy=\'balance\'; reverse=!reverse">Skuld</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="delivery in type_9196 = (deliveries | filter:{fuel_type:\'0\'}) | orderBy:orderBy:reverse | itemsPerPage: 20" pagination-id="f9196">\n                        <td>{{::delivery.date | date:\'shortDate\'}}</td>\n                        <td>{{::delivery.invoice_number}}</td>\n                        <td>{{::delivery.litres | number}} lit.</td>\n                        <td>{{::delivery.price | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.energy_tax | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.co2_tax | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.total_unit_price | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.total_amount | currency:\'kr\'}}</td>\n                        <td>{{::delivery.balance | currency:\'kr\'}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button class="btn btn-info btn-xs" type="button" ng-click="showPayments(delivery.payments)" ng-disabled="delivery.payments.length === 0">\n                                    <i class="fa fa-eur fa-fw"></i>\n                                </button>\n                                <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(delivery)" ng-disabled="!delivery.editable">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(delivery)" ng-confirm-click="Radera raden?" ng-disabled="!delivery.editable">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="2">Summa/medel</th>\n                        <th>{{type_9196 | sumOfValue:\'litres\' | number}} liter</th>\n                        <th>{{(type_9196 | sumOfValue:\'price\')/type_9196.length | currency:\'kr/lit\'}}</th>\n                        <th>{{(type_9196 | sumOfValue:\'energy_tax\')/type_9196.length | currency:\'kr/lit\'}}</th>\n                        <th>{{(type_9196 | sumOfValue:\'co2_tax\')/type_9196.length | currency:\'kr/lit\'}}</th>\n                        <th>{{(type_9196 | sumOfValue:\'total_unit_price\')/type_9196.length | currency:\'kr/lit\'}}</th>\n                        <th>{{type_9196 | sumOfValue:\'total_amount\' | currency:\'kr\'}}</th>\n                        <th colspan="2">{{type_9196 | sumOfValue:\'balance\' | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="11" class="text-center">\n                            <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-condensed">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'date\'; reverse=!reverse">Datum</th>\n                        <th ng-click="orderBy=\'invoice_number\'; reverse=!reverse">Fakturanr</th>\n                        <th ng-click="orderBy=\'litres\'; reverse=!reverse">Antal liter</th>\n                        <th ng-click="orderBy=\'price\'; reverse=!reverse">\xE1-pris</th>\n                        <th ng-click="orderBy=\'energy_tax\'; reverse=!reverse">Energiskatt</th>\n                        <th ng-click="orderBy=\'co2_tax\'; reverse=!reverse">CO2-skatt</th>\n                        <th ng-click="orderBy=\'total_unit_price\'; reverse=!reverse">Totalpris</th>\n                        <th ng-click="orderBy=\'total_amount\'; reverse=!reverse">Totalbelopp</th>\n                        <th ng-click="orderBy=\'balance\'; reverse=!reverse">Skuld</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="delivery in type_100LL = (deliveries | filter:{fuel_type:\'1\'}) | orderBy:orderBy:reverse | itemsPerPage: 20" pagination-id="f100LL">\n                        <td>{{::delivery.date | date:\'shortDate\'}}</td>\n                        <td>{{::delivery.invoice_number}}</td>\n                        <td>{{::delivery.litres | number}} lit.</td>\n                        <td>{{::delivery.price | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.energy_tax | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.co2_tax | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.total_unit_price | currency:\'kr/lit\'}}</td>\n                        <td>{{::delivery.total_amount | currency:\'kr\'}}</td>\n                        <td>{{::delivery.balance | currency:\'kr\'}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button class="btn btn-info btn-xs" type="button" ng-click="showPayments(delivery.payments)" ng-disabled="delivery.payments.length === 0">\n                                    <i class="fa fa-eur fa-fw"></i>\n                                </button>\n                                <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(delivery)" ng-disabled="!delivery.editable">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(delivery)" ng-confirm-click="Radera raden?" ng-disabled="!delivery.editable">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="2">Summa/medel</th>\n                        <th>{{type_100LL | sumOfValue:\'litres\' | number}} liter</th>\n                        <th>{{(type_100LL | sumOfValue:\'price\')/type_100LL.length | currency:\'kr/lit\'}}</th>\n                        <th>{{(type_100LL | sumOfValue:\'energy_tax\')/type_100LL.length | currency:\'kr/lit\'}}</th>\n                        <th>{{(type_100LL | sumOfValue:\'co2_tax\')/type_100LL.length | currency:\'kr/lit\'}}</th>\n                        <th>{{(type_100LL | sumOfValue:\'total_unit_price\')/type_100LL.length | currency:\'kr/lit\'}}</th>\n                        <th>{{type_100LL | sumOfValue:\'total_amount\' | currency:\'kr\'}}</th>\n                        <th colspan="2">{{type_100LL | sumOfValue:\'balance\' | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="11" class="text-center">\n                            <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/deliveries/delivery-payments.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Betalningar</h4>\n</div>\n<div class="modal-body">\n    <table class="table">\n        <thead>\n        <tr>\n            <th>M\xE5nad</th>\n            <th>Belopp</th>\n            <th>Extrabetalning</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="payment in payments">\n            <td>{{::payment.report.date | date:\'MMMM\'}}</td>\n            <td>{{::payment.amount | currency:\'kr\'}}</td>\n            <td>{{::payment.is_extra_payment ? \'Ja\' : \'Nej\'}}</td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr>\n            <th>Summa</th>\n            <th colspan="2">{{::payments | sumOfValue:\'amount\' | currency:\'kr\'}}</th>\n        </tr>\n        </tfoot>\n    </table>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/deliveries/delivery.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{!!delivery.id ? \'\xC4ndra leverans\' : \'Ny leverans\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="deliveryForm" novalidate>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.date.$invalid && !deliveryForm.date.$pristine}">\n            <label for="date">Datum</label>\n            <input id="date" name="date" class="form-control" type="date" ng-model-options="{timezone : \'UTC\'}" ng-model="delivery.date" required>\n        </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.due_date.$invalid && !deliveryForm.due_date.$pristine}">\n                <label for="due_date">F\xF6rfallodatum</label>\n                <input id="due_date" name="due_date" class="form-control" type="date" ng-model-options="{timezone : \'UTC\'}" ng-model="delivery.due_date" required>\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : deliveryForm.fuel_type.$invalid && !deliveryForm.fuel_type.$pristine}">\n            <label for="type">Br\xE4nsletyp</label>\n            <select name="type" id="type" ng-model="delivery.fuel_type" class="form-control" required convert-to-number>\n                <option value="0">AVGAS 91/96 UL</option>\n                <option value="1">AVGAS 100LL</option>\n            </select>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.invoice_number.$invalid && !deliveryForm.invoice_number.$pristine}">\n                <label for="invoice_number">Fakturanummer</label>\n                <input id="invoice_number" name="invoice_number" class="form-control" type="number" ng-model="delivery.invoice_number" min="0">\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.ocr_number.$invalid && !deliveryForm.ocr_number.$pristine}">\n                <label for="ocr_number">Referensnummer</label>\n                <input id="ocr_number" name="ocr_number" class="form-control" type="text" ng-model="delivery.ocr_number" required>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.litres.$invalid && !deliveryForm.litres.$pristine}">\n                <label for="litres">Levererat antal liter</label>\n                <input id="litres" name="litres" class="form-control" type="number" min="0" max="35000" ng-model="delivery.litres" required>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.unit_price.$invalid && !deliveryForm.unit_price.$pristine}">\n                <label for="unit_price">Literpris (\n                    <div class="btn-group">\n                        <button class="btn btn-xs" ng-class="{\'btn-success\' : delivery.price_incl_tax, \'btn-danger\' : !delivery.price_incl_tax}" ng-model="delivery.price_incl_tax" uib-btn-radio="!!true">\n                            inkl\n                        </button>\n                        <button class="btn btn-xs" ng-class="{\'btn-success\' : !delivery.price_incl_tax, \'btn-danger\' : delivery.price_incl_tax}" ng-model="delivery.price_incl_tax" uib-btn-radio="!!false">\n                            exkl\n                        </button>\n                    </div>\n                    skatter)</label>\n                <input id="unit_price" name="unit_price" class="form-control" type="text" min="0" ng-model="delivery.price" ng-currency>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.energy_tax.$invalid && !deliveryForm.energy_tax.$pristine}">\n                <label for="energy_tax">Energiskatt</label>\n                <input id="energy_tax" name="energy_tax" class="form-control" type="text" min="0" ng-model="delivery.energy_tax" ng-currency>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : deliveryForm.co2_tax.$invalid && !deliveryForm.co2_tax.$pristine}">\n                <label for="co2_tax">Koldioxidskatt</label>\n                <input id="co2_tax" name="co2_tax" class="form-control" type="text" min="0" ng-model="delivery.co2_tax" ng-currency>\n            </div>\n        </div>\n        <div class="form-group">\n            <label for="total_amount">Totalbelopp</label>\n            <div class="input-group">\n                <input type="text" id="total_amount" name="total_amount" class="form-control" min="0" ng-currency required ng-model="delivery.total_amount">\n                <span class="input-group-addon bg-info text-" ng-click="delivery.total_amount = suggestAmount(delivery)"><strong>F\xF6resl\xE5</strong></span>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(delivery)" ng-disabled="deliveryForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/dispensings/dispensings.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control">\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" id="endDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" name="endDate" ng-model="dates.endDate" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getDispensings(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li class="text-center"><a ng-href="" ng-click="fetchCDH()"><i class="fa fa-refresh"></i> Importera fr\xE5n CDH</a></li>\n            </ul>\n        </div>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-condensed">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'timestamp\'; reverse=!reverse">Tidpunkt</th>\n                        <th ng-click="orderBy=\'key.holder\'; reverse=!reverse">Kund</th>\n                        <th ng-click="orderBy=\'quantity\'; reverse=!reverse">Antal liter</th>\n                        <th ng-click="orderBy=\'server_unit_price\'; reverse=!reverse">\xE1-pris</th>\n                        <th ng-click="orderBy=\'server_amount\'; reverse=!reverse">Totalt</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="dispensing in type_9196 = (dispensings | filter:{fuel_type:\'0\'}) | orderBy:orderBy:reverse | itemsPerPage: 200" pagination-id="f9196">\n                        <td>{{::dispensing.timestamp | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                        <td>{{::dispensing.key.holder}}</td>\n                        <td>{{::dispensing.quantity | number}} lit.</td>\n                        <td>{{::dispensing.server_unit_price | currency:\'kr/lit\'}}</td>\n                        <td>{{::dispensing.server_amount | currency:\'kr\'}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="2">Summa</th>\n                        <th colspan="2">{{type_9196 | sumOfValue:\'quantity\' | number:2}} liter</th>\n                        <th>{{type_9196 | sumOfValue:\'server_amount\' | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="5" class="text-center">\n                            <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-condensed">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'timestamp\'; reverse=!reverse">Tidpunkt</th>\n                        <th ng-click="orderBy=\'key.holder\'; reverse=!reverse">Kund</th>\n                        <th ng-click="orderBy=\'quantity\'; reverse=!reverse">Antal liter</th>\n                        <th ng-click="orderBy=\'server_unit_price\'; reverse=!reverse">\xE1-pris</th>\n                        <th ng-click="orderBy=\'server_amount\'; reverse=!reverse">Totalt</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="dispensing in type_100LL = (dispensings | filter:{fuel_type:\'1\'}) | orderBy:orderBy:reverse | itemsPerPage: 200" pagination-id="f100LL">\n                        <td>{{::dispensing.timestamp | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                        <td>{{::dispensing.key.holder}}</td>\n                        <td>{{::dispensing.quantity | number}} lit.</td>\n                        <td>{{::dispensing.server_unit_price | currency:\'kr/lit\'}}</td>\n                        <td>{{::dispensing.server_amount | currency:\'kr\'}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="2">Summa</th>\n                        <th colspan="2">{{type_100LL | sumOfValue:\'quantity\' | number:2}} liter</th>\n                        <th>{{type_100LL | sumOfValue:\'server_amount\' | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="5" class="text-center">\n                            <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/invoicing/invoicing.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="month" class="sr-only"></label>\n            <input type="month" id="month" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" name="month" ng-model="month.month" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getData(month)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li class="text-center">\n                    <a ng-href="" ng-confirm-click="M\xE5nadsrapporter kommer nu skickas ut till samtliga nyckelinnehavare med en registrerad e-post, vill du forts\xE4tta?" confirmed-click="sendReports(month)"><i class="fa fa-send"></i> Skicka m\xE5nadsrapporter\n                </a></li>\n                \n                <li class="text-center">\n                    <a ng-href="api/fuel/dispensings/exportExternalSie?month={{month.month.toISOString()}}" target="_blank" ng-confirm-click="Exportera periodens externa tankningar f\xF6r samtliga br\xE4nsletyper till SIE-fil?"><i class="fa fa-floppy-o fa-fw"></i> Exportera extern SIE\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'holder\'; reverse=!reverse">Kund</th>\n                        <th ng-click="orderBy=\'quantity\'; reverse=!reverse">Antal liter</th>\n                        <th ng-click="orderBy=\'amount\'; reverse=!reverse">Summa</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="record in type_9196 = (data | filter:{fuel_type:\'0\'}) | orderBy:orderBy:reverse | itemsPerPage: 200" pagination-id="f9196">\n                        <td>{{::record.holder}}</td>\n                        <td>{{::record.quantity | number:2}} lit.</td>\n                        <td>{{::record.amount | currency:\'kr\'}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th>{{type_9196 | sumOfValue:\'quantity\' | number:2}} liter</th>\n                        <th>{{type_9196 | sumOfValue:\'amount\' | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="3" class="text-center">\n                            <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th ng-click="orderBy=\'holder\'; reverse=!reverse">Kund</th>\n                        <th ng-click="orderBy=\'quantity\'; reverse=!reverse">Antal liter</th>\n                        <th ng-click="orderBy=\'amount\'; reverse=!reverse">Summa</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="record in type_100LL = (data | filter:{fuel_type:\'1\'}) | orderBy:orderBy:reverse | itemsPerPage: 200" pagination-id="f100LL">\n                        <td>{{::record.holder}}</td>\n                        <td>{{::record.quantity | number:2}} lit.</td>\n                        <td>{{::record.amount | currency:\'kr\'}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th>{{type_100LL | sumOfValue:\'quantity\' | number:2}} liter</th>\n                        <th>{{type_100LL | sumOfValue:\'amount\' | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="3" class="text-center">\n                            <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/keys/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-danger">\n        En r\xF6dmarkerad nyckel \xE4r en MASTER, SERVICE eller INAKTIV nyckel.\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/keys/key-history.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Tidigare innehavare av nyckel {{::key.number}}</h4>\n</div>\n<div class="modal-body">\n    <table class="table">\n        <thead>\n        <tr>\n            <th>Innehavare</th>\n            <th>Fr\xE5n</th>\n            <th>Till</th>\n            <th>\xC4ndring utf\xF6rd</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="holder in key.previous_holders | orderBy:\'date_of_change\':true">\n            <td>{{::holder.holder}}</td>\n            <td>{{$last ? key.created_at.substr(0, 10) : getFromDate(key.previous_holders[$index+1].date_of_change)}}\n            </td>\n            <td>{{::holder.date_of_change}}</td>\n            <td>{{::holder.created_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/keys/key.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny nyckel\' : \'Redigera \' + key.number}}</h4>\n</div>\n<div class="modal-body">\n    <form name="keyForm" novalidate>\n        <div class="form-group">\n            <label for="fuel_type">Br\xE4nsletyp</label>\n            <select name="fuel_type" class="form-control" ng-disabled="!isNew" id="fuel_type" ng-model="key.fuel_type" convert-to-number required>\n                <option value="0">AVGAS 91/96 UL</option>\n                <option value="1">AVGAS 100LL</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <div class="row">\n                <div ng-class="{\'col-sm-6\' : originalType !== 4 && key.type === 4 && !isNew, \'col-sm-12\' : !(originalType !== 4 && key.type === 4 && !isNew)}">\n                    <label for="type">Nyckeltyp</label>\n\n                    <select name="type" class="form-control" ng-disabled="key.type < 2" id="type" ng-model="key.type" convert-to-number required>\n                        <option value="0" ng-hide="hasMasterKey()">MASTER\n                        </option>\n                        <option value="1" ng-hide="hasServiceKey()">SERVICE\n                        </option>\n                        <option value="2">Egen/annat</option>\n                        <option value="3">Fakturering</option>\n                        <option value="4">Inaktiv</option>\n                    </select>\n                </div>\n                <div class="col-sm-6" ng-show="originalType !== 4 && key.type === 4 && !isNew">\n                    <label for="date_of_change1">Sista betalningsm\xE5nad <span class="fa fa-question-circle" uib-popover="Sista m\xE5nad som innehavaren har tillg\xE5ng till r\xE4kneverket" uib-popover-trigger="mouseenter" class="btn btn-default"></span></label>\n                    <input type="month" id="date_of_change1" class="form-control" ng-model-options="{timezone: \'UTC\'}" ng-model="key.date_of_change" ng-required="originalType !== 4 && key.type === 4 && !isNew">\n                </div>\n            </div>\n        </div>\n        <div class="form-group">\n            <label for="counter_max">St\xF6rsta v\xE4rde</label>\n            <input type="number" min="0" class="form-control" id="counter_max" ng-model="key.counter_max" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : keyForm.number.$invalid && !keyForm.number.$pristine}">\n            <label for="number">Nummer</label>\n\n            <div ng-messages="keyForm.number.$error" ng-hide="!isNew || key.fuel_type === undefined" class="help-block bg-danger">\n                <div ng-message="unique">Detta nyckelnummer existerar redan!</div>\n            </div>\n            <input id="number" name="number" class="form-control" type="number" ng-disabled="!isNew || key.fuel_type === undefined" min="1" ng-model-options="{debounce: 250}" ng-model="key.number" validate-key-unique="key.id ? (keys | filter:{fuel_type:key.fuel_type, id:!key.id}) : (keys | filter:{fuel_type:key.fuel_type})" required>\n        </div>\n        <div class="form-group" ng-hide="key.type == 4" ng-class="{\'has-error\' : keyForm.holder.$invalid && !keyForm.holder.$pristine}">\n            <div class="row">\n                <div ng-class="{\'col-sm-6\' : editHolder || (key.type !== 4 && originalType === 4), \'col-sm-12\' : !editHolder || !(key.type !== 4 && originalType === 4)}">\n                    <label for="holder">Innehavare</label>\n\n                    <div ng-class="{\'input-group\' : !isNew, \'\' : isNew}">\n                        <input id="holder" name="holder" class="form-control" type="text" ng-model="key.holder" maxlength="100" ng-readonly="!isNew && !editHolder" ng-required="key.type != 4">\n                <span class="input-group-addon addon-right" ng-hide="isNew" ng-click="editHolder = !editHolder"><i ng-class="{\'fa fa-lock\': !editHolder, \'fa fa-unlock\': editHolder}"></i></span>\n                    </div>\n                </div>\n                <div class="col-sm-6" ng-show="editHolder || (key.type !== 4 && originalType === 4)">\n                    <label for="date_of_change">{{originalType === 4 ? \'F\xF6rsta\' : \'Sista\'}} betalningsm\xE5nad <span class="fa fa-question" uib-popover="{{originalType === 4 ? \'F\xF6rsta\' : \'Sista\'}} m\xE5nad som innehavaren har tillg\xE5ng till r\xE4kneverket" uib-popover-trigger="mouseenter" class="btn btn-default"></span></label>\n                    <input type="month" id="date_of_change" class="form-control" ng-model="key.date_of_change" ng-model-options="{timezone: \'UTC\'}" ng-required="editHolder || (key.type !== 4 && originalType === 4)">\n                </div>\n            </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : keyForm.email.$invalid && !keyForm.email.$pristine}" ng-hide="key.type != 3">\n            <label for="email">Notifieringsmail</label>\n            <input type="email" name="email" class="form-control" id="email" ng-model="key.email">\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : keyForm.customer_number.$invalid && !keyForm.customer_number.$pristine}" ng-hide="key.type != 3">\n            <label for="customer_number">Kundnummer</label>\n            <input id="customer_number" name="customer_number" class="form-control" type="number" ng-model="key.customer_number" min="0">\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(key)" ng-disabled="keyForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/keys/keys.html','<div ba-panel>\n    <div class="form-inline text-center">\n        <button class="btn btn-primary btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Ny nyckel\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </div>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-hover" st-table="dKeys" st-safe-src="keys">\n                    <thead>\n                    <tr>\n                        <th st-sort="number" st-sort-default="true">Nummer</th>\n                        <th st-sort="holder">Innehavare</th>\n                        <th st-sort="customer_number">Kundnummer</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="key in dKeys | filter:{fuel_type:\'0\'} | itemsPerPage:20" pagination-id="f9196" ng-class="{\'danger\': key.is_service || key.is_master || key.type === 4}">\n                        <td>{{::key.number}}</td>\n                        <td>{{::key.holder}}</td>\n                        <td>{{::key.customer_number}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button type="button" ng-show="key.deleted_at == null" class="btn btn-primary btn-xs" ng-click="openModal(key)">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button type="button" class="btn btn-info btn-xs" ng-click="showHistory(key)" ng-disabled="key.previous_holders.length === 0"><i class="fa fa-folder-open fa-fw"></i>\n                                </button>\n                                <button type="button" ng-show="key.deleted_at == null" class="btn btn-danger btn-xs" confirmed-click="delete(key)" ng-confirm-click="Radera {{key.number}}?">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan="4" class="text-center">\n                            <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html" pagination-id="f9196"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-hover" st-table="dKeys" st-safe-src="keys">\n                    <thead>\n                    <tr>\n                        <th st-sort="number" st-sort-default="true">Nummer</th>\n                        <th st-sort="holder">Innehavare</th>\n                        <th st-sort="customer_number">Kundnummer</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="key in dKeys | filter:{fuel_type:\'1\'} | itemsPerPage:20" pagination-id="f100LL" ng-class="{\'danger\': key.is_service || key.is_master || key.type === 4}">\n                        <td>{{::key.number}}</td>\n                        <td>{{::key.holder}}</td>\n                        <td>{{::key.customer_number}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button type="button" ng-show="key.deleted_at == null" class="btn btn-primary btn-xs" ng-click="openModal(key)">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button type="button" class="btn btn-info btn-xs" ng-click="showHistory(key)" ng-disabled="key.previous_holders.length === 0"><i class="fa fa-folder-open fa-fw"></i>\n                                </button>\n                                <button type="button" ng-show="key.deleted_at == null" class="btn btn-danger btn-xs" confirmed-click="delete(key)" ng-confirm-click="Radera {{key.number}}?">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan="4" class="text-center">\n                            <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html" pagination-id="f100LL"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/log/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad rad \xE4r en rad som \xE4nnu inte exporterats.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad rad \xE4r en rad som har exporterats.\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/log/log.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control">\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" id="endDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" name="endDate" ng-model="dates.endDate" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getLog(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li class="text-center">\n                    <a ng-href="api/fuel/log/export.sie?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}" target="_blank" ng-confirm-click="Exportera periodens tankningar f\xF6r samtliga br\xE4nsletyper till SIE-fil?"><i class="fa fa-floppy-o fa-fw"></i> Exportera\n                        SIE</a></li>\n                <li class="text-center"><a ng-href="" ng-confirm-click="Vill du verkligen l\xE5sa samtliga icke-SIE rader? Detta g\xE4ller samtliga br\xE4nsletyper!" confirmed-click="lock(dates)"><i class="fa fa-pause"></i> L\xE5s\n                    icke-SIE rader</a></li>\n                <li class="divider"></li>\n                <li class="text-center">\n                    <a ng-href="api/fuel/log/export.pdf?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}&fuelType={{activeTab}}" target="_blank"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a></li>\n            </ul>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96UL" select="$parent.$parent.activeTab = 0">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th>Datum</th>\n                        <th>Flygplan</th>\n                        <th>K\xF6pare</th>\n                        <th>S\xE4ljare</th>\n                        <th>Betals\xE4tt</th>\n                        <th>M\xE4tarst\xE4llning innan</th>\n                        <th>M\xE4tarst\xE4llning efter</th>\n                        <th>Differens</th>\n                        <th>Summa</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="log in type9196 = (logs | filter:{type:0} | orderBy:\'meter_after\':true)" ng-class="{\'bg-success\' : log.exported, \'bg-warning\' : !log.exported}">\n                        <td>{{::log.date | date:\'shortDate\'}}</td>\n                        <td>{{::log.aircraft}}</td>\n                        <td>{{::log.buyer}}</td>\n                        <td>{{::log.seller}}</td>\n                        <td>{{::log.payment_method_text}}</td>\n                        <td ng-class="{\'text-danger\' : log.meter_before !== type9196[$index+1].meter_after && !$last}">\n                            {{::log.meter_before}}\n                        </td>\n                        <td ng-class="{\'text-danger\' : log.meter_after !== type9196[$index-1].meter_before && !$first}">\n                            {{::log.meter_after}}\n                        </td>\n                        <td>{{calculateDifference(log.meter_after, log.meter_before) | number:0}} liter</td>\n                        <td>{{::log.amount | currency:\'kr\'}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <a href="api/fuel/log/{{log.id}}" target="_blank" class="btn btn-info btn-xs">\n                                    <i class="fa fa-floppy-o fa-fw"></i>\n                                </a>\n                                <button ng-disabled="log.exported" class="btn btn-primary btn-xs" type="button" ng-click="openModal(log)">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button ng-disabled="log.exported" ng- class="btn btn-danger btn-xs" type="button" confirmed-click="delete(log)" ng-confirm-click="Radera raden?">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="8">Summa</th>\n                        <th colspan="2">{{type9196 | sumOfValue:\'amount\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL" select="$parent.$parent.activeTab = 1">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th>Datum</th>\n                        <th>Flygplan</th>\n                        <th>K\xF6pare</th>\n                        <th>S\xE4ljare</th>\n                        <th>Betals\xE4tt</th>\n                        <th>M\xE4tarst\xE4llning innan</th>\n                        <th>M\xE4tarst\xE4llning efter</th>\n                        <th>Differens</th>\n                        <th>Summa</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="log in type100LL = (logs | filter:{type:1} | orderBy:\'meter_after\':true)" ng-class="{\'bg-success\' : log.exported, \'bg-warning\' : !log.exported}">\n                        <td>{{::log.date | date:\'shortDate\'}}</td>\n                        <td>{{::log.aircraft}}</td>\n                        <td>{{::log.buyer}}</td>\n                        <td>{{::log.seller}}</td>\n                        <td>{{::log.payment_method_text}}</td>\n                        <td ng-class="{\'text-danger\' : log.meter_before !== type100LL[$index+1].meter_after && !$last}">\n                            {{::log.meter_before}}\n                        </td>\n                        <td ng-class="{\'text-danger\' : log.meter_after !== type100LL[$index-1].meter_before && !$first}">\n                            {{::log.meter_after}}\n                        </td>\n                        <td>{{calculateDifference(log.meter_after, log.meter_before) | number:0 }} liter</td>\n                        <td>{{::log.amount | currency:\'kr\'}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <a href="api/fuel/log/{{log.id}}" target="_blank" class="btn btn-info btn-xs">\n                                    <i class="fa fa-floppy-o fa-fw"></i>\n                                </a>\n                                <button ng-disabled="log.exported" class="btn btn-primary btn-xs" type="button" ng-click="openModal(log)">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button ng-disabled="log.exported" class="btn btn-danger btn-xs" type="button" confirmed-click="delete(log)" ng-confirm-click="Radera raden?">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="8">Summa</th>\n                        <th colspan="2">{{type100LL | sumOfValue:\'amount\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <!--    <uib-tab heading="JET A1"\n                 select="$parent.$parent.activeTab = 2">\n                <div class="table-responsive">\n                    <table class="table table-condensed">\n                        <thead>\n                        <tr>\n                            <th>Datum</th>\n                            <th>Flygplan</th>\n                            <th>K\xF6pare</th>\n                            <th>S\xE4ljare</th>\n                            <th>Betals\xE4tt</th>\n                            <th>M\xE4tarst\xE4llning innan</th>\n                            <th>M\xE4tarst\xE4llning efter</th>\n                            <th>Differens</th>\n                            <th>Summa</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr dir-paginate="log in typeJETA1 = (logs | filter:{type:2} | orderBy:\'meter_after\':true) | itemsPerPage:20"\n                            pagination-id="fJETA1"\n                            ng-class="{\'bg-success\' : log.exported, \'bg-warning\' : !log.exported}">\n                            <td>{{::log.date | date:\'shortDate\'}}</td>\n                            <td>{{::log.aircraft}}</td>\n                            <td>{{::log.buyer}}</td>\n                            <td>{{::log.seller}}</td>\n                            <td>{{::log.payment_method_text}}</td>\n                            <td ng-class="{\'text-danger\' : log.meter_before !== typeJETA1[$index+1].meter_after && !$last}">\n                                {{::log.meter_before}}\n                            </td>\n                            <td ng-class="{\'text-danger\' : log.meter_after !== typeJETA1[$index-1].meter_before && !$first}">\n                                {{::log.meter_after}}\n                            </td>\n                            <td>{{calculateDifference(log.meter_after, log.meter_before) | number:0}} liter</td>\n                            <td>{{::log.amount | currency:\'kr\'}}</td>\n                            <td>\n                                <div class="pull-right">\n                                    <a href="api/fuel/log/{{log.id}}"\n                                       target="_blank"\n                                       class="btn btn-info btn-xs btn-with-icon">\n                                        <i class="fa fa-floppy-o fa-fw"></i>\n                                    </a>\n                                    <button ng-disabled="log.exported"\n                                            class="btn btn-primary btn-xs btn-with-icon"\n                                            type="button"\n                                            ng-click="openModal(log)">\n                                        <i class="fa fa-pencil fa-fw"></i>\n                                    </button>\n                                    <button ng-disabled="log.exported"\n                                            class="btn btn-danger btn-xs btn-with-icon"\n                                            type="button"\n                                            confirmed-click="delete(log)"\n                                            ng-confirm-click="Radera raden?">\n                                        <i class="fa fa-times fa-fw"></i>\n                                    </button>\n                                </div>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <th colspan="8">Summa</th>\n                            <th colspan="2">{{typeJETA1 | sumOfValue:\'amount\' | currency}}</th>\n                        </tr>\n                        <tr>\n                            <td colspan="10"\n                                class="text-center">\n                                <dir-pagination-controls\n                                        pagination-id="fJETA1"\n                                        template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </div>\n            </uib-tab>\n            -->\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/log/log.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Redigera tankning</h4>\n</div>\n<div class="modal-body row">\n    <form name="logForm" novalidate>\n        <div class="col-md-6">\n            <div class="form-group">\n                <label for="date">Datum</label>\n                <input id="date" name="date" class="form-control" type="date" ng-model="log.date" required>\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.aircraft.$invalid && !logForm.aircraft.$pristine}">\n                <label for="aircraft">Registrering</label>\n                <input id="aircraft" name="aircraft" class="form-control text-uppercase" type="text" ng-model="log.aircraft" maxlength="10" placeholder="SE-XYZ" ng-pattern="/\\b([A-Z0-9]{2}-[A-Z]{3})|\\b([A-Z]{1}-[A-Z0-9]{4})|\\b(N[A-Z0-9]{5})/i" required>\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.buyer.$invalid && !logForm.buyer.$pristine}">\n                <label for="buyer">K\xF6pare</label>\n                <input type="text" id="buyer" ng-model="log.buyer" class="form-control text-capitalize" name="buyer" placeholder="Sven Svensson" required>\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.buyer_email.$invalid && !logForm.buyer_email.$pristine}">\n                <label for="buyer_email">K\xF6parens email</label>\n                <input type="email" id="buyer_email" ng-model="log.buyer_email" class="form-control" name="buyer_email">\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.buyer_address.$invalid && !logForm.buyer_address.$pristine}" ng-hide="log.payment_method != 2">\n                <label for="buyer_address">K\xF6parens adress</label>\n                <textarea rows="4" id="buyer_address" name="buyer_address" class="form-control" ng-model="log.buyer_address" ng-disabled="log.payment_method != 2"></textarea>\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.seller.$invalid && !logForm.seller.$pristine}">\n                <label for="seller">S\xE4ljare</label>\n                <input type="text" id="seller" ng-model="log.seller" class="form-control text-capitalize" name="seller" placeholder="Erik Bodin" required>\n            </div>\n        </div>\n        <div class="col-md-6">\n            <div class="form-group" ng-class="{\'has-error\' : editForm.payment_method.$invalid && !editForm.payment_method.$pristine}">\n                <label for="payment_method">Betals\xE4tt</label>\n                <select id="payment_method" class="form-control" ng-model="log.payment_method" convert-to-number required>\n                    <option value="">V\xE4lj betals\xE4tt</option>\n                    <option value="0">Kort</option>\n                    <option value="5">Swish</option>\n                    <option value="1">Kontant</option>\n                    <option value="2">Faktura</option>\n                    <option value="3">Annat</option>\n                    <option value="4">Ej till SIE</option>\n                </select>\n            </div>\n            <div class="form-group" ng-if="log.payment_method == 3">\n                <label>Kontering</label>\n                <transactions-editor ng-model="log.transactions" amount="log.amount"></transactions-editor>\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.meter_before.$invalid && !logForm.meter_before.$pristine}">\n                <label for="meter_before">M\xE4tarst\xE4llning f\xF6re</label>\n                <input id="meter_before" name="meter_before" class="form-control" type="number" ng-model="log.meter_before" min="0" max="{{log.meter_after}}" required>\n            </div>\n            <div class="form-group" ng-class="{\'has-error\' : logForm.meter_after.$invalid && !logForm.meter_after.$pristine}">\n                <label for="meter_after">M\xE4tarst\xE4llning efter</label>\n                <input id="meter_after" name="meter_after" class="form-control" type="number" ng-model="log.meter_after" min="{{log.meter_before}}" required>\n            </div>\n            <div class="form-group">\n                <label for="difference">Antal liter</label>\n                <input id="difference" name="difference" class="form-control" type="number" value="{{log.meter_after - log.meter_before}}" disabled="disabled">\n            </div>\n            <div class="form-group">\n                <label for="taxes">Skatt (totalt per liter)</label>\n                <input id="taxes" name="taxes" class="form-control" type="text" ng-currency ng-model="log.sum_of_taxes">\n            </div>\n            <div class="form-group">\n                <label for="amount">Belopp</label>\n                <input id="amount" name="amount" class="form-control" type="text" ng-model="log.amount" ng-readonly="log.payment_method == 3" ng-currency required>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(log)" ng-disabled="logForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-warning" push-to-array="log.transactions" ng-show="log.payment_method == 3">L\xE4gg till transaktion\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/pricing/price.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Nytt pris\' : \'Redigera pris\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="priceForm" novalidate>\n        <div class="form-group">\n            <label for="fuel_type">Br\xE4nsletyp</label>\n            <select id="fuel_type" name="fuel_type" class="form-control" ng-model="price.fuel_type" convert-to-number required>\n                <option value="0">AVGAS 91/96UL</option>\n                <option value="1">AVGAS 100LL</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="type">Pristyp</label>\n            <select id="type" name="type" class="form-control" ng-model="price.type" convert-to-number required>\n                <option value="0">Fakturering</option>\n                <option value="1">Externt</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="price">Pris per liter (inkl. allt)</label>\n            <input type="text" name="price" id="price" class="form-control" ng-model="price.price" min="0" max="100" required ng-currency>\n        </div>\n        <div class="form-group">\n            <label for="valid_from">G\xE4llande fr\xE5n</label>\n            <input type="date" name="valid_from" ng-model-options="{timezone:\'UTC\'}" class="form-control" id="valid_from" ng-min="minDate" ng-model="price.valid_from" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(price)" ng-disabled="priceForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/pricing/pricing.html','<div ba-panel>\n    <div class="form-inline form-group text-center">\n        <button class="btn btn-primary btn-with-icon" ng-click="openModal()"><i class="fa fa-plus"></i> Nytt pris\n        </button>\n        <button class="btn btn-success btn-with-icon" ng-confirm-click="Du kommer nu skicka ut prisplaneringsinformation till samtliga fakuteringskunder med en giltig email, forts\xE4tta?" confirmed-click="sendMail()"><i class="fa fa-send"></i> Maila prisplanering\n        </button>\n    </div>\n    <uib-tabset justified="true">\n        <uib-tab heading="Fakturering">\n            <div class="row">\n                <div class="table-responsive col-md-6">\n                    <h4 class="text-center">AVGAS 91/96UL</h4>\n                    <table class="table table-condensed table-hover">\n                        <thead>\n                        <tr>\n                            <th>Pris</th>\n                            <th>G\xE4llande from</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr dir-paginate="price in type9196f = (prices | filter:{type:\'0\', fuel_type:\'0\'}) | itemsPerPage: 20" pagination-id="f9196">\n                            <td>{{::price.price | currency:\'kr/lit\'}}</td>\n                            <td>{{::price.valid_from | date:\'shortDate\'}}</td>\n                            <td>\n                                <div class="pull-right">\n                                    <button type="button" class="btn btn-primary btn-xs" ng-disabled="!$first" ng-click="openModal(price, type9196f[1].valid_from)">\n                                        <i class="fa fa-pencil fa-fw"></i>\n                                    </button>\n                                    <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(price)" ng-disabled="!$first" ng-confirm-click="Radera?">\n                                        <i class="fa fa-times fa-fw"></i>\n                                    </button>\n                                </div>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <td colspan="5" class="text-center">\n                                <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </div>\n                <div class="table-responsive col-md-6">\n                    <h4 class="text-center">AVGAS 100LL</h4>\n                    <table class="table table-condensed table-hover">\n                        <thead>\n                        <tr>\n                            <th>Pris</th>\n                            <th>G\xE4llande from</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr dir-paginate="price in type100LLf = (prices | filter:{type:\'0\', fuel_type:\'1\'}) | itemsPerPage: 20" pagination-id="f100LL">\n                            <td>{{::price.price | currency:\'kr/lit\'}}</td>\n                            <td>{{::price.valid_from | date:\'shortDate\'}}</td>\n                            <td>\n                                <div class="pull-right">\n                                    <button type="button" class="btn btn-primary btn-xs" ng-disabled="!$first" ng-click="openModal(price, type100LLf[1].valid_from)">\n                                        <i class="fa fa-pencil fa-fw"></i>\n                                    </button>\n                                    <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(price)" ng-disabled="!$first" ng-confirm-click="Radera?">\n                                        <i class="fa fa-times fa-fw"></i>\n                                    </button>\n                                </div>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <td colspan="5" class="text-center">\n                                <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </div>\n            </div>\n        </uib-tab>\n        <uib-tab heading="Externt">\n            <div class="row">\n                <div class="table-responsive col-md-6">\n                    <h4 class="text-center">AVGAS 91/96UL</h4>\n                    <table class="table table-condensed table-hover">\n                        <thead>\n                        <tr>\n                            <th>Pris</th>\n                            <th>G\xE4llande from</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr dir-paginate="price in type9196e = (prices | filter:{type:\'1\', fuel_type:\'0\'}) | itemsPerPage: 20" pagination-id="e9196">\n                            <td>{{::price.price | currency:\'kr/lit\'}}</td>\n                            <td>{{::price.valid_from | date:\'shortDate\'}}</td>\n                            <td>\n                                <div class="pull-right">\n                                    <button type="button" class="btn btn-primary btn-xs" ng-disabled="!$first" ng-click="openModal(price, type9196e[1].valid_from)">\n                                        <i class="fa fa-pencil fa-fw"></i>\n                                    </button>\n                                    <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(price)" ng-disabled="!$first" ng-confirm-click="Radera?">\n                                        <i class="fa fa-times fa-fw"></i>\n                                    </button>\n                                </div>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <td colspan="5" class="text-center">\n                                <dir-pagination-controls pagination-id="e9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </div>\n                <div class="table-responsive col-md-6">\n                    <h4 class="text-center">AVGAS 100LL</h4>\n                    <table class="table table-condensed table-hover">\n                        <thead>\n                        <tr>\n                            <th>Pris</th>\n                            <th>G\xE4llande from</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr dir-paginate="price in type100LLe = (prices | filter:{type:\'1\', fuel_type:\'1\'}) | itemsPerPage: 20" pagination-id="e100LL">\n                            <td>{{::price.price | currency:\'kr/lit\'}}</td>\n                            <td>{{::price.valid_from | date:\'shortDate\'}}</td>\n                            <td>\n                                <div class="pull-right">\n                                    <button type="button" class="btn btn-primary btn-xs" ng-disabled="!$first" ng-click="openModal(price, type100LLe[1].valid_from)">\n                                        <i class="fa fa-pencil fa-fw"></i>\n                                    </button>\n                                    <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(price)" ng-disabled="!$first" ng-confirm-click="Radera?">\n                                        <i class="fa fa-times fa-fw"></i>\n                                    </button>\n                                </div>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <td colspan="5" class="text-center">\n                                <dir-pagination-controls pagination-id="e100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </div>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/readings/bulkimport.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Bulkimport av avl\xE4sningar</h4>\n</div>\n<div class="modal-body">\n    <form name="readingsForm" novalidate>\n        <uib-tabset justified="true">\n            <uib-tab heading="91/96">\n                <div ng-form="readings9196" novalidate>\n                    <div class="row">\n                        <div class="form-group col-md-6">\n                            <label for="timestamp">Tidpunkt</label>\n                            <input type="datetime-local" name="timestamp" ng-model="data.f9196.timestamp" id="timestamp" class="form-control" required>\n                        </div>\n                        <div class="form-group col-md-6">\n                            <label for="reader">Avl\xE4sare</label>\n                            <input type="text" class="form-control" name="reader" id="reader" ng-model="data.f9196.reader" required maxlength="30">\n                        </div>\n                    </div>\n                    <div class="row" ng-repeat="keygroup in keygroups.group9196">\n                        <div class="form-group col-md-4" ng-repeat="reading in keygroup">\n                            <label>{{reading.key.number + \': \' + reading.key.holder}}</label>\n                            <input type="number" min="0" max="{{reading.key.counter_max}}" name="meter_value" class="form-control" ng-model="reading.meter_value" required>\n                        </div>\n                    </div>\n                </div>\n            </uib-tab>\n            <uib-tab heading="100LL">\n                <div ng-form="readings100LL" novalidate>\n                    <div class="row">\n                        <div class="form-group col-md-6">\n                            <label for="timestamp1">Tidpunkt</label>\n                            <input type="datetime-local" name="timestamp" ng-model="data.f100LL.timestamp" id="timestamp1" class="form-control" required>\n                        </div>\n                        <div class="form-group col-md-6">\n                            <label for="reader1">Avl\xE4sare</label>\n                            <input type="text" class="form-control" name="reader" id="reader1" ng-model="data.f100LL.reader" required maxlength="30">\n                        </div>\n                    </div>\n                    <div class="row" ng-repeat="keygroup in keygroups.group100LL">\n                        <div class="form-group col-md-4" ng-repeat="reading in keygroup">\n                            <label>{{reading.key.number + \': \' + reading.key.holder}}</label>\n                            <input type="number" min="0" max="{{reading.key.counter_max}}" name="meter_value" class="form-control" ng-model="reading.meter_value" required>\n                        </div>\n                    </div>\n                </div>\n            </uib-tab>\n        </uib-tabset>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-disabled="readingsForm.$invalid" ng-click="save(keygroups, data)">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/readings/reading.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny avl\xE4sning\' : \'\xC4ndra avl\xE4sning\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="readingForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : readingForm.type.$invalid && !readingForm.type.$pristine}">\n            <label for="type">Br\xE4nsletyp</label>\n            <select name="type" id="type" ng-model="type" class="form-control" ng-change="setReadingDefaults(type)" ng-disabled="!isNew" convert-to-number required>\n                <option value="0">AVGAS 91/96 UL</option>\n                <option value="1">AVGAS 100LL</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="key">Nyckel</label>\n            <select class="form-control" name="key" id="key" ng-options="key as key.number + \' (\' + key.holder + \')\' for key in keys | filter:{fuel_type:type} track by key.id" ng-model="reading.key" required></select>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : readingForm.meter_value.$invalid && !readingForm.meter_value.$pristine}">\n            <label for="meter_value">Avl\xE4st v\xE4rde</label>\n            <input id="meter_value" name="meter_value" class="form-control" type="number" min="0" ng-model="reading.meter_value" required>\n        </div>\n        <div class="form-group">\n            <label for="timestamp">Tidpunkt f\xF6r avl\xE4sning</label>\n            <input id="timestamp" name="timestamp" class="form-control" type="datetime-local" ng-model="reading.timestamp" required>\n        </div>\n        <div class="form-group">\n            <label for="reader">Avl\xE4sare</label>\n            <input type="text" name="reader" id="reader" class="form-control" ng-model="reading.reader">\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(reading)" ng-disabled="readingForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/readings/readings.html','<div ba-panel>\n    <div class="form-group">\n        <form class="form-inline text-center" name="queryForm" novalidate>\n            <div class="form-group">\n                <label for="month" class="sr-only"></label>\n                <input type="month" id="month" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" name="month" ng-model="month.month" class="form-control">\n            </div>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getReadings(month)"><i class="fa fa-refresh"></i> Visa\n            </button>\n            <div class="btn-group" uib-dropdown>\n                <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n                </button>\n                <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                    <i class="caret"></i>\n                    <span class="sr-only">Split button!</span>\n                </button>\n                <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                    <li><a href="" ng-click="openModal()" class="text-center"><i class="fa fa-plus"></i> Ny avl\xE4sning</a>\n                    </li>\n                    <li><a href="" ng-click="openBulkModal()" class="text-center"><i class="fa fa-plus"></i> Bulkavl\xE4sning</a>\n                    </li>\n                </ul>\n            </div>\n        </form>\n    </div>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dReadings" st-safe-src="readings">\n                    <thead>\n                    <tr>\n                        <th st-sort="key.number" st-sort-default="true">Nyckel</th>\n                        <th st-sort="meter_value">Avl\xE4st v\xE4rde</th>\n                        <th st-sort="timestamp">Tidpunkt</th>\n                        <th st-sort="reader">Avl\xE4sare</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="reading in dReadings | filter:{key:{fuel_type:\'0\'}} | itemsPerPage: 20" pagination-id="f9196">\n                        <td>{{::reading.key.number}} ({{::reading.key.holder}})</td>\n                        <td>{{::reading.meter_value}}</td>\n                        <td>{{::reading.timestamp | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                        <td>{{::reading.reader}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(reading)" ng-disabled="reading.exported">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(reading)" ng-confirm-click="Radera raden?" ng-disabled="reading.exported">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan="9" class="text-center">\n                            <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-condensed" st-table="dReadings" st-safe-src="readings">\n                    <thead>\n                    <tr>\n                        <th st-sort="key.number" st-sort-default="true">Nyckel</th>\n                        <th st-sort="meter_value">Avl\xE4st v\xE4rde</th>\n                        <th st-sort="timestamp">Tidpunkt</th>\n                        <th st-sort="reader">Avl\xE4sare</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="reading in dReadings | filter:{key:{fuel_type:\'1\'}} | itemsPerPage: 20" pagination-id="f100LL">\n                        <td>{{::reading.key.number}} ({{::reading.key.holder}})</td>\n                        <td>{{::reading.meter_value}}</td>\n                        <td>{{::reading.timestamp | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                        <td>{{::reading.reader}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button class="btn btn-primary btn-xs" type="button" ng-click="openModal(reading)" ng-disabled="reading.exported">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(reading)" ng-confirm-click="Radera raden?" ng-disabled="reading.exported">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan="9" class="text-center">\n                            <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/reports/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad leverans \xE4r en leverans d\xE4r en skuld fortfarande finns.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad leverans \xE4r en leverans som betalats av helt och h\xE5llet.\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/reports/report.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Nytt avr\xE4kningsbesked</h4>\n</div>\n<div class="modal-body">\n    <form name="reportForm" novalidate>\n        <div class="row">\n            <div class="form-group col-md-6">\n                <label>Produkt</label>\n                <select name="fuel_type" class="form-control" ng-model="report.fuel_type" ng-change="getReportData(report.fuel_type, report.date)" required>\n                    <option value="0">AVGAS 91/96 UL</option>\n                    <option value="1">AVGAS 100LL</option>\n                </select>\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\': reportForm.month.$invalid && reportForm.month.$touched}">\n                <label>M\xE5nad</label>\n                <input type="month" class="form-control" name="month" ng-disabled="reportForm.fuel_type.$invalid" ng-model-options="{timezone: \'UTC\'}" ng-model="report.date" ng-change="getReportData(report.fuel_type, report.date)" validate-report-exists ng-model-options="{debounce:250}" fuel-type="{{report.fuel_type}}" required>\n\n                <div class="bg-danger" ng-show="reportForm.month.$error.reportExists">Det finns redan en rapport aktuell m\xE5nad</div>\n            </div>\n        </div>\n        <ng-form class="form-horizontal">\n            <div class="form-group">\n                <label for="ingoing_supply" class="col-sm-8 text-left control-label">Ing\xE5ende lagersaldo den f\xF6rste i m\xE5naden</label>\n\n                <div class="col-sm-4">\n                    <input type="number" min="0" class="form-control" id="ingoing_supply" ng-model="report.ingoing_supply" readonly="readonly">\n                </div>\n            </div>\n            <div class="form-group">\n                <label for="total_deliveries" class="col-sm-8 control-label">Inleveranser under m\xE5naden</label>\n\n                <div class="col-sm-4">\n                    <input type="number" min="0" class="form-control" id="total_deliveries" ng-model="report.total_deliveries" readonly="readonly">\n                </div>\n            </div>\n            <div class="form-group">\n                <label for="outgoing_supply" class="col-sm-8 control-label">Utg\xE5ende lagersaldo den siste i m\xE5naden</label>\n\n                <div class="col-sm-4">\n                    <div class="input-group">\n                        <input type="number" min="0" class="form-control" ng-readonly="!manualUsage" ng-change="recalculatePayments()" id="outgoing_supply" ng-model="report.outgoing_supply">\n                        <i class="input-group-addon" ng-click="manualUsage = !manualUsage"><i ng-class="{\'fa fa-lock\': !manualUsage, \'fa fa-unlock\': manualUsage}"></i></i>\n                    </div>\n                </div>\n            </div>\n            <div class="form-group" ng-if="report.losses !== 0 && report.losses !== undefined">\n                <label for="losses" class="col-sm-8 control-label">F\xF6rluster</label>\n\n                <div class="col-sm-4">\n                    <input type="number" class="form-control" id="losses" value="{{report.losses}}" required readonly="readonly">\n                </div>\n            </div>\n            <div class="form-group">\n                <label for="montly_usage" class="col-sm-8 control-label">M\xE5nadens f\xF6rbrukning</label>\n\n                <div class="col-sm-4">\n                    <input type="number" min="0" class="form-control" id="montly_usage" value="{{report.monthly_usage}}" disabled="disabled">\n                </div>\n            </div>\n        </ng-form>\n        <h4>Br\xE4nsle i lager</h4>\n        <uib-accordion close-others="oneAtATime">\n            <div uib-accordion-group ng-repeat="payment in report.fuel_payments.stock">\n                <uib-accordion-heading>\n                    Faktura: {{payment.invoice_number}}\n                </uib-accordion-heading>\n                <ng-form class="row" style="margin: 0">\n                    <div class="form-group col-md-6">\n                        <label>liter</label>\n                        <input type="number" class="form-control" ng-model="payment.litres" readonly="readonly">\n                    </div>\n                    <div class="form-group col-md-6">\n                        <label>belopp</label>\n                        <input type="text" class="form-control" value="{{payment.amount | currency}}" readonly="readonly">\n                    </div>\n                </ng-form>\n            </div>\n        </uib-accordion>\n        <h4>F\xF6rbrukning</h4>\n        <uib-accordion close-others="oneAtATime">\n            <div uib-accordion-group ng-repeat="payment in report.fuel_payments.fuel">\n                <uib-accordion-heading>\n                    Faktura: {{payment.invoiceNumber}}. Kvar till slutbetalad: {{(payment.amountLeft - payment.amount) |\n                    currency}}.\n                </uib-accordion-heading>\n                <ng-form class="row" style="margin: 0">\n                    <div class="form-group col-md-4">\n                        <label>liter</label>\n                        <input type="number" class="form-control" ng-model="payment.litres" readonly="readonly">\n                    </div>\n                    <div class="form-group col-md-4">\n                        <label>pris</label>\n\n                        <input type="text" class="form-control" ng-model="payment.price" readonly="readonly" ng-currency>\n                    </div>\n                    <div class="form-group col-md-4">\n                        <label>belopp</label>\n                        <input type="text" class="form-control" value="{{payment.amount | currency}}" readonly="readonly">\n                    </div>\n                </ng-form>\n            </div>\n        </uib-accordion>\n        <h4>Extra</h4>\n        <uib-accordion close-others="oneAtATime">\n            <div uib-accordion-group ng-repeat="payment in report.fuel_payments.extra">\n                <uib-accordion-heading>\n                    Faktura: {{payment.invoice_number}}\n                </uib-accordion-heading>\n                <ng-form class="row" style="margin: 0">\n                    <div class="form-group col-md-4">\n                        <label>liter</label>\n                        <input type="number" class="form-control" ng-model="payment.litres" readonly="readonly">\n                    </div>\n                    <div class="form-group col-md-4">\n                        <label>pris</label>\n\n                        <input type="text" class="form-control" ng-model="payment.price" readonly="readonly" ng-currency>\n                    </div>\n                    <div class="form-group col-md-4">\n                        <label>belopp</label>\n                        <input type="text" class="form-control" value="{{payment.amount | currency}}" readonly="readonly">\n                    </div>\n                </ng-form>\n            </div>\n        </uib-accordion>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(report)" ng-disabled="reportForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/reports/reports.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getPayments(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <button type="button" class="btn btn-primary btn-with-icon" ng-click="openModal()"><i class="fa fa-plus"></i> Skapa nytt avr\xE4kningsbesked\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab heading="AVGAS 91/96 UL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th>M\xE5nad</th>\n                        <th>M\xE5nadens f\xF6rbrukning</th>\n                        <th>F\xF6rluster</th>\n                        <th>Utbetalat belopp</th>\n                        <th>Varav extra</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="report in type_9196 = (reports | filter:{fuel_type:0}) | itemsPerPage: 20" pagination-id="f9196">\n                        <td>{{::report.date | date:\'MMMM\'}}</td>\n                        <td>{{::report.monthly_usage | number}} liter</td>\n                        <td>{{::report.losses || 0 | number}} liter</td>\n                        <td>{{::report.total_amount_payed | currency:\'kr\'}}</td>\n                        <td>{{::report.extra_amount_paid | currency:\'kr\'}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <a href="api/fuel/reports/{{report.id}}/pdf" target="_blank" class="btn btn-info btn-xs"><i class="fa fa-floppy-o fa-fw"></i></a>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(report)" ng-confirm-click="Radera raden?" ng-disabled="!$first">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th>{{type_9196 | sumOfValue:\'monthly_usage\' | number}} liter</th>\n                        <th>{{type_9196 | sumOfValue:\'losses\' | number}} liter</th>\n                        <th>{{(type_9196 | sumOfValue:\'total_amount_payed\') | currency:\'kr\'}}</th>\n                        <th colspan="2">{{(type_9196 | sumOfValue:\'extra_amount_paid\') | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="9" class="text-center">\n                            <dir-pagination-controls pagination-id="f9196" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="AVGAS 100LL">\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover">\n                    <thead>\n                    <tr>\n                        <th>M\xE5nad</th>\n                        <th>M\xE5nadens f\xF6rbrukning</th>\n                        <th>F\xF6rluster</th>\n                        <th>Utbetalat belopp</th>\n                        <th>Varav extra</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr dir-paginate="report in type_100LL = (reports | filter:{fuel_type:1}) | itemsPerPage: 20" pagination-id="f100LL">\n                        <td>{{::report.date | date:\'MMMM\'}}</td>\n                        <td>{{::report.monthly_usage | number}} liter</td>\n                        <td>{{::report.losses || 0 | number}} liter</td>\n                        <td>{{::report.total_amount_payed | currency:\'kr\'}}</td>\n                        <td>{{::report.extra_amount_paid | currency:\'kr\'}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <a href="api/fuel/reports/{{report.id}}/pdf" target="_blank" class="btn btn-info btn-xs"><i class="fa fa-floppy-o fa-fw"></i></a>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(report)" ng-confirm-click="Radera raden?" ng-disabled="!$first">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th>{{type_100LL | sumOfValue:\'monthly_usage\' | number}} liter</th>\n                        <th>{{type_100LL | sumOfValue:\'losses\' | number}} liter</th>\n                        <th>{{(type_100LL | sumOfValue:\'total_amount_payed\') | currency:\'kr\'}}</th>\n                        <th colspan="2">{{(type_100LL | sumOfValue:\'extra_amount_paid\') | currency:\'kr\'}}</th>\n                    </tr>\n                    <tr>\n                        <td colspan="9" class="text-center">\n                            <dir-pagination-controls pagination-id="f100LL" template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/fuel/stats/consumption-by-key.html','<highchart id="chart1" config="chartConfig"></highchart>\n<form class="form-inline" style="border-bottom: 0">\n    <div class="form-group">\n        <label for="startDate" class="sr-only"></label>\n        <input type="date" id="startDate" ng-model-options="{timezone: \'UTC\'}" class="form-control" ng-model="dates.startDate">\n    </div>\n    <div class="form-group">\n        <label for="endDate" class="sr-only"></label>\n        <input type="date" id="endDate" ng-model-options="{timezone: \'UTC\'}" class="form-control" ng-model="dates.endDate">\n    </div>\n    <button type="button" ng-click="update(dates)" class="btn btn-success btn-with-icon">Visa\n    </button>\n    <select class="form-control" ng-model="config.filter" ng-change="filterByType(config.filter)">\n        <option value="-1" selected="selected">Kombinerat</option>\n        <option value="0">91/96 UL</option>\n        <option value="1">100LL</option>\n    </select>\n</form>');
$templateCache.put('app/pages/fuel/stats/consumption-per-month.html','<highchart id="totalConsumption" config="chartConfig"></highchart>\n<form class="form-inline" style="border-bottom: 0">\n    <div class="form-group">\n        <label for="year" class="sr-only"></label>\n        <input type="number" ng-model="year" id="year" min="2000" class="form-control" minlength="4" maxlength="4" max="2038" required>\n    </div>\n    <button type="button" ng-click="update(year)" class="btn btn-success btn-with-icon">Visa\n    </button>\n</form>');
$templateCache.put('app/pages/fuel/stats/consumption-trailing-twelve.html','<highchart id="trailingConsumption" config="chartConfig"></highchart>\n<form class="form-inline" style="border-bottom: 0" name="monthsForm">\n    <div class="form-group">\n        <label for="months" class="sr-only"></label>\n        <input type="number" ng-model="months.m" id="months" min="12" class="form-control" max="3600" required>\n    </div>\n    <button type="button" ng-disabled="monthsForm.$invalid" ng-click="update(months)" class="btn btn-success btn-with-icon">Visa\n    </button>\n</form>');
$templateCache.put('app/pages/fuel/stats/fuel-already-paid.html','<highchart id="fuelAlreadyPaid" config="chartConfig"></highchart>\n<form class="form-inline" style="border-bottom: 0">\n    <div class="form-group">\n        <label for="year" class="sr-only"></label>\n        <input type="number" ng-model="year" id="year" min="2000" class="form-control" minlength="4" maxlength="4" max="2038" required>\n    </div>\n    <button type="button" ng-click="update(year)" class="btn btn-success btn-with-icon">Visa\n    </button>\n</form>');
$templateCache.put('app/pages/fuel/stats/fuel-in-stock.html','<highchart id="fuelInStock" config="chartConfig"></highchart>');
$templateCache.put('app/pages/fuel/stats/stats.html','<div class="row">\n    <div class="col-lg-6 text-center">\n        <div ba-panel>\n            <consumption-by-key></consumption-by-key>\n        </div>\n    </div>\n    <div class="col-lg-6 text-center">\n        <div ba-panel>\n            <consumption-per-month></consumption-per-month>\n        </div>\n    </div>\n</div>\n<div class="row" style="margin-top: 20px">\n    <div class="col-md-12 text-center">\n        <div ba-panel>\n            <consumption-trailing-twelve></consumption-trailing-twelve>\n        </div>\n    </div>\n</div>\n<div class="row" style="margin-top: 20px">\n    <div class="col-md-6 text-center">\n        <div ba-panel>\n            <fuel-already-paid></fuel-already-paid>\n        </div>\n    </div>\n    <div class="col-md-6 text-center">\n        <div ba-panel>\n            <fuel-in-stock></fuel-in-stock>\n        </div>\n    </div>\n</div>\n<div class="row" style="margin-top: 20px">\n    <div class="col-md-12">\n        <div ba-panel>\n            <totalprice></totalprice>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/stats/total-price.html','<highchart id="total-price" config="chartConfig"></highchart>');
$templateCache.put('app/pages/fuel/taxreturn/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad rad inneb\xE4r att det \xE4r samma avl\xE4sning som ligger n\xE4rmast (i tiden) b\xE5de start och slut p\xE5\n        m\xE5naden. Betyder allts\xE5 att det saknas en avl\xE4sning f\xF6r aktuell nyckel eller att den har hamnat p\xE5 fel datum.\n    </div>\n    <div class="alert bg-danger">\n        En r\xF6dmarkerad rad \xE4r en INAKTIV nyckel som \xE4nd\xE5 har f\xF6rbrukning registrerad p\xE5 sig.\n    </div>\n</div>');
$templateCache.put('app/pages/fuel/taxreturn/taxreturn.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="showTax(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <button class="btn btn-primary btn-with-icon" ng-confirm-click="Skicka ut rapport till bokf\xF6ring?" confirmed-click="sendMail()"><i class="fa fa-send"></i> Maila rapport\n        </button>\n    </form>\n    <table class="table table-condensed table-hover">\n        <thead>\n            <tr>\n                <th>M\xE5nad/kvartal</th>\n                <th>Blyfri</th>\n                <th>Annan</th>\n                <th>Att erh\xE5lla</th>\n            </tr>\n        </thead>\n        <tbody ng-repeat="q in [0,3,6,9]">\n            <tr ng-repeat="month in [0+q,1+q,2+q]">\n                <td>{{months[month]}}</td>\n                <td>{{data[month].litres[0] | number:1}} lit. @ {{data[month].tax[0] | currency:\'kr/l\'}}</td>\n                <td>{{data[month].litres[1] | number:1}} lit. @ {{data[month].tax[1] | currency:\'kr/l\'}}</td>\n                <td>{{data[month].litres[0]*data[month].tax[0]+data[month].litres[1]*data[month].tax[1] | currency:\'kr\'}}</td>\n            </tr>\n            <tr>\n                <td><strong>Kvartal {{q/3+1 | number:0}}</strong></td>\n                <td><strong>{{getQuarterLitres(q, 0, data) | number:0}} lit.</strong></td>\n                <td><strong>{{getQuarterLitres(q, 1, data) | number:0}} lit.</strong></td>\n                <td><strong>{{getQuarterAmount(q, data) | currency:\'kr\':0}}</strong></td>\n            </tr>\n        </tbody>\n        <tfoot>\n            \n        </tfoot>\n    </table>\n</div>');
$templateCache.put('app/pages/jour/check/check.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getCheck(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li>\n                    <a href="" ng-confirm-click="Skicka ut debiteringsmeddelanden?" confirmed-click="sendDebitInfo(year)"><i class="fa fa-envelope-o"></i> S\xE4nd ut debiteringsinfo\n                    </a>\n                </li>\n                <li>\n                    <a href="/api/jour/check.csv?year={{year.year}}" target="_blank" ng-confirm-click="Skapa fil f\xF6r debitering i MWL?" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Exportera CSV</a></li>\n                <li>\n                </li><li>\n                    <a href="/api/jour/check.pdf?year={{year.year}}" target="_blank" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a>\n                </li>\n            </ul>\n        </div>\n    </form>\n    <uib-tabset justified="true">\n        <uib-tab>\n            <uib-tab-heading>Ska betala {{data.should_pay.length}} st.</uib-tab-heading>\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dShouldpay" st-safe-src="data.should_pay">\n                    <thead>\n                    <tr>\n                        <th st-sort="name" st-sort-default="true">Medlem</th>\n                        <th st-sort="pilot_nr">Pilotnummer</th>\n                        <th st-sort="total_points">Jourpo\xE4ng</th>\n                        <th st-sort="total_hours">Flygtimmar</th>\n                        <th st-sort="amount">Att betala</th>\n                        <th st-sort="comment">Kommentar</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="member in dShouldpay">\n                        <td>{{::member.name}}</td>\n                        <td>{{::member.pilot_nr}}</td>\n                        <td>{{(member.total_points || 0) | number:0}} st.</td>\n                        <td>{{(member.total_hours || 0) | number:1}} h</td>\n                        <td>{{member.amount | number:0}} kr</td>\n                        <td>{{::member.comment}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="4">Summa</th>\n                        <th colspan="2">{{dShouldpay | sumOfValue:\'amount\' | number:0}} kr</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab>\n            <uib-tab-heading>Ska inte betala {{data.should_not_pay.length}} st.</uib-tab-heading>\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dShouldnotpay" st-safe-src="data.should_not_pay">\n                    <thead>\n                    <tr>\n                        <th st-sort="name" st-sort-default="true">Medlem</th>\n                        <th st-sort="pilot_nr">Pilotnummer</th>\n                        <th st-sort="total_points">Jourpo\xE4ng</th>\n                        <th st-sort="total_hours">Flygtimmar</th>\n                        <th st-sort="comment">Kommentar</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="member in dShouldnotpay">\n                        <td>{{::member.name}}</td>\n                        <td>{{::member.pilot_nr}}</td>\n                        <td>{{(member.total_points || 0) | number:0}} st.</td>\n                        <td>{{(member.total_hours || 0) | number:1}} h</td>\n                        <td>{{::member.comment}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab>\n            <uib-tab-heading>Undantagna {{data.exempted.length}} st.</uib-tab-heading>\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dExempted" st-safe-src="data.exempted">\n                    <thead>\n                    <tr>\n                        <th st-sort="name" st-sort-default="true">Medlem</th>\n                        <th st-sort="pilot_nr">Pilotnummer</th>\n                        <th st-sort="workgroup_id">Arbetsgrupp</th>\n                        <th st-sort="comment">Kommentar</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="member in dExempted">\n                        <td>{{::member.name}}</td>\n                        <td>{{::member.pilot_nr}}</td>\n                        <td>{{::member.workgroup.name}}</td>\n                        <td>{{::member.comment}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/jour/overview/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;\n    </button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <dl>\n        <dt>Synkronisera med MWL</dt>\n        <dd>Tryck h\xE4r f\xF6r att synkronisera medlemstj\xE4nsten (medlemmarna) aktuellt \xE5r med medlemsregistret i MWL <strong>som\n            det ser ut\n            just nu</strong>. De medlemmar som finns i MWL men inte i Toolboxen kommer l\xE4ggas till samt de medlemmar som\n            finns i Toolboxen men inte i MWL kommer tas bort. Medlemmar placeras automatiskt i arbetsgruppen \'Jour\'\n            f\xF6rutom om det \xE4r en ny medlem (baseras p\xE5 att medlemmen inte finns i Toolboxen f\xF6reg\xE5ende \xE5r) eller en\n            medlem som bor utanf\xF6r \xD6sterg\xF6tland (baseras p\xE5 postort angiven i MWL). Emailadresser kommer ocks\xE5\n            uppdateras. <strong>Medlemmar som redan existerar i Toolboxen kommer inte "skrivas \xF6ver".</strong>\n        </dd>\n    </dl>\n    <dl>\n        <dt>F\xF6rdela \'Jour\' enligt f\xF6reg\xE5ende \xE5r</dt>\n        <dd>Tryck h\xE4r f\xF6r att automatiskt f\xF6rdela in alla medlemmar som aktuellt \xE5r ing\xE5r i arbetsgruppen \'Jour\' i samma\n            arbetsgrupp som de ingick i f\xF6reg\xE5ende \xE5r. Baseras p\xE5 namnet p\xE5 arbetsgruppen och kr\xE4ver att arbetsgrupperna\n            aktuellt \xE5r redan \xE4r inlagda (det l\xE4ggs inte till nya arbetsgrupper). En medlem som f\xF6reg\xE5ende \xE5r ingick i\n            gruppen \'Undantag\' med kommentaren \'Ny medlem\' kommer dock inte flyttas fr\xE5n gruppen \'Jour\'. <strong>Allts\xE5\n                viktigt att nya medlemmar f\xE5r kommentaren \'Ny medlem\' i gruppen \'Undantag\' och inget annat.</strong>\n        </dd>\n    </dl>\n    <dl>\n        <dt>S\xE4nd ut instruktionsmail</dt>\n        <dd>Tryck h\xE4r f\xF6r att skicka ut instruktionsmail till samtliga medlemmar. I mailet framg\xE5r om medlemmen\n            f\xF6rv\xE4ntas g\xF6ra jour, kostnad f\xF6r att \'betala sig loss\' etc.\n        </dd>\n    </dl>\n</div>');
$templateCache.put('app/pages/jour/overview/member.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Redigera {{member.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="memberForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : memberForm.pilot_nr.$invalid && !memberForm.pilot_nr.$pristine}">\n        <div class="form-group" ng-class="{\'has-error\' : memberForm.name.$invalid && !memberForm.name.$pristine}">\n            <label for="comment">Kommentar</label>\n            <input id="comment" name="comment" class="form-control" type="text" ng-model="member.comment">\n        </div>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : memberForm.email.$invalid && !memberForm.email.$pristine}">\n            <label for="email">Email</label>\n            <input type="email" name="email" class="form-control" id="email" ng-model="member.email">\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(member)" ng-disabled="memberForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/jour/overview/overview.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getOverview(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li>\n                    <a href="" ng-confirm-click="Vill du verkligen synkronisera medlemstj\xE4nsten aktuellt \xE5r mot dagens MWL-medlemsregister?" confirmed-click="sync(year)"><i class="fa fa-refresh"></i> Synkronisera med MWL\n                    </a>\n                </li>\n                <li>\n                    <a href="" ng-confirm-click="Medlemmar i gruppen \'Jour\' kommer nu f\xF6rdelas in i den arbetsgrupp de tillh\xF6rde f\xF6reg\xE5ende \xE5r, forts\xE4tt?" confirmed-click="transferJourFromPrev(year)"><i class="fa fa-arrow-right"></i> F\xF6rdela \'Jour\'\n                        enligt f\xF6reg\xE5ende \xE5r\n                    </a>\n                </li>\n                <li>\n                    <a href="" ng-confirm-click="Skicka ut instruktionsmail ang\xE5ende medlemstj\xE4nst f\xF6r aktuellt \xE5r?" confirmed-click="sendInformation(year)"><i class="fa fa-envelope-o"></i> S\xE4nd ut instruktionsmail\n                    </a>\n                </li>\n                <li>\n                    <a href="/api/jour/overview.pdf?year={{year.year}}" target="_blank" class="text-center"><i class="fa fa-floppy-o fa-fw"></i> Skapa PDF</a></li>\n            </ul>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <uib-tabset justified="true" active="activeTab.act">\n        <uib-tab index="$index" ng-repeat="(name, group) in data">\n            <uib-tab-heading>{{::name}} ({{::group.length}} st.)</uib-tab-heading>\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dMembers" st-safe-src="group">\n                    <thead>\n                    <tr>\n                        <th st-sort="name" st-sort-default="true">Medlem</th>\n                        <th st-sort="pilot_nr">Pilotnummer</th>\n                        <th st-sort="membership">Typ av medlem</th>\n                        <th st-sort="comment">Kommentar</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="member in dMembers">\n                        <td>{{::member.name}}</td>\n                        <td>{{::member.pilot_nr}}</td>\n                        <td>{{::member.membership}}</td>\n                        <td>{{::member.comment}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <div class="btn-group" uib-dropdown>\n                                    <button id="button" type="button" class="btn btn-primary btn-xs" uib-dropdown-toggle>\n                                        Flytta <span class="caret"></span>\n                                    </button>\n                                    <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu" aria-labelledby="button">\n                                        <li ng-repeat="wgroup in workGroups" role="menuitem">\n                                            <a href="#" ng-click="assignToNewGroup(member, wgroup)">{{wgroup.name}}</a>\n                                        </li>\n                                    </ul>\n                                </div>\n                                <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(member)">\n                                    <i class="fa fa-pencil fa-fw"></i>\n                                </button>\n                                <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(member)" ng-confirm-click="Radera {{member.name}}?">\n                                    <i class="fa fa-times fa-fw"></i>\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/jour/signs/sign.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny signering\' : \'Redigera signering\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="signForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : signForm.pilot_nr.$invalid && !signForm.pilot_nr.$pristine}">\n            <label for="pilot_nr">Pilotnummer</label>\n            <input id="pilot_nr" name="pilot_nr" class="form-control" type="number" ng-model="sign.pilot_nr" min="1000" max="9999" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : signForm.name.$invalid && !signForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="sign.name" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : signForm.points.$invalid && !signForm.points.$pristine}">\n            <label for="points">Po\xE4ng</label>\n            <input id="points" name="points" class="form-control" type="number" ng-model="sign.points" min="1" max="99" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : signForm.date.$invalid && !signForm.date.$pristine}">\n            <label for="date">Datum</label>\n            <input id="date" name="date" class="form-control" type="date" ng-model-options="{timezone : \'UTC\'}" ng-model="sign.date" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(sign)" ng-disabled="signForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/jour/signs/signs.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" name="startDate" ng-model="dates.startDate" class="form-control" required>\n        </div>\n\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" id="endDate" name="endDate" ng-model="dates.endDate" class="form-control" required>\n        </div>\n\n        <button type="button" class="btn btn-success btn-with-icon" ng-disabled="queryForm.$invalid" ng-click="getSigns(dates)"><i class="fa fa-refresh"></i> Visa\n        </button>\n\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <span class="caret"></span>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" role="menu" uib-dropdown-menu>\n                <li><a href="" ng-click="openModal()" class="text-center"><i class="fa fa-plus"></i> Ny signering</a></li>\n                <li class="divider"></li>\n                <li>\n                    <a target="_blank" class="text-center" ng-href="/api/jour/signs/export.pdf?startDate={{dates.startDate.toISOString()}}&endDate={{dates.endDate.toISOString()}}">\n                        <i class="fa fa-floppy-o fa-fw"></i> Skapa PDF\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dSigns" st-safe-src="signs">\n            <thead>\n            <tr>\n                <th st-sort="pilot_nr">Pilotnummer</th>\n                <th st-sort="name">Namn</th>\n                <th st-sort="points">Po\xE4ng</th>\n                <th st-sort="date" st-sort-default="reverse">Datum</th>\n                <th st-sort="created_at">Registrerad</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="sign in dSigns | itemsPerPage: 20">\n                <td>{{::sign.pilot_nr}}</td>\n                <td>{{::sign.name}}</td>\n                <td>{{::sign.points}} st</td>\n                <td>{{::sign.date | date:\'shortDate\'}}</td>\n                <td>{{::sign.created_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(sign)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(sign)" ng-confirm-click="Radera signeringen?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="6" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/jour/workgroups/workgroup.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;\n    </button>\n    <h4 class="modal-title">{{isNew ? \'Ny arbetsgrupp\' : \'Redigera \' + group.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="groupForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : groupForm.name.$invalid && !groupForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="group.name" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(group)" ng-disabled="groupForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/jour/workgroups/workgroups.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getGroups(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li>\n                    <a href="" ng-click="openModal()"><i class="fa fa-plus"></i> Ny arbetsgrupp\n                    </a>\n                </li>\n                <li>\n                    <a href="" ng-confirm-click="\xD6verf\xF6r arbetsgrupper fr\xE5n f\xF6reg\xE5ende \xE5r till aktuellt \xE5r?" confirmed-click="transferFromPrev(year)"><i class="fa fa-arrow-right"></i> \xD6verf\xF6r fr\xE5n f\xF6reg\xE5ende \xE5r\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dGroups" st-safe-src="workGroups">\n            <thead>\n            <tr>\n                <th st-sort="name" st-sort-default="true">Namn</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="group in dGroups | itemsPerPage: 20">\n                <td>{{::group.name}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(group)" ng-disabled="group.name === \'Jour\' || group.name === \'Undantag\' || group.name === \'Individuell uppgift\'">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(group)" ng-confirm-click="Radera {{group.name}}?" ng-disabled="group.name === \'Jour\' || group.name === \'Undantag\' || group.name === \'Individuell uppgift\'">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="3" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/kiosk/products/product.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny produkt\' : \'Redigera produkt\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="productForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : productForm.name.$invalid && !productForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="product.name" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : productForm.price.$invalid && !productForm.price.$pristine}">\n            <label for="price">Pris</label>\n            <input id="price" name="price" class="form-control" type="number" ng-model="product.price" min="1" max="999" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : productForm.stock.$invalid && !productForm.stock.$pristine}">\n            <label for="stock">Lagersaldo</label>\n            <input id="stock" name="stock" class="form-control" type="number" ng-model="product.stock" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(product)" ng-disabled="productForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/kiosk/products/products.html','<div class="row">\n    <div class="col-md-12" ba-panel>\n        <div class="row text-center">\n            <div class="col-md-12">\n                <form class="form-inline">\n                    <button class="btn btn-primary btn-with-icon btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Ny produkt\n                    </button>\n                </form>\n            </div>\n        </div>\n        <div class="table-responsive">\n            <table class="table table-hover" st-table="dProducts" st-safe-src="products">\n                <thead>\n                <tr>\n                    <th st-sort-default="true" st-sort="name">Namn</th>\n                    <th st-sort="price">Pris</th>\n                    <th st-sort="stock">Lagersaldo</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr dir-paginate="product in dProducts | itemsPerPage: 20">\n                    <td>{{::product.name}}</td>\n                    <td>{{::product.price | currency:\'kr\':0}}</td>\n                    <td>{{::product.stock}} st</td>\n                    <td>\n                        <div class="pull-right">\n                            <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(product)">\n                                <i class="fa fa-pencil fa-fw"></i>\n                            </button>\n                            <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(product)" ng-confirm-click="Radera produkten {{::product.name}}?">\n                                <i class="fa fa-times fa-fw"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <td colspan="4" class="text-center">\n                        <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                    </td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/kiosk/purchases/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad rad \xE4r en rad som \xE4nnu inte exporterats.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad rad \xE4r en rad som har exporterats.\n    </div>\n</div>');
$templateCache.put('app/pages/kiosk/purchases/purchase.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Detaljerad information</h4>\n</div>\n<div class="modal-body">\n    <div>\n        <div class="form-group">\n            <label>Pilotnummer</label>\n\n            <p class="form-control-static">{{purchase.pilot_nr}}</p>\n        </div>\n        <div class="form-group">\n            <label>Belopp</label>\n\n            <p class="form-control-static">{{purchase.amount | currency:\'kr\':0}}</p>\n        </div>\n        <div class="form-group">\n            <label>Kommentar</label>\n\n            <p class="form-control-static">{{purchase.comment}}</p>\n        </div>\n        <div class="form-group">\n            <label>Skapad</label>\n\n            <p class="form-control-static">{{purchase.created_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</p>\n        </div>\n        <div class="form-group">\n            <label>OCR</label>\n\n            <p class="form-control-static">{{purchase.ocr_number}}</p>\n        </div>\n        <div class="form-group">\n            <label>IP-adress</label>\n\n            <p class="form-control-static">{{purchase.ip_address}}</p>\n        </div>\n        <div class="form-group">\n            <label>HTTP-data</label>\n\n            <p class="form-control-static">{{purchase.http_data}}</p>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/kiosk/purchases/purchases.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" id="queryForm" novalidate>\n        <div class="form-group">\n            <label for="startDate" class="sr-only"></label>\n            <input type="date" id="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" name="startDate" ng-model="dates.startDate" max="{{dates.endDate}}" class="form-control" required>\n        </div>\n        <div class="form-group">\n            <label for="endDate" class="sr-only"></label>\n            <input type="date" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" id="endDate" name="endDate" ng-model="dates.endDate" class="form-control" required>\n        </div>\n        <div class="form-group">\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getKiosklist(dates)"><i class="fa fa-refresh"></i> Visa\n            </button>\n            <a target="_blank" href="/api/kiosk/records/export">\n                <button class="btn btn-primary btn-with-icon" type="button" ng-disabled="queryForm.$invalid" ng-confirm-click="Exportera samtliga icke-exporterade rader?" confirmed-click=""><i class="fa fa-floppy-o fa-fw"></i> Skapa CSV\n                </button>\n            </a>\n        </div>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </form>\n    <div class="table-responsive">\n        <table class="table table-condensed table-hover" st-table="dPurchases" st-safe-src="purchases">\n            <thead>\n            <tr>\n                <th>Pilot</th>\n                <th>Kommentar</th>\n                <th>Summa</th>\n                <th>Registrerat</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="purchase in dPurchases | itemsPerPage:20" ng-class="{\'success\' : purchase.exported, \'warning\' : !purchase.exported}">\n                <td>{{::purchase.pilot_nr}}</td>\n                <td>{{::purchase.comment}}</td>\n                <td>{{::purchase.amount | currency:\'kr\':0}}</td>\n                <td>{{::purchase.created_at | date:\'yyyy-MM-dd HH:mm:ss\'}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button class="btn btn-primary btn-xs" type="button" ng-click="showDetails(purchase)">\n                            <i class="fa fa-info fa-fw"></i>\n                        </button>\n                        <button class="btn btn-danger btn-xs" type="button" confirmed-click="delete(purchase)" ng-confirm-click="Radera raden?" ng-disabled="purchase.exported">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="5" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/saab/accounts/account.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Nytt konto\' : \'Redigera konto\'}}</h4>\n</div>\n<div class="modal-body">\n    <form name="accountForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.name.$invalid && !accountForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="account.name" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.pilot_nr.$invalid && !accountForm.pilot_nr.$pristine}">\n            <label for="pilot_nr">Pilotnummer</label>\n            <input id="pilot_nr" name="pilot_nr" class="form-control" type="number" ng-model="account.pilot_nr" min="50000" max="59999" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.hours_per_year.$invalid && !accountForm.hours_per_year.$pristine}">\n            <label for="hours_per_year">Timmar per \xE5r</label>\n            <input id="hours_per_year" name="hours_per_year" class="form-control" type="number" ng-model="account.hours_per_year" min="0" max="99" required>\n        </div>\n        <div class="form-group" ng-class="{\'has-error\' : accountForm.initial_balance.$invalid && !accountForm.initial_balance.$pristine}">\n            <label for="initial_balance">Ing\xE5ende balans</label>\n            <input id="initial_balance" name="initial_balance" class="form-control" type="text" ng-currency min="account.accumulated_payments" ng-model="account.initial_balance" required>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(account)" ng-disabled="accountForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/saab/accounts/accounts.html','<div class="row">\n    <div class="col-md-12" ba-panel>\n        <div class="row text-center">\n            <div class="col-md-12">\n                <form class="form-inline">\n                    <button class="btn btn-primary btn-with-icon btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Nytt konto\n                    </button>\n                </form>\n            </div>\n        </div>\n        <div class="table-responsive">\n            <table class="table table-hover" st-table="dAccounts" st-safe-src="accounts">\n                <thead>\n                <tr>\n                    <th st-sort-default="true" st-sort="name">Namn</th>\n                    <th st-sort="pilot_nr">Pilotnummer</th>\n                    <th st-sort="hours_per_year">Timmar per \xE5r</th>\n                    <th st-sort="initial_balance">Ing\xE5ende balans</th>\n                    <th st-sort="balance">Balans</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr dir-paginate="account in dAccounts | itemsPerPage: 20">\n                    <td>{{::account.name}}</td>\n                    <td>{{::account.pilot_nr}}</td>\n                    <td>{{::account.hours_per_year}} h</td>\n                    <td>{{::account.initial_balance | currency:\'kr\'}}</td>\n                    <td>{{::account.balance | currency:\'kr\'}}</td>\n                    <td>\n                        <div class="pull-right">\n                            <button class="btn btn-primary btn-xs" type="button" ng-disabled="account.payments.length === 0" ng-click="showPayments(account.payments)">\n                                <i class="fa fa-eur fa-fw"></i>\n                            </button>\n                            <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(account)">\n                                <i class="fa fa-pencil fa-fw"></i>\n                            </button>\n                            <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(account)" ng-disabled="account.payments.length !== 0" ng-confirm-click="Radera kontot {{::account.name}}?">\n                                <i class="fa fa-times fa-fw"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <th colspan="3">Summa</th>\n                    <th>{{accounts | sumOfValue:\'initial_balance\' | currency:\'kr\'}}</th>\n                    <th colspan="2">{{accounts | sumOfValue:\'balance\' | currency:\'kr\'}}</th>\n                </tr>\n                <tr>\n                    <td colspan="6" class="text-center">\n                        <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                    </td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/saab/accounts/payments.modal.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" ng-click="close()">&times;</button>\n    <h4 class="modal-title">Nedskrivningar</h4>\n</div>\n<div class="modal-body">\n    <table class="table" st-table="payments">\n        <thead>\n        <tr>\n            <th st-sort="date_of_payment">Bokf\xF6ringsdatum</th>\n            <th st-sort-default="reverse" st-sort="date_of_flight">Flygdatum</th>\n            <th st-sort="flight_time">Flygtid</th>\n            <th st-sort="amount">Belopp</th>\n            <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="payment in payments">\n            <td>{{::payment.date_of_payment | date:\'shortDate\'}}</td>\n            <td>{{::payment.date_of_flight | date:\'shortDate\'}}</td>\n            <td>{{::payment.flight_time}} h</td>\n            <td>{{::payment.amount | currency:\'kr\'}}</td>\n            <td>\n                <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(payment)" ng-confirm-click="Radera betalningen?">\n                    <i class="fa fa-times fa-fw"></i>\n                </button>\n            </td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr>\n            <th colspan="3">Summa</th>\n            <th colspan="2">{{::payments | sumOfValue:\'amount\' | currency:\'kr\'}}</th>\n        </tr>\n        </tfoot>\n    </table>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/saab/invoice/invoice.html','<div ba-panel>\n    <div class="form-inline text-center">\n        <ng-form name="queryForm" novalidate>\n            <div class="form-group">\n                <label for="startDate" class="sr-only"></label>\n                <input type="date" id="startDate" name="startDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" max="{{dates.endDate}}" ng-model="dates.startDate" class="form-control">\n            </div>\n            <div class="form-group">\n                <label for="endDate" class="sr-only"></label>\n                <input type="date" id="endDate" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" min="{{dates.startDate}}" name="endDate" ng-model="dates.endDate" class="form-control">\n            </div>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getInvoice(dates)"><i class="fa fa-refresh"></i> Visa\n            </button>\n        </ng-form>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li>\n                    <form method="post" action="api/saab/invoice.pdf" class="text-center" prompt="invoice.nr" prompt-message="Ange fakturanummer: " target="_blank">\n                        <input type="hidden" name="invoice" value="{{invoice.nr}}">\n                        <input type="hidden" name="sum" value="{{groupInvoice(filterFlights(flights, false))}}">\n                        <input type="hidden" name="flights" value="{{filterFlights(flights, false)}}">\n                        <input type="hidden" name="startDate" value="{{dates.startDate.toISOString()}}">\n                        <input type="hidden" name="endDate" value="{{dates.endDate.toISOString()}}">\n                        <button type="submit" class="btn btn-link btn-with-icon"><i class="fa fa-floppy-o fa-fw"></i> Skapa\n                            fakturaunderlag\n                        </button>\n                    </form>\n                </li>\n                <li>\n                    <form method="post" action="api/saab/order.pdf" class="text-center" target="_blank">\n                        <input type="hidden" name="rows" value="{{groupInvoice(filterFlights(flights, true))}}">\n                        <input type="hidden" name="startDate" value="{{dates.startDate.toISOString()}}">\n                        <input type="hidden" name="endDate" value="{{dates.endDate.toISOString()}}">\n                        <button type="submit" class="btn btn-link btn-with-icon"><i class="fa fa-floppy-o fa-fw"></i> Skapa\n                            bokf\xF6ringsorder\n                        </button>\n                    </form>\n                </li>\n                <li>\n                    <form method="post" action="api/saab/order.sie" class="text-center" prompt="date" prompt-message="Ange bokf\xF6ringsdatum (\xC5\xC5\xC5\xC5-MM-DD)" target="_blank">\n                        <input type="hidden" name="rows" value="{{groupInvoice(filterFlights(flights, true))}}">\n                        <input type="hidden" name="date" value="{{date}}">\n                        <button type="submit" class="btn btn-link btn-with-icon"><i class="fa fa-floppy-o fa-fw"></i> Skapa\n                            SIE\n                        </button>\n                    </form>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <uib-tabset justified="true">\n        <uib-tab heading="Detaljunderlag">\n            <div class="table-responsive">\n                <table class="table table-condensed" st-table="dFlights" st-safe-src="flights">\n                    <thead>\n                    <tr>\n                        <th st-sort="name">Namn (avdelning/kst)</th>\n                        <th st-sort="aircraft">Flygplan</th>\n                        <th st-sort="type">Typ</th>\n                        <th st-sort="date" st-sort-default="reverse">Datum</th>\n                        <th st-sort="tacho">Timmar</th>\n                        <th st-sort="tariff">\xE1-pris</th>\n                        <th st-sort="amount">Summa</th>\n                        <th st-sort="in_order">Bokf. order</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="flight in dFlights" ng-class="{\'bg-warning\' : !!flight.in_order}">\n                        <td>{{::flight.name}}</td>\n                        <td>{{::flight.aircraft}}</td>\n                        <td>{{::flight.type}}</td>\n                        <td>{{::flight.date | date:\'shortDate\'}}</td>\n                        <td>{{::flight.tacho | number:1}} h</td>\n                        <td>{{::flight.tariff | currency}}</td>\n                        <td>{{::flight.amount | currency}}</td>\n                        <td>\n                            <div class="pull-right">\n                                <button type="button" ng-show="balances[flight.pilot_nr] !== undefined && (balances[flight.pilot_nr] !== 0 || !!flight.in_order)" class="btn btn-primary btn-xs btn-with-icon" ng-click="addToOrder(flight)" ng-disabled="balances[flight.pilot_nr] < flight.amount || !!flight.in_order">Ja\n                                </button>\n                                <button type="button" ng-show="balances[flight.pilot_nr] !== undefined && (balances[flight.pilot_nr] !== 0 || !!flight.in_order)" class="btn btn-warning btn-xs btn-with-icon" ng-click="removeFromOrder(flight)" ng-disabled="!flight.in_order">Nej\n                                </button>\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="4">Summa</th>\n                        <th colspan="2">{{to_invoice | sumOfValue:\'tacho\' | number:1}} h</th>\n                        <th colspan="2">{{to_invoice | sumOfValue:\'amount\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="Summering">\n            <div class="table-responsive">\n                <table class="table table-condensed">\n                    <thead>\n                    <tr>\n                        <th>Namn (avdelning/kst)</th>\n                        <th>Timmar</th>\n                        <th>Rader</th>\n                        <th>Belopp</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="row in to_invoice = (flights | filter:{in_order:false}) | groupBy:\'name\' | toArray:true | orderBy:\'$key\'">\n                        <td>{{row.$key}}</td>\n                        <td>{{row | sumOfValue:\'tacho\' | number:1}} h</td>\n                        <td>{{row.length | number:0}} st</td>\n                        <td>{{row | sumOfValue:\'amount\' | currency}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th>{{to_invoice | sumOfValue:\'tacho\' | number:1}} h</th>\n                        <th>{{to_invoice.length}} st</th>\n                        <th>{{to_invoice | sumOfValue:\'amount\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab heading="Bokf\xF6ringsorder">\n            <div class="table-responsive">\n                <table class="table table-condensed">\n                    <thead>\n                    <tr>\n                        <th>Namn (avdelning/kst)</th>\n                        <th>Timmar</th>\n                        <th>Rader</th>\n                        <th>Belopp</th>\n                        <th>Debet</th>\n                        <th>Kredit</th>\n                        <th>Resultatenhet</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="row in (to_order = (flights | filter:{in_order:true})) | groupBy:\'name\' | toArray:true | orderBy:\'$key\'">\n                        <td>{{row.$key}}</td>\n                        <td>{{row | sumOfValue:\'tacho\' | number:1}} h</td>\n                        <td>{{row.length | number:0}} st</td>\n                        <td>{{row | sumOfValue:\'amount\' | currency}}</td>\n                        <td>2430</td>\n                        <td>3102</td>\n                        <td>{{row[0].pilot_nr}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th>{{to_order | sumOfValue:\'tacho\' | number:1}} h</th>\n                        <th>{{to_order.length}} st</th>\n                        <th colspan="4">{{to_order | sumOfValue:\'amount\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/salaries/breakdown/breakdown.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="month" class="sr-only"></label>\n            <input type="month" id="month" ng-model-options="{allowInvalid : true, timezone : \'UTC\'}" name="month" ng-model="month" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getSalaries(month)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <div class="btn-group" uib-dropdown>\n            <button type="button" class="btn btn-primary btn-with-icon"><i class="fa fa-cog"></i> \xC5tg\xE4rd\n            </button>\n            <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-primary" uib-dropdown-toggle>\n                <i class="caret"></i>\n                <span class="sr-only">Split button!</span>\n            </button>\n            <ul class="dropdown-menu" uib-dropdown-menu role="menu">\n                <li><a ng-href="api/salaries/pdf?month={{month.toISOString()}}&instructor={{activeInstructor}}" target="_blank" class="text-center"><i class="fa fa-plus"></i> Skapa PDF</a>\n                </li>\n                <li><a href="" ng-confirm-click="L\xF6neunderlag kommer nu skickas ut till samtliga l\xE4rare med det aktiverat, forts\xE4tt?" confirmed-click="sendMails(month)" class="text-center"><i class="fa fa-plus"></i> Maila l\xF6neunderlag</a>\n                </li>\n            </ul>\n        </div>\n    </form>\n    <uib-tabset>\n        <uib-tab heading="Sammanst\xE4llning" ng-click="setActive(\'Sammanst\xE4llning\')">\n            <div class="table-responsive" ng-repeat="(name, instructor) in breakdown" ng-if="instructor.flights.length !== 0">\n                <table class="table table-hover table-condensed">\n                    <thead>\n                    <tr><h4>{{::instructor.sends_invoices ? (instructor.has_retired ? name + \' (fakturerar, pension\xE4r)\' : name + \' (fakturerar)\') : name}}</h4></tr>\n                    <tr>\n                        <th style="width: 25%">L\xF6neart</th>\n                        <th style="width: 25%">Antal</th>\n                        <th style="width: 25%">\xE1-pris</th>\n                        <th style="width: 25%">Summa</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="(name, type) in instructor.tariffs" ng-if="type.total !== 0">\n                        <td>{{name}}</td>\n                        <td>{{type.number | number:1}} {{type.unit}}</td>\n                        <td>{{type.total/type.number | number:2}} kr/{{type.unit}}</td>\n                        <td>{{type.total | currency}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th>Summa</th>\n                        <th colspan="2">{{getTotals(objToArray(instructor.tariffs))}}</th>\n                        <th>{{objToArray(instructor.tariffs) | sumOfValue:\'total\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n        <uib-tab ng-repeat="(name, instructor) in breakdown" ng-if="instructor.flights.length !== 0" ng-click="setActive(name)">\n            <uib-tab-heading>{{::name}}</uib-tab-heading>\n            <div class="table-responsive">\n                <table class="table table-condensed table-hover" st-table="dFlights" st-safe-src="instructor.flights">\n                    <thead>\n                    <tr>\n                        <th st-sort="flightDate" st-sort-default="true">Datum</th>\n                        <th st-sort="regnr">Flygplan</th>\n                        <th st-sort="flightUserFullname">Elev</th>\n                        <th st-sort="tachTotal">Tacho</th>\n                        <th st-sort="tariff.name">L\xF6neart</th>\n                        <th st-sort="tariff.tariff">\xE1-pris</th>\n                        <th st-sort="extraTariff.name">Extra l\xF6neart</th>\n                        <th st-sort="extraTariff.tariff">\xE1-pris</th>\n                        <th st-sort="flight.total">Summa</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr ng-repeat="flight in dFlights">\n                        <td>{{::flight.flightDate | date:\'shortDate\'}}</td>\n                        <td>{{::flight.regnr}}</td>\n                        <td>{{::flight.flightUserFullname}}</td>\n                        <td>{{::flight.tachTotal | number:1}} h</td>\n                        <td>{{::flight.tariff.name}}</td>\n                        <td>{{::flight.tariff.tariff | number:2}} kr/h</td>\n                        <td>{{::flight.extraTariff.name || \'-\'}}</td>\n                        <td>{{getExtraTariffAPrice(flight)}}</td>\n                        <td>{{flight.total = flight.tariff.tariff*flight.tachTotal + flight.extraTariff.tariff | currency}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <th colspan="3">Summa</th>\n                        <th colspan="5">{{instructor.flights | sumOfValue:\'tachTotal\' | number:1}} h</th>\n                        <th>{{instructor.flights | sumOfValue:\'total\' | currency}}</th>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/pages/salaries/breakdown/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> F\xF6rklaring</span>\n</div>\n<div class="modal-body">\n    <div class="alert bg-warning">\n        En gulmarkerad flygning \xE4r en flygning som \xE4nnu inte exporterats/l\xE5sts.\n    </div>\n    <div class="alert bg-success">\n        En gr\xF6nmarkerad flygning \xE4r en flygning som har exporterats/l\xE5sts.\n    </div>\n</div>');
$templateCache.put('app/pages/salaries/flightTypes/flightType.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny typ av flygning\' : \'Redigera \' + type.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="typeForm" novalidate>\n        <div class="form-group" ng-class="{\'has-error\' : typeForm.name.$invalid && !typeForm.name.$pristine}">\n            <label for="name">Namn</label>\n            <input id="name" name="name" class="form-control" type="text" ng-model="type.name" required>\n        </div>\n        <div class="row">\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : typeForm.tariff.$invalid && !typeForm.tariff.$pristine}">\n                <label for="tariff">L\xF6neart</label>\n                <select id="tariff" class="form-control" ng-model="type.tariff" ng-options="tariff as tariff.name for tariff in tariffs | filter:{is_single_type:0} track by tariff.id">\n                    <option value="">V\xE4lj l\xF6neart</option>\n                </select>\n            </div>\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : typeForm.extra_tariff.$invalid && !typeForm.extra_tariff.$pristine}">\n                <label for="extra_tariff">Extra l\xF6neart</label>\n                <select id="extra_tariff" class="form-control" ng-model="type.extra_tariff" ng-options="extra_tariff as extra_tariff.name for extra_tariff in tariffs | filter:{is_single_type:1} track by extra_tariff.id">\n                    <option value="">V\xE4lj extra l\xF6neart</option>\n                </select>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(type)" ng-disabled="typeForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/salaries/flightTypes/flightTypes.html','<div ba-panel>\n    <div class="form-inline text-center">\n        <button class="btn btn-primary btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Ny typ av flygning\n        </button>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dTypes" st-safe-src="flightTypes">\n            <thead>\n            <tr>\n                <th st-sort="name" st-sort-default="true">Namn</th>\n                <th st-sort="tariff.name">L\xF6neart</th>\n                <th st-sort="extra_tariff.name">Extra l\xF6neart</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="type in dTypes | itemsPerPage: 20">\n                <td>{{::type.name}}</td>\n                <td>{{::type.tariff.name}}</td>\n                <td>{{::type.extra_tariff.name}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" class="btn btn-primary btn-xs" ng-click="openModal(type)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" class="btn btn-danger btn-xs" confirmed-click="delete(type)" ng-confirm-click="Radera {{type.name}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="4" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/salaries/instructors/instructor.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny instrukt\xF6r\' : \'Redigera \' + instructor.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="instructorForm" novalidate>\n        <div class="row">\n            <div class="form-group col-sm-9" ng-class="{\'has-error\' : instructorForm.name.$invalid && !instructorForm.name.$pristine}">\n                <label for="name">Namn</label>\n                <input id="name" name="name" class="form-control" type="text" ng-model="instructor.name" required>\n            </div>\n            <div class="form-group col-sm-3" ng-class="{\'has-error\' : instructorForm.short.$invalid && !instructorForm.short.$pristine}">\n                <label for="short">F\xF6rkortning</label>\n                <input id="short" name="short" class="form-control" type="text" ng-model="instructor.short" maxlength="3" required>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : instructorForm.born.$invalid && !instructorForm.born.$pristine}">\n                <label for="born">F\xF6delsedag</label>\n                <input type="date" ng-model-options="{timezone:\'UTC\'}" class="form-control" ng-model="instructor.born" required name="born" id="born">\n            </div>\n            <div class="form-group col-md-6" ng-class="{\'has-error\' : instructorForm.email.$invalid && instructorForm.email.$pristine}">\n                <label for="email">Email</label>\n                <input type="email" class="form-control" ng-model="instructor.email" ng-required="instructor.wants_email" name="email" id="email">\n            </div>\n        </div>\n        <div class="text-center">\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="instructor.wants_email" uib-btn-radio="true">Mailutskick p\xE5</label>\n                <label class="btn btn-primary" ng-model="instructor.wants_email" uib-btn-radio="false">Mailutskick av</label>\n            </div>\n            <div class="btn-group">\n                <label class="btn btn-primary" ng-model="instructor.sends_invoices" uib-btn-radio="true">Fakturerar</label>\n                <label class="btn btn-primary" ng-model="instructor.sends_invoices" uib-btn-radio="false">L\xF6n</label>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(instructor)" ng-disabled="instructorForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/salaries/instructors/instructors.html','<div ba-panel>\n    <div class="form-inline text-center">\n        <button type="button" class="btn btn-warning btn-with-icon" ng-model="filter.showDeleted" uib-btn-checkbox>\n            <i ng-class="{\'fa fa-eye\' : !filter.showDeleted, \'fa fa-eye-slash\' : filter.showDeleted}"></i>\n            {{filter.showDeleted ? \'D\xF6lj raderade\' : \'Visa raderade\'}}\n        </button>\n        <button class="btn btn-primary btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Ny instrukt\xF6r\n        </button>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dInstructors" st-safe-src="instructors">\n            <thead>\n            <tr>\n                <th st-sort="name" st-sort-default="true">Namn</th>\n                <th st-sort="short">F\xF6rkortning</th>\n                <th st-sort="born">F\xF6delsedag</th>\n                <th st-sort="email">Email</th>\n                <th st-sort="wants_email">Utskick</th>\n                <th st-sort="sends_invoices">Fakturerar</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="instructor in dInstructors | filter:showDel | itemsPerPage: 20">\n                <td>{{::instructor.name}}</td>\n                <td>{{::instructor.short}}</td>\n                <td>{{::instructor.born | date:\'yyyy-MM-dd\'}}</td>\n                <td>{{::instructor.email}}</td>\n                <td>{{::instructor.wants_email ? \'Ja\' : \'Nej\'}}</td>\n                <td>{{::instructor.sends_invoices ? \'Ja\' : \'Nej\'}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" ng-show="instructor.deleted_at == null" class="btn btn-primary btn-xs" ng-click="openModal(instructor)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" ng-show="instructor.deleted_at == null" class="btn btn-danger btn-xs" confirmed-click="delete(instructor)" ng-confirm-click="Radera {{instructor.name}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                        <button type="button" ng-hide="instructor.deleted_at == null" class="btn btn-warning btn-xs" confirmed-click="restore(instructor)" ng-confirm-click="\xC5terst\xE4lla {{instructor.name}}?">\xC5terst\xE4ll\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="7" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/salaries/tariffs/info.modal.html','<div class="modal-header bg-info">\n    <button type="button" class="close" data-dismiss="modal" ng-click="$dismiss()">&times;</button>\n    <i class="fa fa-question-circle"></i> <span> Hj\xE4lp</span>\n</div>\n<div class="modal-body">\n    <p>\n        <strong>Tariff: </strong>Ange tariff (oftast timl\xF6n) f\xF6r aktuell l\xF6netyp. Bruttotariff ska anges exklusive\n        semesterers\xE4ttning och liknande.\n    </p>\n    <p>\n        <strong>Tariff (helg): </strong>Ange tariff f\xF6r helgskolning.\n    </p>\n    <p>\n        <strong>Tariff faktura: </strong>Ange tariff f\xF6r de l\xE4rare som fakturerar. Ska anges exklusive moms. R\xE4knas\n        normalt ut som timl\xF6nen * arbetsgivaravgift * semesterers\xE4ttning / moms. Exempel: timl\xF6n * 1,3142 * 1,12 / 1,25.\n    </p>\n    <p>\n        <strong>Tariff faktura (helg): </strong>Ange tariff f\xF6r helgskolning.\n    </p>\n    <p>\n        <strong>Tariff faktura (pension\xE4r): </strong>Ange tariff f\xF6r de l\xE4rare som fakturerar och \xE4r pension\xE4r. Ska anges exklusive moms. R\xE4knas\n        normalt ut som timl\xF6nen * arbetsgivaravgift f\xF6r pension\xE4rer * semesterers\xE4ttning / moms. Exempel: timl\xF6n * 1,1636 * 1,12 / 1,25.\n    </p>\n    <p>\n        <strong>Tariff faktura (pension\xE4r) (helg): </strong>Ange tariff f\xF6r helgskolning.\n    </p>\n</div>');
$templateCache.put('app/pages/salaries/tariffs/tariff.modal.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="close()">&times;</button>\n    <h4 class="modal-title">{{isNew ? \'Ny l\xF6neart\' : \'Redigera \' + tariff.name}}</h4>\n</div>\n<div class="modal-body">\n    <form name="tariffForm" novalidate>\n        <div class="row">\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.name.$invalid && !tariffForm.name.$pristine}">\n                <label for="name">Namn</label>\n                <input id="name" name="name" class="form-control" type="text" ng-model="tariff.name" required>\n            </div>\n            <div class="form-group col-sm-6">\n                <label for="type">Typ</label>\n                <select id="type" class="form-control" ng-model="tariff.is_single_type" required convert-to-number>\n                    <option value="0" selected="selected">kr/h</option>\n                    <option value="1">kr/st</option>\n                </select>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.tariff.$invalid && !tariffForm.tariff.$pristine}">\n                <label for="tariff">Tariff</label>\n                <input id="tariff" name="tariff" class="form-control" type="text" ng-currency ng-model="tariff.tariff" required>\n            </div>\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.tariff_weekend.$invalid && !tariffForm.tariff_weekend.$pristine}">\n                <label for="tariff_weekend">Tariff (helg)</label>\n                <input id="tariff_weekend" name="tariff_weekend" class="form-control" type="text" ng-currency ng-model="tariff.tariff_weekend" required>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.tariff_invoice.$invalid && !tariffForm.tariff_invoice.$pristine}">\n                <label for="tariff_invoice">Tariff faktura</label>\n                <input id="tariff_invoice" name="tariff_invoice" class="form-control" type="text" ng-currency ng-model="tariff.tariff_invoice" required>\n            </div>\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.tariff_invoice_weekend.$invalid && !tariffForm.tariff_invoice_weekend.$pristine}">\n                <label for="tariff_invoice_weekend">Tariff faktura (helg)</label>\n                <input id="tariff_invoice_weekend" name="tariff_invoice_weekend" class="form-control" type="text" ng-currency ng-model="tariff.tariff_invoice_weekend" required>\n            </div>\n        </div>\n        <div class="row">\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.tariff_invoice_retired.$invalid && !tariffForm.tariff_invoice_retired.$pristine}">\n                <label for="tariff_invoice_retired">Tariff faktura (pension\xE4r)</label>\n                <input id="tariff_invoice_retired" name="tariff_invoice_retired" class="form-control" type="text" ng-currency ng-model="tariff.tariff_invoice_retired" required>\n            </div>\n            <div class="form-group col-sm-6" ng-class="{\'has-error\' : tariffForm.tariff_invoice_retired_weekend.$invalid && !tariffForm.tariff_invoice_retired_weekend.$pristine}">\n                <label for="tariff_invoice_retired_weekend">Tariff faktura (pension\xE4r) (helg)</label>\n                <input id="tariff_invoice_retired_weekend" name="tariff_invoice_retired_weekend" class="form-control" type="text" ng-currency ng-model="tariff.tariff_invoice_retired_weekend" required>\n            </div>\n        </div>\n    </form>\n</div>\n<div class="modal-footer">\n    <div class="text-center">\n        <button type="button" class="btn btn-primary" ng-click="save(tariff)" ng-disabled="tariffForm.$invalid">Spara\n        </button>\n        <button type="button" class="btn btn-default" ng-click="close()">St\xE4ng\n        </button>\n    </div>\n</div>');
$templateCache.put('app/pages/salaries/tariffs/tariffs.html','<div ba-panel>\n    <div class="form-inline text-center">\n        <button class="btn btn-primary btn-with-icon" type="button" ng-click="openModal()"><i class="fa fa-plus"></i> Ny l\xF6neart\n        </button>\n        <div class="pull-right">\n            <i class="fa fa-question-circle fa-2x" ng-click="openInfoModal()"></i>\n        </div>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-hover" st-table="dTariffs" st-safe-src="tariffs">\n            <thead>\n            <tr>\n                <th st-sort="name" st-sort-default="true">Namn</th>\n                <th st-sort="tariff">Tariff</th>\n                <th st-sort="tariff_weekend">Tariff (helg)</th>\n                <th st-sort="tariff_invoice">Tariff faktura</th>\n                <th st-sort="tariff_invoice_weekend">Tariff faktura (helg)</th>\n                <th st-sort="tariff_invoice_retired">Tariff faktura (pension\xE4r)</th>\n                <th st-sort="tariff_invoice_retired_weekend">Tariff faktura (pension\xE4r) (helg)</th>\n                <th st-sort="unit">Enhet</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr dir-paginate="tariff in dTariffs | filter:showDel | itemsPerPage: 20">\n                <td>{{::tariff.name}}</td>\n                <td>{{::tariff.tariff | number:2}}</td>\n                <td>{{::tariff.tariff_weekend | number:2}}</td>\n                <td>{{::tariff.tariff_invoice | number:2}}</td>\n                <td>{{::tariff.tariff_invoice_weekend | number:2}}</td>\n                <td>{{::tariff.tariff_invoice_retired | number:2}}</td>\n                <td>{{::tariff.tariff_invoice_retired_weekend | number:2}}</td>\n                <td>{{::tariff.unit}}</td>\n                <td>\n                    <div class="pull-right">\n                        <button type="button" ng-show="tariff.deleted_at == null" class="btn btn-primary btn-xs" ng-click="openModal(tariff)">\n                            <i class="fa fa-pencil fa-fw"></i>\n                        </button>\n                        <button type="button" ng-show="tariff.deleted_at == null" class="btn btn-danger btn-xs" confirmed-click="delete(tariff)" ng-confirm-click="Radera {{tariff.name}}?">\n                            <i class="fa fa-times fa-fw"></i>\n                        </button>\n                        <button type="button" ng-hide="tariff.deleted_at == null" class="btn btn-warning btn-xs" confirmed-click="restore(tariff)" ng-confirm-click="\xC5terst\xE4lla {{tariff.name}}?">\xC5terst\xE4ll\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td colspan="9" class="text-center">\n                    <dir-pagination-controls template-url="app/commons/partials/dirPagination.tpl.html"></dir-pagination-controls>\n                </td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/pages/stats/flightcodestats/flightcodestats.html','<div ba-panel>\n    <form class="form-inline text-center no-print" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getStats(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n        <button type="button" ng-if="data" class="btn btn-default btn-with-icon no-print" ng-click="print()"><i class="fa fa-print"></i> Skriv ut\n        </button>\n    </form>\n\n    <!-- Data Table -->\n    <div class="table-responsive" style="margin-top: 20px;" ng-if="data">\n        <table class="table table-hover table-condensed">\n            <thead>\n            <tr>\n                <th></th>\n                <th ng-repeat="m in months">{{m}}</th>\n                <th>Summa</th>\n                <th>Budget<br>period</th>\n                <th>Budget<br>\xE5r</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="row in data.rows">\n                <td><strong>{{row.kod}}</strong></td>\n                <td ng-repeat="val in row.cells track by $index" ng-class="{\'text-bold\': $index === 12}">{{val | number: ($index >= 13 ? 0 : 1)}}</td>\n            </tr>\n            </tbody>\n            <tfoot>\n            <tr>\n                <td><strong>Summa</strong></td>\n                <td ng-repeat="val in data.summaRow track by $index"><strong>{{val > 0 ? (val | number: ($index >= 13 ? 0 : 1)) : \'\'}}</strong></td>\n            </tr>\n            <tr>\n                <td><strong>Ack.</strong></td>\n                <td ng-repeat="val in data.accRow track by $index">{{val !== null ? (val | number:1) : \'\'}}</td>\n            </tr>\n            <tr>\n                <td><strong>Budget</strong></td>\n                <td ng-repeat="val in data.budgetAccRow track by $index">{{val !== null ? (val | number:1) : \'\'}}</td>\n            </tr>\n            <tr>\n                <td><strong>Ack. {{data.prevYear}}</strong></td>\n                <td ng-repeat="val in data.prevYearAccRow track by $index">{{val !== null ? (val | number:1) : \'\'}}</td>\n            </tr>\n            </tfoot>\n        </table>\n    </div>\n\n    <!-- Charts -->\n    <div ng-if="data" class="charts-container print-page-break" style="margin-top: 30px;">\n        <div class="row">\n            <div class="col-md-6">\n                <highchart id="lineChart" config="lineChartConfig"></highchart>\n            </div>\n            <div class="col-md-6">\n                <highchart id="barChart" config="barChartConfig"></highchart>\n            </div>\n        </div>\n\n        <div class="row" style="margin-top: 20px;">\n            <div class="col-md-6">\n                <highchart id="pieFlygkod" config="pieFlygkodConfig"></highchart>\n            </div>\n            <div class="col-md-6">\n                <highchart id="pieAircraft" config="pieAircraftConfig"></highchart>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/pages/stats/flighthours/flighthours.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getFlightHours(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n    </form>\n    <table class="table table-hover">\n        <thead>\n        <tr>\n            <th>Flygplan</th>\n            <th ng-repeat="cat in categories">{{cat}}</th>\n            <th>Totalt</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat="(aircraft, row) in data">\n            <td>{{aircraft}}</td>\n            <td ng-repeat="cat in categories">{{row[cat].hours | number:1}} h / {{row[cat].flights}} st</td>\n            <td><strong>{{calculateRowTotal(row, \'hours\') | number:1}} h / {{calculateRowTotal(row, \'flights\')}} st</strong></td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr>\n            <td><strong>Totalt</strong></td>\n            <td ng-repeat="cat in categories"><strong>{{calculateColumnTotal(cat, \'hours\') | number:1}} h / {{calculateColumnTotal(cat, \'flights\')}} st</strong></td>\n            <td><strong>{{calculateGrandTotal(\'hours\') | number:1}} h / {{calculateGrandTotal(\'flights\')}} st</strong></td>\n        </tr>\n        </tfoot>\n    </table>\n</div>\n');
$templateCache.put('app/pages/stats/landings/landings.html','<div ba-panel>\n    <form class="form-inline text-center" name="queryForm" novalidate>\n        <div class="form-group">\n            <label for="year" class="sr-only"></label>\n            <input type="number" minlength="4" maxlength="4" min="2000" id="year" name="year" ng-model="year.year" class="form-control">\n        </div>\n        <button type="button" ng-disabled="queryForm.$invalid" class="btn btn-success btn-with-icon" ng-click="getLandings(year)"><i class="fa fa-refresh"></i> Visa\n        </button>\n    </form>\n    <uib-tabset active="activeTab.act">\n        <uib-tab index="$index" ng-repeat="(aircraft, data_ac) in data">\n            <uib-tab-heading>{{::aircraft}}</uib-tab-heading>\n            <table class="table table-condensed table-hover">\n                <thead>\n                <tr>\n                    <th colspan="5" class="text-center"><h3>Totalt: {{calculateTotal(data_ac)}} st</h3></th>\n                </tr>\n                <tr>\n                    <th></th>\n                    <th>Start</th>\n                    <th>Landning</th>\n                    <th>TGL</th>\n                    <th>Antal r\xF6relser</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat-start="month in data_ac">\n                    <td colspan="5"><strong><u>{{::months[$index]}}</u></strong></td>\n                </tr>\n                <tr>\n                    <td><strong>Dag 06-18</strong></td>\n                    <td>{{::month.takeoff_day}} st</td>\n                    <td>{{::month.landing_day}} st</td>\n                    <td>{{::month.tgl_day}} st</td>\n                    <td>{{month.takeoff_day + month.landing_day + 2*month.tgl_day}} st</td>\n                </tr>\n                <tr>\n                    <td><strong>Kv\xE4ll 18-22</strong></td>\n                    <td>{{::month.takeoff_evening}} st</td>\n                    <td>{{::month.landing_evening}} st</td>\n                    <td>{{::month.tgl_evening}} st</td>\n                    <td>{{month.takeoff_evening + month.landing_evening + 2*month.tgl_evening}} st</td>\n                </tr>\n                <tr ng-repeat-end>\n                    <td><strong>Natt 22-06</strong></td>\n                    <td>{{::month.takeoff_night}} st</td>\n                    <td>{{::month.landing_night}} st</td>\n                    <td>{{::month.tgl_night}} st</td>\n                    <td>{{month.takeoff_night + month.landing_night + 2*month.tgl_night}} st</td>\n                </tr>\n                </tbody>\n            </table>\n        </uib-tab>\n    </uib-tabset>\n</div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop">\n    <ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight">\n        <li ng-repeat="item in ::menuItems | filter:authorizedModules" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item">\n\n            <a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link">\n                <i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span>\n            </a>\n\n            <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler>\n                <i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span>\n                <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b>\n            </a>\n\n            <ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu>\n                <li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item">\n                    <a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span>\n                        <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b>\n                    </a>\n                    <ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu>\n                        <li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected">\n                            <a ng-mouseenter="hoverItem($event, item)" href ng-if="::subSubitem.disabled" class="al-sidebar-list-link">\n                                {{ ::subSubitem.title }}\n                            </a>\n                            <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">\n                                {{::subSubitem.title }}\n                            </a>\n                        </li>\n                    </ul>\n                    <a ng-mouseenter="hoverItem($event, item)" href ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">\n                        {{ ::subitem.title }}\n                    </a>\n                    <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled && !subitem.blank)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">\n                        {{ ::subitem.title}}\n                    </a>\n                    <a ng-mouseenter="hoverItem($event, item)" target="_blank" ng-if="::(!subitem.subMenu && !subitem.disabled && subitem.blank)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">\n                        {{ ::subitem.title}}\n                    </a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n    <div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div>\n</aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard">\n    <div class="ba-wizard-navigation-container">\n        <div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">\n            {{t.title}}\n        </div>\n    </div>\n\n    <div class="progress ba-wizard-progress">\n        <div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}">\n        </div>\n    </div>\n\n    <div class="steps" ng-transclude></div>\n\n    <nav>\n        <ul class="pager ba-wizard-pager">\n            <li class="previous">\n                <button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous\n                </button>\n            </li>\n            <li class="next">\n                <button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button>\n            </li>\n        </ul>\n    </nav>\n</div>\n');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>\n');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix">\n    <h1 class="al-title">{{ activePageTitle }}</h1>\n\n    <ul class="breadcrumb al-breadcrumb">\n        <li>\n            <a href="/dashboard">Hem</a></li>\n        <li>{{ activePageTitle }}</li>\n    </ul>\n</div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}">\n    <a href="/dashboard" class="al-logo clearfix"><span>LFK</span> Toolbox</a>\n    <a href class="collapse-menu-link fa fa-bars" ba-sidebar-toggle-menu></a>\n\n    <div class="user-profile clearfix">\n        <div class="al-user-profile" uib-dropdown>\n            <a uib-dropdown-toggle class="profile-toggle-link">\n                <!--<img ng-src="{{::( \'Nasta\' | profilePicture )}}">-->\n                <i class="fa fa-cogs fa-3x fa-bordered"></i>\n            </a>\n            <ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu>\n                <li><i class="dropdown-arr"></i></li>\n                <li><a href ng-click="openModal()"><i class="fa fa-user"></i>Profil</a></li>\n                <li><a href="/logout" class="signout"><i class="fa fa-power-off"></i>Logga ut</a></li>\n            </ul>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets">\n    <div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}">\n        <div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block">\n            <div ba-panel ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}">\n                <div ng-include="widget.url"></div>\n            </div>\n        </div>\n    </div>\n</div>\n');}]);